/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.gateway = (function() {

    /**
     * Namespace gateway.
     * @exports gateway
     * @namespace
     */
    var gateway = {};

    gateway.core = (function() {

        /**
         * Namespace core.
         * @memberof gateway
         * @namespace
         */
        var core = {};

        core.Daq = (function() {

            /**
             * Properties of a Daq.
             * @memberof gateway.core
             * @interface IDaq
             * @property {string|null} [uuid] Daq uuid
             * @property {string|null} [name] Daq name
             * @property {number|null} [address] Daq address
             * @property {string|null} [serial] Daq serial
             */

            /**
             * Constructs a new Daq.
             * @memberof gateway.core
             * @classdesc Represents a Daq.
             * @implements IDaq
             * @constructor
             * @param {gateway.core.IDaq=} [properties] Properties to set
             */
            function Daq(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Daq uuid.
             * @member {string} uuid
             * @memberof gateway.core.Daq
             * @instance
             */
            Daq.prototype.uuid = "";

            /**
             * Daq name.
             * @member {string} name
             * @memberof gateway.core.Daq
             * @instance
             */
            Daq.prototype.name = "";

            /**
             * Daq address.
             * @member {number|null|undefined} address
             * @memberof gateway.core.Daq
             * @instance
             */
            Daq.prototype.address = null;

            /**
             * Daq serial.
             * @member {string|null|undefined} serial
             * @memberof gateway.core.Daq
             * @instance
             */
            Daq.prototype.serial = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * Daq daqRef.
             * @member {"address"|"serial"|undefined} daqRef
             * @memberof gateway.core.Daq
             * @instance
             */
            Object.defineProperty(Daq.prototype, "daqRef", {
                get: $util.oneOfGetter($oneOfFields = ["address", "serial"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Daq instance using the specified properties.
             * @function create
             * @memberof gateway.core.Daq
             * @static
             * @param {gateway.core.IDaq=} [properties] Properties to set
             * @returns {gateway.core.Daq} Daq instance
             */
            Daq.create = function create(properties) {
                return new Daq(properties);
            };

            /**
             * Encodes the specified Daq message. Does not implicitly {@link gateway.core.Daq.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.Daq
             * @static
             * @param {gateway.core.IDaq} message Daq message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Daq.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.uuid);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.address);
                if (message.serial != null && Object.hasOwnProperty.call(message, "serial"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.serial);
                return writer;
            };

            /**
             * Encodes the specified Daq message, length delimited. Does not implicitly {@link gateway.core.Daq.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.Daq
             * @static
             * @param {gateway.core.IDaq} message Daq message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Daq.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Daq message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.Daq
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.Daq} Daq
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Daq.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.Daq();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.uuid = reader.string();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.address = reader.uint32();
                        break;
                    case 4:
                        message.serial = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Daq message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.Daq
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.Daq} Daq
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Daq.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Daq message.
             * @function verify
             * @memberof gateway.core.Daq
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Daq.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    if (!$util.isString(message.uuid))
                        return "uuid: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.address != null && message.hasOwnProperty("address")) {
                    properties.daqRef = 1;
                    if (!$util.isInteger(message.address))
                        return "address: integer expected";
                }
                if (message.serial != null && message.hasOwnProperty("serial")) {
                    if (properties.daqRef === 1)
                        return "daqRef: multiple values";
                    properties.daqRef = 1;
                    if (!$util.isString(message.serial))
                        return "serial: string expected";
                }
                return null;
            };

            /**
             * Creates a Daq message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.Daq
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.Daq} Daq
             */
            Daq.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.Daq)
                    return object;
                var message = new $root.gateway.core.Daq();
                if (object.uuid != null)
                    message.uuid = String(object.uuid);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.address != null)
                    message.address = object.address >>> 0;
                if (object.serial != null)
                    message.serial = String(object.serial);
                return message;
            };

            /**
             * Creates a plain object from a Daq message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.Daq
             * @static
             * @param {gateway.core.Daq} message Daq
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Daq.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.uuid = "";
                    object.name = "";
                }
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    object.uuid = message.uuid;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.address != null && message.hasOwnProperty("address")) {
                    object.address = message.address;
                    if (options.oneofs)
                        object.daqRef = "address";
                }
                if (message.serial != null && message.hasOwnProperty("serial")) {
                    object.serial = message.serial;
                    if (options.oneofs)
                        object.daqRef = "serial";
                }
                return object;
            };

            /**
             * Converts this Daq to JSON.
             * @function toJSON
             * @memberof gateway.core.Daq
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Daq.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Daq;
        })();

        core.OperatingPower = (function() {

            /**
             * Properties of an OperatingPower.
             * @memberof gateway.core
             * @interface IOperatingPower
             * @property {number|null} [I] OperatingPower I
             * @property {number|null} [V] OperatingPower V
             * @property {number|null} [Power] OperatingPower Power
             * @property {number|Long|null} [AccEnergy] OperatingPower AccEnergy
             */

            /**
             * Constructs a new OperatingPower.
             * @memberof gateway.core
             * @classdesc Represents an OperatingPower.
             * @implements IOperatingPower
             * @constructor
             * @param {gateway.core.IOperatingPower=} [properties] Properties to set
             */
            function OperatingPower(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OperatingPower I.
             * @member {number} I
             * @memberof gateway.core.OperatingPower
             * @instance
             */
            OperatingPower.prototype.I = 0;

            /**
             * OperatingPower V.
             * @member {number} V
             * @memberof gateway.core.OperatingPower
             * @instance
             */
            OperatingPower.prototype.V = 0;

            /**
             * OperatingPower Power.
             * @member {number} Power
             * @memberof gateway.core.OperatingPower
             * @instance
             */
            OperatingPower.prototype.Power = 0;

            /**
             * OperatingPower AccEnergy.
             * @member {number|Long} AccEnergy
             * @memberof gateway.core.OperatingPower
             * @instance
             */
            OperatingPower.prototype.AccEnergy = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new OperatingPower instance using the specified properties.
             * @function create
             * @memberof gateway.core.OperatingPower
             * @static
             * @param {gateway.core.IOperatingPower=} [properties] Properties to set
             * @returns {gateway.core.OperatingPower} OperatingPower instance
             */
            OperatingPower.create = function create(properties) {
                return new OperatingPower(properties);
            };

            /**
             * Encodes the specified OperatingPower message. Does not implicitly {@link gateway.core.OperatingPower.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.OperatingPower
             * @static
             * @param {gateway.core.IOperatingPower} message OperatingPower message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OperatingPower.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.I != null && Object.hasOwnProperty.call(message, "I"))
                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.I);
                if (message.V != null && Object.hasOwnProperty.call(message, "V"))
                    writer.uint32(/* id 2, wireType 5 =*/21).float(message.V);
                if (message.Power != null && Object.hasOwnProperty.call(message, "Power"))
                    writer.uint32(/* id 3, wireType 5 =*/29).float(message.Power);
                if (message.AccEnergy != null && Object.hasOwnProperty.call(message, "AccEnergy"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.AccEnergy);
                return writer;
            };

            /**
             * Encodes the specified OperatingPower message, length delimited. Does not implicitly {@link gateway.core.OperatingPower.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.OperatingPower
             * @static
             * @param {gateway.core.IOperatingPower} message OperatingPower message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OperatingPower.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OperatingPower message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.OperatingPower
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.OperatingPower} OperatingPower
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OperatingPower.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.OperatingPower();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.I = reader.float();
                        break;
                    case 2:
                        message.V = reader.float();
                        break;
                    case 3:
                        message.Power = reader.float();
                        break;
                    case 4:
                        message.AccEnergy = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OperatingPower message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.OperatingPower
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.OperatingPower} OperatingPower
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OperatingPower.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OperatingPower message.
             * @function verify
             * @memberof gateway.core.OperatingPower
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OperatingPower.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.I != null && message.hasOwnProperty("I"))
                    if (typeof message.I !== "number")
                        return "I: number expected";
                if (message.V != null && message.hasOwnProperty("V"))
                    if (typeof message.V !== "number")
                        return "V: number expected";
                if (message.Power != null && message.hasOwnProperty("Power"))
                    if (typeof message.Power !== "number")
                        return "Power: number expected";
                if (message.AccEnergy != null && message.hasOwnProperty("AccEnergy"))
                    if (!$util.isInteger(message.AccEnergy) && !(message.AccEnergy && $util.isInteger(message.AccEnergy.low) && $util.isInteger(message.AccEnergy.high)))
                        return "AccEnergy: integer|Long expected";
                return null;
            };

            /**
             * Creates an OperatingPower message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.OperatingPower
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.OperatingPower} OperatingPower
             */
            OperatingPower.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.OperatingPower)
                    return object;
                var message = new $root.gateway.core.OperatingPower();
                if (object.I != null)
                    message.I = Number(object.I);
                if (object.V != null)
                    message.V = Number(object.V);
                if (object.Power != null)
                    message.Power = Number(object.Power);
                if (object.AccEnergy != null)
                    if ($util.Long)
                        (message.AccEnergy = $util.Long.fromValue(object.AccEnergy)).unsigned = true;
                    else if (typeof object.AccEnergy === "string")
                        message.AccEnergy = parseInt(object.AccEnergy, 10);
                    else if (typeof object.AccEnergy === "number")
                        message.AccEnergy = object.AccEnergy;
                    else if (typeof object.AccEnergy === "object")
                        message.AccEnergy = new $util.LongBits(object.AccEnergy.low >>> 0, object.AccEnergy.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from an OperatingPower message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.OperatingPower
             * @static
             * @param {gateway.core.OperatingPower} message OperatingPower
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OperatingPower.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.I = 0;
                    object.V = 0;
                    object.Power = 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.AccEnergy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.AccEnergy = options.longs === String ? "0" : 0;
                }
                if (message.I != null && message.hasOwnProperty("I"))
                    object.I = options.json && !isFinite(message.I) ? String(message.I) : message.I;
                if (message.V != null && message.hasOwnProperty("V"))
                    object.V = options.json && !isFinite(message.V) ? String(message.V) : message.V;
                if (message.Power != null && message.hasOwnProperty("Power"))
                    object.Power = options.json && !isFinite(message.Power) ? String(message.Power) : message.Power;
                if (message.AccEnergy != null && message.hasOwnProperty("AccEnergy"))
                    if (typeof message.AccEnergy === "number")
                        object.AccEnergy = options.longs === String ? String(message.AccEnergy) : message.AccEnergy;
                    else
                        object.AccEnergy = options.longs === String ? $util.Long.prototype.toString.call(message.AccEnergy) : options.longs === Number ? new $util.LongBits(message.AccEnergy.low >>> 0, message.AccEnergy.high >>> 0).toNumber(true) : message.AccEnergy;
                return object;
            };

            /**
             * Converts this OperatingPower to JSON.
             * @function toJSON
             * @memberof gateway.core.OperatingPower
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OperatingPower.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OperatingPower;
        })();

        core.OperatingPowerMeasurement = (function() {

            /**
             * Properties of an OperatingPowerMeasurement.
             * @memberof gateway.core
             * @interface IOperatingPowerMeasurement
             * @property {google.protobuf.ITimestamp|null} [timestamp] OperatingPowerMeasurement timestamp
             * @property {string|null} [moduleUuid] OperatingPowerMeasurement moduleUuid
             * @property {string|null} [daqUuid] OperatingPowerMeasurement daqUuid
             * @property {gateway.core.IOperatingPower|null} [data] OperatingPowerMeasurement data
             */

            /**
             * Constructs a new OperatingPowerMeasurement.
             * @memberof gateway.core
             * @classdesc Represents an OperatingPowerMeasurement.
             * @implements IOperatingPowerMeasurement
             * @constructor
             * @param {gateway.core.IOperatingPowerMeasurement=} [properties] Properties to set
             */
            function OperatingPowerMeasurement(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OperatingPowerMeasurement timestamp.
             * @member {google.protobuf.ITimestamp|null|undefined} timestamp
             * @memberof gateway.core.OperatingPowerMeasurement
             * @instance
             */
            OperatingPowerMeasurement.prototype.timestamp = null;

            /**
             * OperatingPowerMeasurement moduleUuid.
             * @member {string} moduleUuid
             * @memberof gateway.core.OperatingPowerMeasurement
             * @instance
             */
            OperatingPowerMeasurement.prototype.moduleUuid = "";

            /**
             * OperatingPowerMeasurement daqUuid.
             * @member {string} daqUuid
             * @memberof gateway.core.OperatingPowerMeasurement
             * @instance
             */
            OperatingPowerMeasurement.prototype.daqUuid = "";

            /**
             * OperatingPowerMeasurement data.
             * @member {gateway.core.IOperatingPower|null|undefined} data
             * @memberof gateway.core.OperatingPowerMeasurement
             * @instance
             */
            OperatingPowerMeasurement.prototype.data = null;

            /**
             * Creates a new OperatingPowerMeasurement instance using the specified properties.
             * @function create
             * @memberof gateway.core.OperatingPowerMeasurement
             * @static
             * @param {gateway.core.IOperatingPowerMeasurement=} [properties] Properties to set
             * @returns {gateway.core.OperatingPowerMeasurement} OperatingPowerMeasurement instance
             */
            OperatingPowerMeasurement.create = function create(properties) {
                return new OperatingPowerMeasurement(properties);
            };

            /**
             * Encodes the specified OperatingPowerMeasurement message. Does not implicitly {@link gateway.core.OperatingPowerMeasurement.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.OperatingPowerMeasurement
             * @static
             * @param {gateway.core.IOperatingPowerMeasurement} message OperatingPowerMeasurement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OperatingPowerMeasurement.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.moduleUuid != null && Object.hasOwnProperty.call(message, "moduleUuid"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.moduleUuid);
                if (message.daqUuid != null && Object.hasOwnProperty.call(message, "daqUuid"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.daqUuid);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    $root.gateway.core.OperatingPower.encode(message.data, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OperatingPowerMeasurement message, length delimited. Does not implicitly {@link gateway.core.OperatingPowerMeasurement.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.OperatingPowerMeasurement
             * @static
             * @param {gateway.core.IOperatingPowerMeasurement} message OperatingPowerMeasurement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OperatingPowerMeasurement.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OperatingPowerMeasurement message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.OperatingPowerMeasurement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.OperatingPowerMeasurement} OperatingPowerMeasurement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OperatingPowerMeasurement.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.OperatingPowerMeasurement();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.moduleUuid = reader.string();
                        break;
                    case 3:
                        message.daqUuid = reader.string();
                        break;
                    case 4:
                        message.data = $root.gateway.core.OperatingPower.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OperatingPowerMeasurement message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.OperatingPowerMeasurement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.OperatingPowerMeasurement} OperatingPowerMeasurement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OperatingPowerMeasurement.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OperatingPowerMeasurement message.
             * @function verify
             * @memberof gateway.core.OperatingPowerMeasurement
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OperatingPowerMeasurement.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.timestamp);
                    if (error)
                        return "timestamp." + error;
                }
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    if (!$util.isString(message.moduleUuid))
                        return "moduleUuid: string expected";
                if (message.daqUuid != null && message.hasOwnProperty("daqUuid"))
                    if (!$util.isString(message.daqUuid))
                        return "daqUuid: string expected";
                if (message.data != null && message.hasOwnProperty("data")) {
                    var error = $root.gateway.core.OperatingPower.verify(message.data);
                    if (error)
                        return "data." + error;
                }
                return null;
            };

            /**
             * Creates an OperatingPowerMeasurement message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.OperatingPowerMeasurement
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.OperatingPowerMeasurement} OperatingPowerMeasurement
             */
            OperatingPowerMeasurement.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.OperatingPowerMeasurement)
                    return object;
                var message = new $root.gateway.core.OperatingPowerMeasurement();
                if (object.timestamp != null) {
                    if (typeof object.timestamp !== "object")
                        throw TypeError(".gateway.core.OperatingPowerMeasurement.timestamp: object expected");
                    message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
                }
                if (object.moduleUuid != null)
                    message.moduleUuid = String(object.moduleUuid);
                if (object.daqUuid != null)
                    message.daqUuid = String(object.daqUuid);
                if (object.data != null) {
                    if (typeof object.data !== "object")
                        throw TypeError(".gateway.core.OperatingPowerMeasurement.data: object expected");
                    message.data = $root.gateway.core.OperatingPower.fromObject(object.data);
                }
                return message;
            };

            /**
             * Creates a plain object from an OperatingPowerMeasurement message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.OperatingPowerMeasurement
             * @static
             * @param {gateway.core.OperatingPowerMeasurement} message OperatingPowerMeasurement
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OperatingPowerMeasurement.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.timestamp = null;
                    object.moduleUuid = "";
                    object.daqUuid = "";
                    object.data = null;
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    object.moduleUuid = message.moduleUuid;
                if (message.daqUuid != null && message.hasOwnProperty("daqUuid"))
                    object.daqUuid = message.daqUuid;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = $root.gateway.core.OperatingPower.toObject(message.data, options);
                return object;
            };

            /**
             * Converts this OperatingPowerMeasurement to JSON.
             * @function toJSON
             * @memberof gateway.core.OperatingPowerMeasurement
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OperatingPowerMeasurement.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OperatingPowerMeasurement;
        })();

        core.IvCurve = (function() {

            /**
             * Properties of an IvCurve.
             * @memberof gateway.core
             * @interface IIvCurve
             * @property {Array.<number>|null} [I] IvCurve I
             * @property {Array.<number>|null} [V] IvCurve V
             * @property {number|null} [Imp] IvCurve Imp
             * @property {number|null} [Vmp] IvCurve Vmp
             * @property {number|null} [Pmp] IvCurve Pmp
             * @property {number|null} [Isc] IvCurve Isc
             * @property {number|null} [Voc] IvCurve Voc
             * @property {number|null} [Iop] IvCurve Iop
             * @property {number|null} [Vop] IvCurve Vop
             * @property {number|null} [Pop] IvCurve Pop
             * @property {number|null} [Temperature] IvCurve Temperature
             */

            /**
             * Constructs a new IvCurve.
             * @memberof gateway.core
             * @classdesc Represents an IvCurve.
             * @implements IIvCurve
             * @constructor
             * @param {gateway.core.IIvCurve=} [properties] Properties to set
             */
            function IvCurve(properties) {
                this.I = [];
                this.V = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * IvCurve I.
             * @member {Array.<number>} I
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.I = $util.emptyArray;

            /**
             * IvCurve V.
             * @member {Array.<number>} V
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.V = $util.emptyArray;

            /**
             * IvCurve Imp.
             * @member {number} Imp
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Imp = 0;

            /**
             * IvCurve Vmp.
             * @member {number} Vmp
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Vmp = 0;

            /**
             * IvCurve Pmp.
             * @member {number} Pmp
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Pmp = 0;

            /**
             * IvCurve Isc.
             * @member {number} Isc
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Isc = 0;

            /**
             * IvCurve Voc.
             * @member {number} Voc
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Voc = 0;

            /**
             * IvCurve Iop.
             * @member {number} Iop
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Iop = 0;

            /**
             * IvCurve Vop.
             * @member {number} Vop
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Vop = 0;

            /**
             * IvCurve Pop.
             * @member {number} Pop
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Pop = 0;

            /**
             * IvCurve Temperature.
             * @member {number} Temperature
             * @memberof gateway.core.IvCurve
             * @instance
             */
            IvCurve.prototype.Temperature = 0;

            /**
             * Creates a new IvCurve instance using the specified properties.
             * @function create
             * @memberof gateway.core.IvCurve
             * @static
             * @param {gateway.core.IIvCurve=} [properties] Properties to set
             * @returns {gateway.core.IvCurve} IvCurve instance
             */
            IvCurve.create = function create(properties) {
                return new IvCurve(properties);
            };

            /**
             * Encodes the specified IvCurve message. Does not implicitly {@link gateway.core.IvCurve.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.IvCurve
             * @static
             * @param {gateway.core.IIvCurve} message IvCurve message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IvCurve.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.I != null && message.I.length) {
                    writer.uint32(/* id 1, wireType 2 =*/10).fork();
                    for (var i = 0; i < message.I.length; ++i)
                        writer.float(message.I[i]);
                    writer.ldelim();
                }
                if (message.V != null && message.V.length) {
                    writer.uint32(/* id 2, wireType 2 =*/18).fork();
                    for (var i = 0; i < message.V.length; ++i)
                        writer.float(message.V[i]);
                    writer.ldelim();
                }
                if (message.Imp != null && Object.hasOwnProperty.call(message, "Imp"))
                    writer.uint32(/* id 3, wireType 5 =*/29).float(message.Imp);
                if (message.Vmp != null && Object.hasOwnProperty.call(message, "Vmp"))
                    writer.uint32(/* id 4, wireType 5 =*/37).float(message.Vmp);
                if (message.Pmp != null && Object.hasOwnProperty.call(message, "Pmp"))
                    writer.uint32(/* id 5, wireType 5 =*/45).float(message.Pmp);
                if (message.Isc != null && Object.hasOwnProperty.call(message, "Isc"))
                    writer.uint32(/* id 6, wireType 5 =*/53).float(message.Isc);
                if (message.Voc != null && Object.hasOwnProperty.call(message, "Voc"))
                    writer.uint32(/* id 7, wireType 5 =*/61).float(message.Voc);
                if (message.Iop != null && Object.hasOwnProperty.call(message, "Iop"))
                    writer.uint32(/* id 8, wireType 5 =*/69).float(message.Iop);
                if (message.Vop != null && Object.hasOwnProperty.call(message, "Vop"))
                    writer.uint32(/* id 9, wireType 5 =*/77).float(message.Vop);
                if (message.Pop != null && Object.hasOwnProperty.call(message, "Pop"))
                    writer.uint32(/* id 10, wireType 5 =*/85).float(message.Pop);
                if (message.Temperature != null && Object.hasOwnProperty.call(message, "Temperature"))
                    writer.uint32(/* id 11, wireType 5 =*/93).float(message.Temperature);
                return writer;
            };

            /**
             * Encodes the specified IvCurve message, length delimited. Does not implicitly {@link gateway.core.IvCurve.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.IvCurve
             * @static
             * @param {gateway.core.IIvCurve} message IvCurve message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IvCurve.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an IvCurve message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.IvCurve
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.IvCurve} IvCurve
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IvCurve.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.IvCurve();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.I && message.I.length))
                            message.I = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.I.push(reader.float());
                        } else
                            message.I.push(reader.float());
                        break;
                    case 2:
                        if (!(message.V && message.V.length))
                            message.V = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.V.push(reader.float());
                        } else
                            message.V.push(reader.float());
                        break;
                    case 3:
                        message.Imp = reader.float();
                        break;
                    case 4:
                        message.Vmp = reader.float();
                        break;
                    case 5:
                        message.Pmp = reader.float();
                        break;
                    case 6:
                        message.Isc = reader.float();
                        break;
                    case 7:
                        message.Voc = reader.float();
                        break;
                    case 8:
                        message.Iop = reader.float();
                        break;
                    case 9:
                        message.Vop = reader.float();
                        break;
                    case 10:
                        message.Pop = reader.float();
                        break;
                    case 11:
                        message.Temperature = reader.float();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an IvCurve message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.IvCurve
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.IvCurve} IvCurve
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IvCurve.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an IvCurve message.
             * @function verify
             * @memberof gateway.core.IvCurve
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            IvCurve.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.I != null && message.hasOwnProperty("I")) {
                    if (!Array.isArray(message.I))
                        return "I: array expected";
                    for (var i = 0; i < message.I.length; ++i)
                        if (typeof message.I[i] !== "number")
                            return "I: number[] expected";
                }
                if (message.V != null && message.hasOwnProperty("V")) {
                    if (!Array.isArray(message.V))
                        return "V: array expected";
                    for (var i = 0; i < message.V.length; ++i)
                        if (typeof message.V[i] !== "number")
                            return "V: number[] expected";
                }
                if (message.Imp != null && message.hasOwnProperty("Imp"))
                    if (typeof message.Imp !== "number")
                        return "Imp: number expected";
                if (message.Vmp != null && message.hasOwnProperty("Vmp"))
                    if (typeof message.Vmp !== "number")
                        return "Vmp: number expected";
                if (message.Pmp != null && message.hasOwnProperty("Pmp"))
                    if (typeof message.Pmp !== "number")
                        return "Pmp: number expected";
                if (message.Isc != null && message.hasOwnProperty("Isc"))
                    if (typeof message.Isc !== "number")
                        return "Isc: number expected";
                if (message.Voc != null && message.hasOwnProperty("Voc"))
                    if (typeof message.Voc !== "number")
                        return "Voc: number expected";
                if (message.Iop != null && message.hasOwnProperty("Iop"))
                    if (typeof message.Iop !== "number")
                        return "Iop: number expected";
                if (message.Vop != null && message.hasOwnProperty("Vop"))
                    if (typeof message.Vop !== "number")
                        return "Vop: number expected";
                if (message.Pop != null && message.hasOwnProperty("Pop"))
                    if (typeof message.Pop !== "number")
                        return "Pop: number expected";
                if (message.Temperature != null && message.hasOwnProperty("Temperature"))
                    if (typeof message.Temperature !== "number")
                        return "Temperature: number expected";
                return null;
            };

            /**
             * Creates an IvCurve message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.IvCurve
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.IvCurve} IvCurve
             */
            IvCurve.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.IvCurve)
                    return object;
                var message = new $root.gateway.core.IvCurve();
                if (object.I) {
                    if (!Array.isArray(object.I))
                        throw TypeError(".gateway.core.IvCurve.I: array expected");
                    message.I = [];
                    for (var i = 0; i < object.I.length; ++i)
                        message.I[i] = Number(object.I[i]);
                }
                if (object.V) {
                    if (!Array.isArray(object.V))
                        throw TypeError(".gateway.core.IvCurve.V: array expected");
                    message.V = [];
                    for (var i = 0; i < object.V.length; ++i)
                        message.V[i] = Number(object.V[i]);
                }
                if (object.Imp != null)
                    message.Imp = Number(object.Imp);
                if (object.Vmp != null)
                    message.Vmp = Number(object.Vmp);
                if (object.Pmp != null)
                    message.Pmp = Number(object.Pmp);
                if (object.Isc != null)
                    message.Isc = Number(object.Isc);
                if (object.Voc != null)
                    message.Voc = Number(object.Voc);
                if (object.Iop != null)
                    message.Iop = Number(object.Iop);
                if (object.Vop != null)
                    message.Vop = Number(object.Vop);
                if (object.Pop != null)
                    message.Pop = Number(object.Pop);
                if (object.Temperature != null)
                    message.Temperature = Number(object.Temperature);
                return message;
            };

            /**
             * Creates a plain object from an IvCurve message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.IvCurve
             * @static
             * @param {gateway.core.IvCurve} message IvCurve
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            IvCurve.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.I = [];
                    object.V = [];
                }
                if (options.defaults) {
                    object.Imp = 0;
                    object.Vmp = 0;
                    object.Pmp = 0;
                    object.Isc = 0;
                    object.Voc = 0;
                    object.Iop = 0;
                    object.Vop = 0;
                    object.Pop = 0;
                    object.Temperature = 0;
                }
                if (message.I && message.I.length) {
                    object.I = [];
                    for (var j = 0; j < message.I.length; ++j)
                        object.I[j] = options.json && !isFinite(message.I[j]) ? String(message.I[j]) : message.I[j];
                }
                if (message.V && message.V.length) {
                    object.V = [];
                    for (var j = 0; j < message.V.length; ++j)
                        object.V[j] = options.json && !isFinite(message.V[j]) ? String(message.V[j]) : message.V[j];
                }
                if (message.Imp != null && message.hasOwnProperty("Imp"))
                    object.Imp = options.json && !isFinite(message.Imp) ? String(message.Imp) : message.Imp;
                if (message.Vmp != null && message.hasOwnProperty("Vmp"))
                    object.Vmp = options.json && !isFinite(message.Vmp) ? String(message.Vmp) : message.Vmp;
                if (message.Pmp != null && message.hasOwnProperty("Pmp"))
                    object.Pmp = options.json && !isFinite(message.Pmp) ? String(message.Pmp) : message.Pmp;
                if (message.Isc != null && message.hasOwnProperty("Isc"))
                    object.Isc = options.json && !isFinite(message.Isc) ? String(message.Isc) : message.Isc;
                if (message.Voc != null && message.hasOwnProperty("Voc"))
                    object.Voc = options.json && !isFinite(message.Voc) ? String(message.Voc) : message.Voc;
                if (message.Iop != null && message.hasOwnProperty("Iop"))
                    object.Iop = options.json && !isFinite(message.Iop) ? String(message.Iop) : message.Iop;
                if (message.Vop != null && message.hasOwnProperty("Vop"))
                    object.Vop = options.json && !isFinite(message.Vop) ? String(message.Vop) : message.Vop;
                if (message.Pop != null && message.hasOwnProperty("Pop"))
                    object.Pop = options.json && !isFinite(message.Pop) ? String(message.Pop) : message.Pop;
                if (message.Temperature != null && message.hasOwnProperty("Temperature"))
                    object.Temperature = options.json && !isFinite(message.Temperature) ? String(message.Temperature) : message.Temperature;
                return object;
            };

            /**
             * Converts this IvCurve to JSON.
             * @function toJSON
             * @memberof gateway.core.IvCurve
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            IvCurve.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return IvCurve;
        })();

        core.IvCurveMeasurement = (function() {

            /**
             * Properties of an IvCurveMeasurement.
             * @memberof gateway.core
             * @interface IIvCurveMeasurement
             * @property {google.protobuf.ITimestamp|null} [timestamp] IvCurveMeasurement timestamp
             * @property {string|null} [moduleUuid] IvCurveMeasurement moduleUuid
             * @property {string|null} [daqUuid] IvCurveMeasurement daqUuid
             * @property {gateway.core.IIvCurve|null} [data] IvCurveMeasurement data
             */

            /**
             * Constructs a new IvCurveMeasurement.
             * @memberof gateway.core
             * @classdesc Represents an IvCurveMeasurement.
             * @implements IIvCurveMeasurement
             * @constructor
             * @param {gateway.core.IIvCurveMeasurement=} [properties] Properties to set
             */
            function IvCurveMeasurement(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * IvCurveMeasurement timestamp.
             * @member {google.protobuf.ITimestamp|null|undefined} timestamp
             * @memberof gateway.core.IvCurveMeasurement
             * @instance
             */
            IvCurveMeasurement.prototype.timestamp = null;

            /**
             * IvCurveMeasurement moduleUuid.
             * @member {string} moduleUuid
             * @memberof gateway.core.IvCurveMeasurement
             * @instance
             */
            IvCurveMeasurement.prototype.moduleUuid = "";

            /**
             * IvCurveMeasurement daqUuid.
             * @member {string} daqUuid
             * @memberof gateway.core.IvCurveMeasurement
             * @instance
             */
            IvCurveMeasurement.prototype.daqUuid = "";

            /**
             * IvCurveMeasurement data.
             * @member {gateway.core.IIvCurve|null|undefined} data
             * @memberof gateway.core.IvCurveMeasurement
             * @instance
             */
            IvCurveMeasurement.prototype.data = null;

            /**
             * Creates a new IvCurveMeasurement instance using the specified properties.
             * @function create
             * @memberof gateway.core.IvCurveMeasurement
             * @static
             * @param {gateway.core.IIvCurveMeasurement=} [properties] Properties to set
             * @returns {gateway.core.IvCurveMeasurement} IvCurveMeasurement instance
             */
            IvCurveMeasurement.create = function create(properties) {
                return new IvCurveMeasurement(properties);
            };

            /**
             * Encodes the specified IvCurveMeasurement message. Does not implicitly {@link gateway.core.IvCurveMeasurement.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.IvCurveMeasurement
             * @static
             * @param {gateway.core.IIvCurveMeasurement} message IvCurveMeasurement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IvCurveMeasurement.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.moduleUuid != null && Object.hasOwnProperty.call(message, "moduleUuid"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.moduleUuid);
                if (message.daqUuid != null && Object.hasOwnProperty.call(message, "daqUuid"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.daqUuid);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    $root.gateway.core.IvCurve.encode(message.data, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified IvCurveMeasurement message, length delimited. Does not implicitly {@link gateway.core.IvCurveMeasurement.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.IvCurveMeasurement
             * @static
             * @param {gateway.core.IIvCurveMeasurement} message IvCurveMeasurement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IvCurveMeasurement.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an IvCurveMeasurement message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.IvCurveMeasurement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.IvCurveMeasurement} IvCurveMeasurement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IvCurveMeasurement.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.IvCurveMeasurement();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.moduleUuid = reader.string();
                        break;
                    case 3:
                        message.daqUuid = reader.string();
                        break;
                    case 4:
                        message.data = $root.gateway.core.IvCurve.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an IvCurveMeasurement message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.IvCurveMeasurement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.IvCurveMeasurement} IvCurveMeasurement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IvCurveMeasurement.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an IvCurveMeasurement message.
             * @function verify
             * @memberof gateway.core.IvCurveMeasurement
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            IvCurveMeasurement.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.timestamp);
                    if (error)
                        return "timestamp." + error;
                }
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    if (!$util.isString(message.moduleUuid))
                        return "moduleUuid: string expected";
                if (message.daqUuid != null && message.hasOwnProperty("daqUuid"))
                    if (!$util.isString(message.daqUuid))
                        return "daqUuid: string expected";
                if (message.data != null && message.hasOwnProperty("data")) {
                    var error = $root.gateway.core.IvCurve.verify(message.data);
                    if (error)
                        return "data." + error;
                }
                return null;
            };

            /**
             * Creates an IvCurveMeasurement message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.IvCurveMeasurement
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.IvCurveMeasurement} IvCurveMeasurement
             */
            IvCurveMeasurement.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.IvCurveMeasurement)
                    return object;
                var message = new $root.gateway.core.IvCurveMeasurement();
                if (object.timestamp != null) {
                    if (typeof object.timestamp !== "object")
                        throw TypeError(".gateway.core.IvCurveMeasurement.timestamp: object expected");
                    message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
                }
                if (object.moduleUuid != null)
                    message.moduleUuid = String(object.moduleUuid);
                if (object.daqUuid != null)
                    message.daqUuid = String(object.daqUuid);
                if (object.data != null) {
                    if (typeof object.data !== "object")
                        throw TypeError(".gateway.core.IvCurveMeasurement.data: object expected");
                    message.data = $root.gateway.core.IvCurve.fromObject(object.data);
                }
                return message;
            };

            /**
             * Creates a plain object from an IvCurveMeasurement message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.IvCurveMeasurement
             * @static
             * @param {gateway.core.IvCurveMeasurement} message IvCurveMeasurement
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            IvCurveMeasurement.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.timestamp = null;
                    object.moduleUuid = "";
                    object.daqUuid = "";
                    object.data = null;
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    object.moduleUuid = message.moduleUuid;
                if (message.daqUuid != null && message.hasOwnProperty("daqUuid"))
                    object.daqUuid = message.daqUuid;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = $root.gateway.core.IvCurve.toObject(message.data, options);
                return object;
            };

            /**
             * Converts this IvCurveMeasurement to JSON.
             * @function toJSON
             * @memberof gateway.core.IvCurveMeasurement
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            IvCurveMeasurement.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return IvCurveMeasurement;
        })();

        core.SensorDataMeasurement = (function() {

            /**
             * Properties of a SensorDataMeasurement.
             * @memberof gateway.core
             * @interface ISensorDataMeasurement
             * @property {google.protobuf.ITimestamp|null} [timestamp] SensorDataMeasurement timestamp
             * @property {string|null} [sensorUuid] SensorDataMeasurement sensorUuid
             * @property {string|null} [telemetryType] SensorDataMeasurement telemetryType
             * @property {google.protobuf.IStruct|null} [data] SensorDataMeasurement data
             */

            /**
             * Constructs a new SensorDataMeasurement.
             * @memberof gateway.core
             * @classdesc Represents a SensorDataMeasurement.
             * @implements ISensorDataMeasurement
             * @constructor
             * @param {gateway.core.ISensorDataMeasurement=} [properties] Properties to set
             */
            function SensorDataMeasurement(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SensorDataMeasurement timestamp.
             * @member {google.protobuf.ITimestamp|null|undefined} timestamp
             * @memberof gateway.core.SensorDataMeasurement
             * @instance
             */
            SensorDataMeasurement.prototype.timestamp = null;

            /**
             * SensorDataMeasurement sensorUuid.
             * @member {string} sensorUuid
             * @memberof gateway.core.SensorDataMeasurement
             * @instance
             */
            SensorDataMeasurement.prototype.sensorUuid = "";

            /**
             * SensorDataMeasurement telemetryType.
             * @member {string} telemetryType
             * @memberof gateway.core.SensorDataMeasurement
             * @instance
             */
            SensorDataMeasurement.prototype.telemetryType = "";

            /**
             * SensorDataMeasurement data.
             * @member {google.protobuf.IStruct|null|undefined} data
             * @memberof gateway.core.SensorDataMeasurement
             * @instance
             */
            SensorDataMeasurement.prototype.data = null;

            /**
             * Creates a new SensorDataMeasurement instance using the specified properties.
             * @function create
             * @memberof gateway.core.SensorDataMeasurement
             * @static
             * @param {gateway.core.ISensorDataMeasurement=} [properties] Properties to set
             * @returns {gateway.core.SensorDataMeasurement} SensorDataMeasurement instance
             */
            SensorDataMeasurement.create = function create(properties) {
                return new SensorDataMeasurement(properties);
            };

            /**
             * Encodes the specified SensorDataMeasurement message. Does not implicitly {@link gateway.core.SensorDataMeasurement.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.SensorDataMeasurement
             * @static
             * @param {gateway.core.ISensorDataMeasurement} message SensorDataMeasurement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SensorDataMeasurement.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.sensorUuid != null && Object.hasOwnProperty.call(message, "sensorUuid"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.sensorUuid);
                if (message.telemetryType != null && Object.hasOwnProperty.call(message, "telemetryType"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.telemetryType);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    $root.google.protobuf.Struct.encode(message.data, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified SensorDataMeasurement message, length delimited. Does not implicitly {@link gateway.core.SensorDataMeasurement.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.SensorDataMeasurement
             * @static
             * @param {gateway.core.ISensorDataMeasurement} message SensorDataMeasurement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SensorDataMeasurement.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SensorDataMeasurement message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.SensorDataMeasurement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.SensorDataMeasurement} SensorDataMeasurement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SensorDataMeasurement.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.SensorDataMeasurement();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.sensorUuid = reader.string();
                        break;
                    case 3:
                        message.telemetryType = reader.string();
                        break;
                    case 4:
                        message.data = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SensorDataMeasurement message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.SensorDataMeasurement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.SensorDataMeasurement} SensorDataMeasurement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SensorDataMeasurement.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SensorDataMeasurement message.
             * @function verify
             * @memberof gateway.core.SensorDataMeasurement
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SensorDataMeasurement.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.timestamp);
                    if (error)
                        return "timestamp." + error;
                }
                if (message.sensorUuid != null && message.hasOwnProperty("sensorUuid"))
                    if (!$util.isString(message.sensorUuid))
                        return "sensorUuid: string expected";
                if (message.telemetryType != null && message.hasOwnProperty("telemetryType"))
                    if (!$util.isString(message.telemetryType))
                        return "telemetryType: string expected";
                if (message.data != null && message.hasOwnProperty("data")) {
                    var error = $root.google.protobuf.Struct.verify(message.data);
                    if (error)
                        return "data." + error;
                }
                return null;
            };

            /**
             * Creates a SensorDataMeasurement message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.SensorDataMeasurement
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.SensorDataMeasurement} SensorDataMeasurement
             */
            SensorDataMeasurement.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.SensorDataMeasurement)
                    return object;
                var message = new $root.gateway.core.SensorDataMeasurement();
                if (object.timestamp != null) {
                    if (typeof object.timestamp !== "object")
                        throw TypeError(".gateway.core.SensorDataMeasurement.timestamp: object expected");
                    message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
                }
                if (object.sensorUuid != null)
                    message.sensorUuid = String(object.sensorUuid);
                if (object.telemetryType != null)
                    message.telemetryType = String(object.telemetryType);
                if (object.data != null) {
                    if (typeof object.data !== "object")
                        throw TypeError(".gateway.core.SensorDataMeasurement.data: object expected");
                    message.data = $root.google.protobuf.Struct.fromObject(object.data);
                }
                return message;
            };

            /**
             * Creates a plain object from a SensorDataMeasurement message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.SensorDataMeasurement
             * @static
             * @param {gateway.core.SensorDataMeasurement} message SensorDataMeasurement
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SensorDataMeasurement.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.timestamp = null;
                    object.sensorUuid = "";
                    object.telemetryType = "";
                    object.data = null;
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
                if (message.sensorUuid != null && message.hasOwnProperty("sensorUuid"))
                    object.sensorUuid = message.sensorUuid;
                if (message.telemetryType != null && message.hasOwnProperty("telemetryType"))
                    object.telemetryType = message.telemetryType;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = $root.google.protobuf.Struct.toObject(message.data, options);
                return object;
            };

            /**
             * Converts this SensorDataMeasurement to JSON.
             * @function toJSON
             * @memberof gateway.core.SensorDataMeasurement
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SensorDataMeasurement.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SensorDataMeasurement;
        })();

        core.Daqs = (function() {

            /**
             * Constructs a new Daqs service.
             * @memberof gateway.core
             * @classdesc Represents a Daqs
             * @extends $protobuf.rpc.Service
             * @constructor
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             */
            function Daqs(rpcImpl, requestDelimited, responseDelimited) {
                $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
            }

            (Daqs.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Daqs;

            /**
             * Creates new Daqs service using the specified rpc implementation.
             * @function create
             * @memberof gateway.core.Daqs
             * @static
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             * @returns {Daqs} RPC service. Useful where requests and/or responses are streamed.
             */
            Daqs.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                return new this(rpcImpl, requestDelimited, responseDelimited);
            };

            /**
             * Callback as used by {@link gateway.core.Daqs#list}.
             * @memberof gateway.core.Daqs
             * @typedef ListCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.ListDaqsResponse} [response] ListDaqsResponse
             */

            /**
             * Calls List.
             * @function list
             * @memberof gateway.core.Daqs
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @param {gateway.core.Daqs.ListCallback} callback Node-style callback called with the error, if any, and ListDaqsResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Daqs.prototype.list = function list(request, callback) {
                return this.rpcCall(list, $root.google.protobuf.Empty, $root.gateway.core.ListDaqsResponse, request, callback);
            }, "name", { value: "List" });

            /**
             * Calls List.
             * @function list
             * @memberof gateway.core.Daqs
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @returns {Promise<gateway.core.ListDaqsResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Daqs#ping}.
             * @memberof gateway.core.Daqs
             * @typedef PingCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.DaqPingResponse} [response] DaqPingResponse
             */

            /**
             * Calls Ping.
             * @function ping
             * @memberof gateway.core.Daqs
             * @instance
             * @param {gateway.core.IPingDaqRequest} request PingDaqRequest message or plain object
             * @param {gateway.core.Daqs.PingCallback} callback Node-style callback called with the error, if any, and DaqPingResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Daqs.prototype.ping = function ping(request, callback) {
                return this.rpcCall(ping, $root.gateway.core.PingDaqRequest, $root.gateway.core.DaqPingResponse, request, callback);
            }, "name", { value: "Ping" });

            /**
             * Calls Ping.
             * @function ping
             * @memberof gateway.core.Daqs
             * @instance
             * @param {gateway.core.IPingDaqRequest} request PingDaqRequest message or plain object
             * @returns {Promise<gateway.core.DaqPingResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Daqs#softReset}.
             * @memberof gateway.core.Daqs
             * @typedef SoftResetCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls SoftReset.
             * @function softReset
             * @memberof gateway.core.Daqs
             * @instance
             * @param {gateway.core.ISoftResetDaqRequest} request SoftResetDaqRequest message or plain object
             * @param {gateway.core.Daqs.SoftResetCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Daqs.prototype.softReset = function softReset(request, callback) {
                return this.rpcCall(softReset, $root.gateway.core.SoftResetDaqRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "SoftReset" });

            /**
             * Calls SoftReset.
             * @function softReset
             * @memberof gateway.core.Daqs
             * @instance
             * @param {gateway.core.ISoftResetDaqRequest} request SoftResetDaqRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            return Daqs;
        })();

        core.DaqDetails = (function() {

            /**
             * Properties of a DaqDetails.
             * @memberof gateway.core
             * @interface IDaqDetails
             * @property {string|null} [uuid] DaqDetails uuid
             * @property {string|null} [name] DaqDetails name
             * @property {number|null} [address] DaqDetails address
             * @property {string|null} [serial] DaqDetails serial
             * @property {string|null} [firmwareVersion] DaqDetails firmwareVersion
             * @property {boolean|null} [connected] DaqDetails connected
             * @property {google.protobuf.ITimestamp|null} [lastSeen] DaqDetails lastSeen
             */

            /**
             * Constructs a new DaqDetails.
             * @memberof gateway.core
             * @classdesc Represents a DaqDetails.
             * @implements IDaqDetails
             * @constructor
             * @param {gateway.core.IDaqDetails=} [properties] Properties to set
             */
            function DaqDetails(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DaqDetails uuid.
             * @member {string} uuid
             * @memberof gateway.core.DaqDetails
             * @instance
             */
            DaqDetails.prototype.uuid = "";

            /**
             * DaqDetails name.
             * @member {string} name
             * @memberof gateway.core.DaqDetails
             * @instance
             */
            DaqDetails.prototype.name = "";

            /**
             * DaqDetails address.
             * @member {number} address
             * @memberof gateway.core.DaqDetails
             * @instance
             */
            DaqDetails.prototype.address = 0;

            /**
             * DaqDetails serial.
             * @member {string} serial
             * @memberof gateway.core.DaqDetails
             * @instance
             */
            DaqDetails.prototype.serial = "";

            /**
             * DaqDetails firmwareVersion.
             * @member {string} firmwareVersion
             * @memberof gateway.core.DaqDetails
             * @instance
             */
            DaqDetails.prototype.firmwareVersion = "";

            /**
             * DaqDetails connected.
             * @member {boolean} connected
             * @memberof gateway.core.DaqDetails
             * @instance
             */
            DaqDetails.prototype.connected = false;

            /**
             * DaqDetails lastSeen.
             * @member {google.protobuf.ITimestamp|null|undefined} lastSeen
             * @memberof gateway.core.DaqDetails
             * @instance
             */
            DaqDetails.prototype.lastSeen = null;

            /**
             * Creates a new DaqDetails instance using the specified properties.
             * @function create
             * @memberof gateway.core.DaqDetails
             * @static
             * @param {gateway.core.IDaqDetails=} [properties] Properties to set
             * @returns {gateway.core.DaqDetails} DaqDetails instance
             */
            DaqDetails.create = function create(properties) {
                return new DaqDetails(properties);
            };

            /**
             * Encodes the specified DaqDetails message. Does not implicitly {@link gateway.core.DaqDetails.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.DaqDetails
             * @static
             * @param {gateway.core.IDaqDetails} message DaqDetails message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DaqDetails.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.uuid);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.address);
                if (message.serial != null && Object.hasOwnProperty.call(message, "serial"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.serial);
                if (message.firmwareVersion != null && Object.hasOwnProperty.call(message, "firmwareVersion"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.firmwareVersion);
                if (message.connected != null && Object.hasOwnProperty.call(message, "connected"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.connected);
                if (message.lastSeen != null && Object.hasOwnProperty.call(message, "lastSeen"))
                    $root.google.protobuf.Timestamp.encode(message.lastSeen, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified DaqDetails message, length delimited. Does not implicitly {@link gateway.core.DaqDetails.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.DaqDetails
             * @static
             * @param {gateway.core.IDaqDetails} message DaqDetails message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DaqDetails.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DaqDetails message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.DaqDetails
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.DaqDetails} DaqDetails
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DaqDetails.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.DaqDetails();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.uuid = reader.string();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.address = reader.uint32();
                        break;
                    case 4:
                        message.serial = reader.string();
                        break;
                    case 6:
                        message.firmwareVersion = reader.string();
                        break;
                    case 7:
                        message.connected = reader.bool();
                        break;
                    case 8:
                        message.lastSeen = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DaqDetails message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.DaqDetails
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.DaqDetails} DaqDetails
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DaqDetails.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DaqDetails message.
             * @function verify
             * @memberof gateway.core.DaqDetails
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DaqDetails.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    if (!$util.isString(message.uuid))
                        return "uuid: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.address != null && message.hasOwnProperty("address"))
                    if (!$util.isInteger(message.address))
                        return "address: integer expected";
                if (message.serial != null && message.hasOwnProperty("serial"))
                    if (!$util.isString(message.serial))
                        return "serial: string expected";
                if (message.firmwareVersion != null && message.hasOwnProperty("firmwareVersion"))
                    if (!$util.isString(message.firmwareVersion))
                        return "firmwareVersion: string expected";
                if (message.connected != null && message.hasOwnProperty("connected"))
                    if (typeof message.connected !== "boolean")
                        return "connected: boolean expected";
                if (message.lastSeen != null && message.hasOwnProperty("lastSeen")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.lastSeen);
                    if (error)
                        return "lastSeen." + error;
                }
                return null;
            };

            /**
             * Creates a DaqDetails message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.DaqDetails
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.DaqDetails} DaqDetails
             */
            DaqDetails.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.DaqDetails)
                    return object;
                var message = new $root.gateway.core.DaqDetails();
                if (object.uuid != null)
                    message.uuid = String(object.uuid);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.address != null)
                    message.address = object.address >>> 0;
                if (object.serial != null)
                    message.serial = String(object.serial);
                if (object.firmwareVersion != null)
                    message.firmwareVersion = String(object.firmwareVersion);
                if (object.connected != null)
                    message.connected = Boolean(object.connected);
                if (object.lastSeen != null) {
                    if (typeof object.lastSeen !== "object")
                        throw TypeError(".gateway.core.DaqDetails.lastSeen: object expected");
                    message.lastSeen = $root.google.protobuf.Timestamp.fromObject(object.lastSeen);
                }
                return message;
            };

            /**
             * Creates a plain object from a DaqDetails message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.DaqDetails
             * @static
             * @param {gateway.core.DaqDetails} message DaqDetails
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DaqDetails.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.uuid = "";
                    object.name = "";
                    object.address = 0;
                    object.serial = "";
                    object.firmwareVersion = "";
                    object.connected = false;
                    object.lastSeen = null;
                }
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    object.uuid = message.uuid;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = message.address;
                if (message.serial != null && message.hasOwnProperty("serial"))
                    object.serial = message.serial;
                if (message.firmwareVersion != null && message.hasOwnProperty("firmwareVersion"))
                    object.firmwareVersion = message.firmwareVersion;
                if (message.connected != null && message.hasOwnProperty("connected"))
                    object.connected = message.connected;
                if (message.lastSeen != null && message.hasOwnProperty("lastSeen"))
                    object.lastSeen = $root.google.protobuf.Timestamp.toObject(message.lastSeen, options);
                return object;
            };

            /**
             * Converts this DaqDetails to JSON.
             * @function toJSON
             * @memberof gateway.core.DaqDetails
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DaqDetails.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DaqDetails;
        })();

        core.ListDaqsResponse = (function() {

            /**
             * Properties of a ListDaqsResponse.
             * @memberof gateway.core
             * @interface IListDaqsResponse
             * @property {Array.<gateway.core.IDaqDetails>|null} [daqs] ListDaqsResponse daqs
             */

            /**
             * Constructs a new ListDaqsResponse.
             * @memberof gateway.core
             * @classdesc Represents a ListDaqsResponse.
             * @implements IListDaqsResponse
             * @constructor
             * @param {gateway.core.IListDaqsResponse=} [properties] Properties to set
             */
            function ListDaqsResponse(properties) {
                this.daqs = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListDaqsResponse daqs.
             * @member {Array.<gateway.core.IDaqDetails>} daqs
             * @memberof gateway.core.ListDaqsResponse
             * @instance
             */
            ListDaqsResponse.prototype.daqs = $util.emptyArray;

            /**
             * Creates a new ListDaqsResponse instance using the specified properties.
             * @function create
             * @memberof gateway.core.ListDaqsResponse
             * @static
             * @param {gateway.core.IListDaqsResponse=} [properties] Properties to set
             * @returns {gateway.core.ListDaqsResponse} ListDaqsResponse instance
             */
            ListDaqsResponse.create = function create(properties) {
                return new ListDaqsResponse(properties);
            };

            /**
             * Encodes the specified ListDaqsResponse message. Does not implicitly {@link gateway.core.ListDaqsResponse.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ListDaqsResponse
             * @static
             * @param {gateway.core.IListDaqsResponse} message ListDaqsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListDaqsResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.daqs != null && message.daqs.length)
                    for (var i = 0; i < message.daqs.length; ++i)
                        $root.gateway.core.DaqDetails.encode(message.daqs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ListDaqsResponse message, length delimited. Does not implicitly {@link gateway.core.ListDaqsResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ListDaqsResponse
             * @static
             * @param {gateway.core.IListDaqsResponse} message ListDaqsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListDaqsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListDaqsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ListDaqsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ListDaqsResponse} ListDaqsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListDaqsResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ListDaqsResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.daqs && message.daqs.length))
                            message.daqs = [];
                        message.daqs.push($root.gateway.core.DaqDetails.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListDaqsResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ListDaqsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ListDaqsResponse} ListDaqsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListDaqsResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListDaqsResponse message.
             * @function verify
             * @memberof gateway.core.ListDaqsResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListDaqsResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.daqs != null && message.hasOwnProperty("daqs")) {
                    if (!Array.isArray(message.daqs))
                        return "daqs: array expected";
                    for (var i = 0; i < message.daqs.length; ++i) {
                        var error = $root.gateway.core.DaqDetails.verify(message.daqs[i]);
                        if (error)
                            return "daqs." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ListDaqsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ListDaqsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ListDaqsResponse} ListDaqsResponse
             */
            ListDaqsResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ListDaqsResponse)
                    return object;
                var message = new $root.gateway.core.ListDaqsResponse();
                if (object.daqs) {
                    if (!Array.isArray(object.daqs))
                        throw TypeError(".gateway.core.ListDaqsResponse.daqs: array expected");
                    message.daqs = [];
                    for (var i = 0; i < object.daqs.length; ++i) {
                        if (typeof object.daqs[i] !== "object")
                            throw TypeError(".gateway.core.ListDaqsResponse.daqs: object expected");
                        message.daqs[i] = $root.gateway.core.DaqDetails.fromObject(object.daqs[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ListDaqsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ListDaqsResponse
             * @static
             * @param {gateway.core.ListDaqsResponse} message ListDaqsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListDaqsResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.daqs = [];
                if (message.daqs && message.daqs.length) {
                    object.daqs = [];
                    for (var j = 0; j < message.daqs.length; ++j)
                        object.daqs[j] = $root.gateway.core.DaqDetails.toObject(message.daqs[j], options);
                }
                return object;
            };

            /**
             * Converts this ListDaqsResponse to JSON.
             * @function toJSON
             * @memberof gateway.core.ListDaqsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListDaqsResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ListDaqsResponse;
        })();

        core.PingDaqRequest = (function() {

            /**
             * Properties of a PingDaqRequest.
             * @memberof gateway.core
             * @interface IPingDaqRequest
             * @property {string|null} [daqUuid] PingDaqRequest daqUuid
             * @property {number|null} [daqAddress] PingDaqRequest daqAddress
             * @property {string|null} [daqSerial] PingDaqRequest daqSerial
             */

            /**
             * Constructs a new PingDaqRequest.
             * @memberof gateway.core
             * @classdesc Represents a PingDaqRequest.
             * @implements IPingDaqRequest
             * @constructor
             * @param {gateway.core.IPingDaqRequest=} [properties] Properties to set
             */
            function PingDaqRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PingDaqRequest daqUuid.
             * @member {string|null|undefined} daqUuid
             * @memberof gateway.core.PingDaqRequest
             * @instance
             */
            PingDaqRequest.prototype.daqUuid = null;

            /**
             * PingDaqRequest daqAddress.
             * @member {number|null|undefined} daqAddress
             * @memberof gateway.core.PingDaqRequest
             * @instance
             */
            PingDaqRequest.prototype.daqAddress = null;

            /**
             * PingDaqRequest daqSerial.
             * @member {string|null|undefined} daqSerial
             * @memberof gateway.core.PingDaqRequest
             * @instance
             */
            PingDaqRequest.prototype.daqSerial = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * PingDaqRequest daqRef.
             * @member {"daqUuid"|"daqAddress"|"daqSerial"|undefined} daqRef
             * @memberof gateway.core.PingDaqRequest
             * @instance
             */
            Object.defineProperty(PingDaqRequest.prototype, "daqRef", {
                get: $util.oneOfGetter($oneOfFields = ["daqUuid", "daqAddress", "daqSerial"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new PingDaqRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.PingDaqRequest
             * @static
             * @param {gateway.core.IPingDaqRequest=} [properties] Properties to set
             * @returns {gateway.core.PingDaqRequest} PingDaqRequest instance
             */
            PingDaqRequest.create = function create(properties) {
                return new PingDaqRequest(properties);
            };

            /**
             * Encodes the specified PingDaqRequest message. Does not implicitly {@link gateway.core.PingDaqRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.PingDaqRequest
             * @static
             * @param {gateway.core.IPingDaqRequest} message PingDaqRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PingDaqRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.daqUuid != null && Object.hasOwnProperty.call(message, "daqUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.daqUuid);
                if (message.daqAddress != null && Object.hasOwnProperty.call(message, "daqAddress"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.daqAddress);
                if (message.daqSerial != null && Object.hasOwnProperty.call(message, "daqSerial"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.daqSerial);
                return writer;
            };

            /**
             * Encodes the specified PingDaqRequest message, length delimited. Does not implicitly {@link gateway.core.PingDaqRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.PingDaqRequest
             * @static
             * @param {gateway.core.IPingDaqRequest} message PingDaqRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PingDaqRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PingDaqRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.PingDaqRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.PingDaqRequest} PingDaqRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PingDaqRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.PingDaqRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.daqUuid = reader.string();
                        break;
                    case 2:
                        message.daqAddress = reader.uint32();
                        break;
                    case 3:
                        message.daqSerial = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PingDaqRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.PingDaqRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.PingDaqRequest} PingDaqRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PingDaqRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PingDaqRequest message.
             * @function verify
             * @memberof gateway.core.PingDaqRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PingDaqRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.daqUuid != null && message.hasOwnProperty("daqUuid")) {
                    properties.daqRef = 1;
                    if (!$util.isString(message.daqUuid))
                        return "daqUuid: string expected";
                }
                if (message.daqAddress != null && message.hasOwnProperty("daqAddress")) {
                    if (properties.daqRef === 1)
                        return "daqRef: multiple values";
                    properties.daqRef = 1;
                    if (!$util.isInteger(message.daqAddress))
                        return "daqAddress: integer expected";
                }
                if (message.daqSerial != null && message.hasOwnProperty("daqSerial")) {
                    if (properties.daqRef === 1)
                        return "daqRef: multiple values";
                    properties.daqRef = 1;
                    if (!$util.isString(message.daqSerial))
                        return "daqSerial: string expected";
                }
                return null;
            };

            /**
             * Creates a PingDaqRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.PingDaqRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.PingDaqRequest} PingDaqRequest
             */
            PingDaqRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.PingDaqRequest)
                    return object;
                var message = new $root.gateway.core.PingDaqRequest();
                if (object.daqUuid != null)
                    message.daqUuid = String(object.daqUuid);
                if (object.daqAddress != null)
                    message.daqAddress = object.daqAddress >>> 0;
                if (object.daqSerial != null)
                    message.daqSerial = String(object.daqSerial);
                return message;
            };

            /**
             * Creates a plain object from a PingDaqRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.PingDaqRequest
             * @static
             * @param {gateway.core.PingDaqRequest} message PingDaqRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PingDaqRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (message.daqUuid != null && message.hasOwnProperty("daqUuid")) {
                    object.daqUuid = message.daqUuid;
                    if (options.oneofs)
                        object.daqRef = "daqUuid";
                }
                if (message.daqAddress != null && message.hasOwnProperty("daqAddress")) {
                    object.daqAddress = message.daqAddress;
                    if (options.oneofs)
                        object.daqRef = "daqAddress";
                }
                if (message.daqSerial != null && message.hasOwnProperty("daqSerial")) {
                    object.daqSerial = message.daqSerial;
                    if (options.oneofs)
                        object.daqRef = "daqSerial";
                }
                return object;
            };

            /**
             * Converts this PingDaqRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.PingDaqRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PingDaqRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PingDaqRequest;
        })();

        core.SoftResetDaqRequest = (function() {

            /**
             * Properties of a SoftResetDaqRequest.
             * @memberof gateway.core
             * @interface ISoftResetDaqRequest
             * @property {string|null} [daqUuid] SoftResetDaqRequest daqUuid
             * @property {number|null} [daqAddress] SoftResetDaqRequest daqAddress
             * @property {string|null} [daqSerial] SoftResetDaqRequest daqSerial
             */

            /**
             * Constructs a new SoftResetDaqRequest.
             * @memberof gateway.core
             * @classdesc Represents a SoftResetDaqRequest.
             * @implements ISoftResetDaqRequest
             * @constructor
             * @param {gateway.core.ISoftResetDaqRequest=} [properties] Properties to set
             */
            function SoftResetDaqRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SoftResetDaqRequest daqUuid.
             * @member {string|null|undefined} daqUuid
             * @memberof gateway.core.SoftResetDaqRequest
             * @instance
             */
            SoftResetDaqRequest.prototype.daqUuid = null;

            /**
             * SoftResetDaqRequest daqAddress.
             * @member {number|null|undefined} daqAddress
             * @memberof gateway.core.SoftResetDaqRequest
             * @instance
             */
            SoftResetDaqRequest.prototype.daqAddress = null;

            /**
             * SoftResetDaqRequest daqSerial.
             * @member {string|null|undefined} daqSerial
             * @memberof gateway.core.SoftResetDaqRequest
             * @instance
             */
            SoftResetDaqRequest.prototype.daqSerial = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * SoftResetDaqRequest daqRef.
             * @member {"daqUuid"|"daqAddress"|"daqSerial"|undefined} daqRef
             * @memberof gateway.core.SoftResetDaqRequest
             * @instance
             */
            Object.defineProperty(SoftResetDaqRequest.prototype, "daqRef", {
                get: $util.oneOfGetter($oneOfFields = ["daqUuid", "daqAddress", "daqSerial"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new SoftResetDaqRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.SoftResetDaqRequest
             * @static
             * @param {gateway.core.ISoftResetDaqRequest=} [properties] Properties to set
             * @returns {gateway.core.SoftResetDaqRequest} SoftResetDaqRequest instance
             */
            SoftResetDaqRequest.create = function create(properties) {
                return new SoftResetDaqRequest(properties);
            };

            /**
             * Encodes the specified SoftResetDaqRequest message. Does not implicitly {@link gateway.core.SoftResetDaqRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.SoftResetDaqRequest
             * @static
             * @param {gateway.core.ISoftResetDaqRequest} message SoftResetDaqRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SoftResetDaqRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.daqUuid != null && Object.hasOwnProperty.call(message, "daqUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.daqUuid);
                if (message.daqAddress != null && Object.hasOwnProperty.call(message, "daqAddress"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.daqAddress);
                if (message.daqSerial != null && Object.hasOwnProperty.call(message, "daqSerial"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.daqSerial);
                return writer;
            };

            /**
             * Encodes the specified SoftResetDaqRequest message, length delimited. Does not implicitly {@link gateway.core.SoftResetDaqRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.SoftResetDaqRequest
             * @static
             * @param {gateway.core.ISoftResetDaqRequest} message SoftResetDaqRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SoftResetDaqRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SoftResetDaqRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.SoftResetDaqRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.SoftResetDaqRequest} SoftResetDaqRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SoftResetDaqRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.SoftResetDaqRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.daqUuid = reader.string();
                        break;
                    case 2:
                        message.daqAddress = reader.uint32();
                        break;
                    case 3:
                        message.daqSerial = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SoftResetDaqRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.SoftResetDaqRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.SoftResetDaqRequest} SoftResetDaqRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SoftResetDaqRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SoftResetDaqRequest message.
             * @function verify
             * @memberof gateway.core.SoftResetDaqRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SoftResetDaqRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.daqUuid != null && message.hasOwnProperty("daqUuid")) {
                    properties.daqRef = 1;
                    if (!$util.isString(message.daqUuid))
                        return "daqUuid: string expected";
                }
                if (message.daqAddress != null && message.hasOwnProperty("daqAddress")) {
                    if (properties.daqRef === 1)
                        return "daqRef: multiple values";
                    properties.daqRef = 1;
                    if (!$util.isInteger(message.daqAddress))
                        return "daqAddress: integer expected";
                }
                if (message.daqSerial != null && message.hasOwnProperty("daqSerial")) {
                    if (properties.daqRef === 1)
                        return "daqRef: multiple values";
                    properties.daqRef = 1;
                    if (!$util.isString(message.daqSerial))
                        return "daqSerial: string expected";
                }
                return null;
            };

            /**
             * Creates a SoftResetDaqRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.SoftResetDaqRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.SoftResetDaqRequest} SoftResetDaqRequest
             */
            SoftResetDaqRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.SoftResetDaqRequest)
                    return object;
                var message = new $root.gateway.core.SoftResetDaqRequest();
                if (object.daqUuid != null)
                    message.daqUuid = String(object.daqUuid);
                if (object.daqAddress != null)
                    message.daqAddress = object.daqAddress >>> 0;
                if (object.daqSerial != null)
                    message.daqSerial = String(object.daqSerial);
                return message;
            };

            /**
             * Creates a plain object from a SoftResetDaqRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.SoftResetDaqRequest
             * @static
             * @param {gateway.core.SoftResetDaqRequest} message SoftResetDaqRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SoftResetDaqRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (message.daqUuid != null && message.hasOwnProperty("daqUuid")) {
                    object.daqUuid = message.daqUuid;
                    if (options.oneofs)
                        object.daqRef = "daqUuid";
                }
                if (message.daqAddress != null && message.hasOwnProperty("daqAddress")) {
                    object.daqAddress = message.daqAddress;
                    if (options.oneofs)
                        object.daqRef = "daqAddress";
                }
                if (message.daqSerial != null && message.hasOwnProperty("daqSerial")) {
                    object.daqSerial = message.daqSerial;
                    if (options.oneofs)
                        object.daqRef = "daqSerial";
                }
                return object;
            };

            /**
             * Converts this SoftResetDaqRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.SoftResetDaqRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SoftResetDaqRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SoftResetDaqRequest;
        })();

        core.DaqPingResponse = (function() {

            /**
             * Properties of a DaqPingResponse.
             * @memberof gateway.core
             * @interface IDaqPingResponse
             * @property {number|null} [roundTripMs] DaqPingResponse roundTripMs
             */

            /**
             * Constructs a new DaqPingResponse.
             * @memberof gateway.core
             * @classdesc Represents a DaqPingResponse.
             * @implements IDaqPingResponse
             * @constructor
             * @param {gateway.core.IDaqPingResponse=} [properties] Properties to set
             */
            function DaqPingResponse(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DaqPingResponse roundTripMs.
             * @member {number} roundTripMs
             * @memberof gateway.core.DaqPingResponse
             * @instance
             */
            DaqPingResponse.prototype.roundTripMs = 0;

            /**
             * Creates a new DaqPingResponse instance using the specified properties.
             * @function create
             * @memberof gateway.core.DaqPingResponse
             * @static
             * @param {gateway.core.IDaqPingResponse=} [properties] Properties to set
             * @returns {gateway.core.DaqPingResponse} DaqPingResponse instance
             */
            DaqPingResponse.create = function create(properties) {
                return new DaqPingResponse(properties);
            };

            /**
             * Encodes the specified DaqPingResponse message. Does not implicitly {@link gateway.core.DaqPingResponse.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.DaqPingResponse
             * @static
             * @param {gateway.core.IDaqPingResponse} message DaqPingResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DaqPingResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roundTripMs != null && Object.hasOwnProperty.call(message, "roundTripMs"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.roundTripMs);
                return writer;
            };

            /**
             * Encodes the specified DaqPingResponse message, length delimited. Does not implicitly {@link gateway.core.DaqPingResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.DaqPingResponse
             * @static
             * @param {gateway.core.IDaqPingResponse} message DaqPingResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DaqPingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DaqPingResponse message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.DaqPingResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.DaqPingResponse} DaqPingResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DaqPingResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.DaqPingResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roundTripMs = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DaqPingResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.DaqPingResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.DaqPingResponse} DaqPingResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DaqPingResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DaqPingResponse message.
             * @function verify
             * @memberof gateway.core.DaqPingResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DaqPingResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roundTripMs != null && message.hasOwnProperty("roundTripMs"))
                    if (!$util.isInteger(message.roundTripMs))
                        return "roundTripMs: integer expected";
                return null;
            };

            /**
             * Creates a DaqPingResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.DaqPingResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.DaqPingResponse} DaqPingResponse
             */
            DaqPingResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.DaqPingResponse)
                    return object;
                var message = new $root.gateway.core.DaqPingResponse();
                if (object.roundTripMs != null)
                    message.roundTripMs = object.roundTripMs >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a DaqPingResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.DaqPingResponse
             * @static
             * @param {gateway.core.DaqPingResponse} message DaqPingResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DaqPingResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.roundTripMs = 0;
                if (message.roundTripMs != null && message.hasOwnProperty("roundTripMs"))
                    object.roundTripMs = message.roundTripMs;
                return object;
            };

            /**
             * Converts this DaqPingResponse to JSON.
             * @function toJSON
             * @memberof gateway.core.DaqPingResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DaqPingResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DaqPingResponse;
        })();

        core.Gateway = (function() {

            /**
             * Constructs a new Gateway service.
             * @memberof gateway.core
             * @classdesc Represents a Gateway
             * @extends $protobuf.rpc.Service
             * @constructor
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             */
            function Gateway(rpcImpl, requestDelimited, responseDelimited) {
                $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
            }

            (Gateway.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Gateway;

            /**
             * Creates new Gateway service using the specified rpc implementation.
             * @function create
             * @memberof gateway.core.Gateway
             * @static
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             * @returns {Gateway} RPC service. Useful where requests and/or responses are streamed.
             */
            Gateway.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                return new this(rpcImpl, requestDelimited, responseDelimited);
            };

            /**
             * Callback as used by {@link gateway.core.Gateway#ping}.
             * @memberof gateway.core.Gateway
             * @typedef PingCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.GatewayPingResponse} [response] GatewayPingResponse
             */

            /**
             * Calls Ping.
             * @function ping
             * @memberof gateway.core.Gateway
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @param {gateway.core.Gateway.PingCallback} callback Node-style callback called with the error, if any, and GatewayPingResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Gateway.prototype.ping = function ping(request, callback) {
                return this.rpcCall(ping, $root.google.protobuf.Empty, $root.gateway.core.GatewayPingResponse, request, callback);
            }, "name", { value: "Ping" });

            /**
             * Calls Ping.
             * @function ping
             * @memberof gateway.core.Gateway
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @returns {Promise<gateway.core.GatewayPingResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Gateway#info}.
             * @memberof gateway.core.Gateway
             * @typedef InfoCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.GatewayInfoResponse} [response] GatewayInfoResponse
             */

            /**
             * Calls Info.
             * @function info
             * @memberof gateway.core.Gateway
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @param {gateway.core.Gateway.InfoCallback} callback Node-style callback called with the error, if any, and GatewayInfoResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Gateway.prototype.info = function info(request, callback) {
                return this.rpcCall(info, $root.google.protobuf.Empty, $root.gateway.core.GatewayInfoResponse, request, callback);
            }, "name", { value: "Info" });

            /**
             * Calls Info.
             * @function info
             * @memberof gateway.core.Gateway
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @returns {Promise<gateway.core.GatewayInfoResponse>} Promise
             * @variation 2
             */

            return Gateway;
        })();

        core.GatewayPingResponse = (function() {

            /**
             * Properties of a GatewayPingResponse.
             * @memberof gateway.core
             * @interface IGatewayPingResponse
             * @property {string|null} [message] GatewayPingResponse message
             */

            /**
             * Constructs a new GatewayPingResponse.
             * @memberof gateway.core
             * @classdesc Represents a GatewayPingResponse.
             * @implements IGatewayPingResponse
             * @constructor
             * @param {gateway.core.IGatewayPingResponse=} [properties] Properties to set
             */
            function GatewayPingResponse(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GatewayPingResponse message.
             * @member {string} message
             * @memberof gateway.core.GatewayPingResponse
             * @instance
             */
            GatewayPingResponse.prototype.message = "";

            /**
             * Creates a new GatewayPingResponse instance using the specified properties.
             * @function create
             * @memberof gateway.core.GatewayPingResponse
             * @static
             * @param {gateway.core.IGatewayPingResponse=} [properties] Properties to set
             * @returns {gateway.core.GatewayPingResponse} GatewayPingResponse instance
             */
            GatewayPingResponse.create = function create(properties) {
                return new GatewayPingResponse(properties);
            };

            /**
             * Encodes the specified GatewayPingResponse message. Does not implicitly {@link gateway.core.GatewayPingResponse.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.GatewayPingResponse
             * @static
             * @param {gateway.core.IGatewayPingResponse} message GatewayPingResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GatewayPingResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
                return writer;
            };

            /**
             * Encodes the specified GatewayPingResponse message, length delimited. Does not implicitly {@link gateway.core.GatewayPingResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.GatewayPingResponse
             * @static
             * @param {gateway.core.IGatewayPingResponse} message GatewayPingResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GatewayPingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GatewayPingResponse message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.GatewayPingResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.GatewayPingResponse} GatewayPingResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GatewayPingResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.GatewayPingResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.message = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GatewayPingResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.GatewayPingResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.GatewayPingResponse} GatewayPingResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GatewayPingResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GatewayPingResponse message.
             * @function verify
             * @memberof gateway.core.GatewayPingResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GatewayPingResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                return null;
            };

            /**
             * Creates a GatewayPingResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.GatewayPingResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.GatewayPingResponse} GatewayPingResponse
             */
            GatewayPingResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.GatewayPingResponse)
                    return object;
                var message = new $root.gateway.core.GatewayPingResponse();
                if (object.message != null)
                    message.message = String(object.message);
                return message;
            };

            /**
             * Creates a plain object from a GatewayPingResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.GatewayPingResponse
             * @static
             * @param {gateway.core.GatewayPingResponse} message GatewayPingResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GatewayPingResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.message = "";
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                return object;
            };

            /**
             * Converts this GatewayPingResponse to JSON.
             * @function toJSON
             * @memberof gateway.core.GatewayPingResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GatewayPingResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GatewayPingResponse;
        })();

        core.GatewayInfoResponse = (function() {

            /**
             * Properties of a GatewayInfoResponse.
             * @memberof gateway.core
             * @interface IGatewayInfoResponse
             * @property {string|null} [version] GatewayInfoResponse version
             * @property {google.protobuf.ITimestamp|null} [buildDate] GatewayInfoResponse buildDate
             * @property {google.protobuf.IDuration|null} [uptime] GatewayInfoResponse uptime
             * @property {google.protobuf.IDuration|null} [systemUptime] GatewayInfoResponse systemUptime
             */

            /**
             * Constructs a new GatewayInfoResponse.
             * @memberof gateway.core
             * @classdesc Represents a GatewayInfoResponse.
             * @implements IGatewayInfoResponse
             * @constructor
             * @param {gateway.core.IGatewayInfoResponse=} [properties] Properties to set
             */
            function GatewayInfoResponse(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GatewayInfoResponse version.
             * @member {string} version
             * @memberof gateway.core.GatewayInfoResponse
             * @instance
             */
            GatewayInfoResponse.prototype.version = "";

            /**
             * GatewayInfoResponse buildDate.
             * @member {google.protobuf.ITimestamp|null|undefined} buildDate
             * @memberof gateway.core.GatewayInfoResponse
             * @instance
             */
            GatewayInfoResponse.prototype.buildDate = null;

            /**
             * GatewayInfoResponse uptime.
             * @member {google.protobuf.IDuration|null|undefined} uptime
             * @memberof gateway.core.GatewayInfoResponse
             * @instance
             */
            GatewayInfoResponse.prototype.uptime = null;

            /**
             * GatewayInfoResponse systemUptime.
             * @member {google.protobuf.IDuration|null|undefined} systemUptime
             * @memberof gateway.core.GatewayInfoResponse
             * @instance
             */
            GatewayInfoResponse.prototype.systemUptime = null;

            /**
             * Creates a new GatewayInfoResponse instance using the specified properties.
             * @function create
             * @memberof gateway.core.GatewayInfoResponse
             * @static
             * @param {gateway.core.IGatewayInfoResponse=} [properties] Properties to set
             * @returns {gateway.core.GatewayInfoResponse} GatewayInfoResponse instance
             */
            GatewayInfoResponse.create = function create(properties) {
                return new GatewayInfoResponse(properties);
            };

            /**
             * Encodes the specified GatewayInfoResponse message. Does not implicitly {@link gateway.core.GatewayInfoResponse.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.GatewayInfoResponse
             * @static
             * @param {gateway.core.IGatewayInfoResponse} message GatewayInfoResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GatewayInfoResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.version);
                if (message.buildDate != null && Object.hasOwnProperty.call(message, "buildDate"))
                    $root.google.protobuf.Timestamp.encode(message.buildDate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.uptime != null && Object.hasOwnProperty.call(message, "uptime"))
                    $root.google.protobuf.Duration.encode(message.uptime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.systemUptime != null && Object.hasOwnProperty.call(message, "systemUptime"))
                    $root.google.protobuf.Duration.encode(message.systemUptime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GatewayInfoResponse message, length delimited. Does not implicitly {@link gateway.core.GatewayInfoResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.GatewayInfoResponse
             * @static
             * @param {gateway.core.IGatewayInfoResponse} message GatewayInfoResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GatewayInfoResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GatewayInfoResponse message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.GatewayInfoResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.GatewayInfoResponse} GatewayInfoResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GatewayInfoResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.GatewayInfoResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.version = reader.string();
                        break;
                    case 2:
                        message.buildDate = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.uptime = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.systemUptime = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GatewayInfoResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.GatewayInfoResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.GatewayInfoResponse} GatewayInfoResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GatewayInfoResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GatewayInfoResponse message.
             * @function verify
             * @memberof gateway.core.GatewayInfoResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GatewayInfoResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                if (message.buildDate != null && message.hasOwnProperty("buildDate")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.buildDate);
                    if (error)
                        return "buildDate." + error;
                }
                if (message.uptime != null && message.hasOwnProperty("uptime")) {
                    var error = $root.google.protobuf.Duration.verify(message.uptime);
                    if (error)
                        return "uptime." + error;
                }
                if (message.systemUptime != null && message.hasOwnProperty("systemUptime")) {
                    var error = $root.google.protobuf.Duration.verify(message.systemUptime);
                    if (error)
                        return "systemUptime." + error;
                }
                return null;
            };

            /**
             * Creates a GatewayInfoResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.GatewayInfoResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.GatewayInfoResponse} GatewayInfoResponse
             */
            GatewayInfoResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.GatewayInfoResponse)
                    return object;
                var message = new $root.gateway.core.GatewayInfoResponse();
                if (object.version != null)
                    message.version = String(object.version);
                if (object.buildDate != null) {
                    if (typeof object.buildDate !== "object")
                        throw TypeError(".gateway.core.GatewayInfoResponse.buildDate: object expected");
                    message.buildDate = $root.google.protobuf.Timestamp.fromObject(object.buildDate);
                }
                if (object.uptime != null) {
                    if (typeof object.uptime !== "object")
                        throw TypeError(".gateway.core.GatewayInfoResponse.uptime: object expected");
                    message.uptime = $root.google.protobuf.Duration.fromObject(object.uptime);
                }
                if (object.systemUptime != null) {
                    if (typeof object.systemUptime !== "object")
                        throw TypeError(".gateway.core.GatewayInfoResponse.systemUptime: object expected");
                    message.systemUptime = $root.google.protobuf.Duration.fromObject(object.systemUptime);
                }
                return message;
            };

            /**
             * Creates a plain object from a GatewayInfoResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.GatewayInfoResponse
             * @static
             * @param {gateway.core.GatewayInfoResponse} message GatewayInfoResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GatewayInfoResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.version = "";
                    object.buildDate = null;
                    object.uptime = null;
                    object.systemUptime = null;
                }
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                if (message.buildDate != null && message.hasOwnProperty("buildDate"))
                    object.buildDate = $root.google.protobuf.Timestamp.toObject(message.buildDate, options);
                if (message.uptime != null && message.hasOwnProperty("uptime"))
                    object.uptime = $root.google.protobuf.Duration.toObject(message.uptime, options);
                if (message.systemUptime != null && message.hasOwnProperty("systemUptime"))
                    object.systemUptime = $root.google.protobuf.Duration.toObject(message.systemUptime, options);
                return object;
            };

            /**
             * Converts this GatewayInfoResponse to JSON.
             * @function toJSON
             * @memberof gateway.core.GatewayInfoResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GatewayInfoResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GatewayInfoResponse;
        })();

        core.Modules = (function() {

            /**
             * Constructs a new Modules service.
             * @memberof gateway.core
             * @classdesc Represents a Modules
             * @extends $protobuf.rpc.Service
             * @constructor
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             */
            function Modules(rpcImpl, requestDelimited, responseDelimited) {
                $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
            }

            (Modules.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Modules;

            /**
             * Creates new Modules service using the specified rpc implementation.
             * @function create
             * @memberof gateway.core.Modules
             * @static
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             * @returns {Modules} RPC service. Useful where requests and/or responses are streamed.
             */
            Modules.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                return new this(rpcImpl, requestDelimited, responseDelimited);
            };

            /**
             * Callback as used by {@link gateway.core.Modules#list}.
             * @memberof gateway.core.Modules
             * @typedef ListCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.ListModulesResponse} [response] ListModulesResponse
             */

            /**
             * Calls List.
             * @function list
             * @memberof gateway.core.Modules
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @param {gateway.core.Modules.ListCallback} callback Node-style callback called with the error, if any, and ListModulesResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Modules.prototype.list = function list(request, callback) {
                return this.rpcCall(list, $root.google.protobuf.Empty, $root.gateway.core.ListModulesResponse, request, callback);
            }, "name", { value: "List" });

            /**
             * Calls List.
             * @function list
             * @memberof gateway.core.Modules
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @returns {Promise<gateway.core.ListModulesResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Modules#link}.
             * @memberof gateway.core.Modules
             * @typedef LinkCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls Link.
             * @function link
             * @memberof gateway.core.Modules
             * @instance
             * @param {gateway.core.ILinkModuleRequest} request LinkModuleRequest message or plain object
             * @param {gateway.core.Modules.LinkCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Modules.prototype.link = function link(request, callback) {
                return this.rpcCall(link, $root.gateway.core.LinkModuleRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "Link" });

            /**
             * Calls Link.
             * @function link
             * @memberof gateway.core.Modules
             * @instance
             * @param {gateway.core.ILinkModuleRequest} request LinkModuleRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Modules#unlink}.
             * @memberof gateway.core.Modules
             * @typedef UnlinkCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls Unlink.
             * @function unlink
             * @memberof gateway.core.Modules
             * @instance
             * @param {gateway.core.IUnlinkModuleRequest} request UnlinkModuleRequest message or plain object
             * @param {gateway.core.Modules.UnlinkCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Modules.prototype.unlink = function unlink(request, callback) {
                return this.rpcCall(unlink, $root.gateway.core.UnlinkModuleRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "Unlink" });

            /**
             * Calls Unlink.
             * @function unlink
             * @memberof gateway.core.Modules
             * @instance
             * @param {gateway.core.IUnlinkModuleRequest} request UnlinkModuleRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Modules#getIvCurve}.
             * @memberof gateway.core.Modules
             * @typedef GetIvCurveCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.IvCurveMeasurement} [response] IvCurveMeasurement
             */

            /**
             * Calls GetIvCurve.
             * @function getIvCurve
             * @memberof gateway.core.Modules
             * @instance
             * @param {gateway.core.IGetIvCurveRequest} request GetIvCurveRequest message or plain object
             * @param {gateway.core.Modules.GetIvCurveCallback} callback Node-style callback called with the error, if any, and IvCurveMeasurement
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Modules.prototype.getIvCurve = function getIvCurve(request, callback) {
                return this.rpcCall(getIvCurve, $root.gateway.core.GetIvCurveRequest, $root.gateway.core.IvCurveMeasurement, request, callback);
            }, "name", { value: "GetIvCurve" });

            /**
             * Calls GetIvCurve.
             * @function getIvCurve
             * @memberof gateway.core.Modules
             * @instance
             * @param {gateway.core.IGetIvCurveRequest} request GetIvCurveRequest message or plain object
             * @returns {Promise<gateway.core.IvCurveMeasurement>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Modules#getOperatingPower}.
             * @memberof gateway.core.Modules
             * @typedef GetOperatingPowerCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.OperatingPowerMeasurement} [response] OperatingPowerMeasurement
             */

            /**
             * Calls GetOperatingPower.
             * @function getOperatingPower
             * @memberof gateway.core.Modules
             * @instance
             * @param {gateway.core.IGetOperatingPowerRequest} request GetOperatingPowerRequest message or plain object
             * @param {gateway.core.Modules.GetOperatingPowerCallback} callback Node-style callback called with the error, if any, and OperatingPowerMeasurement
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Modules.prototype.getOperatingPower = function getOperatingPower(request, callback) {
                return this.rpcCall(getOperatingPower, $root.gateway.core.GetOperatingPowerRequest, $root.gateway.core.OperatingPowerMeasurement, request, callback);
            }, "name", { value: "GetOperatingPower" });

            /**
             * Calls GetOperatingPower.
             * @function getOperatingPower
             * @memberof gateway.core.Modules
             * @instance
             * @param {gateway.core.IGetOperatingPowerRequest} request GetOperatingPowerRequest message or plain object
             * @returns {Promise<gateway.core.OperatingPowerMeasurement>} Promise
             * @variation 2
             */

            return Modules;
        })();

        core.Module = (function() {

            /**
             * Properties of a Module.
             * @memberof gateway.core
             * @interface IModule
             * @property {string|null} [uuid] Module uuid
             * @property {string|null} [name] Module name
             * @property {gateway.core.IDaq|null} [daq] Module daq
             * @property {gateway.core.IIvCurveSettings|null} [ivSettings] Module ivSettings
             */

            /**
             * Constructs a new Module.
             * @memberof gateway.core
             * @classdesc Represents a Module.
             * @implements IModule
             * @constructor
             * @param {gateway.core.IModule=} [properties] Properties to set
             */
            function Module(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Module uuid.
             * @member {string} uuid
             * @memberof gateway.core.Module
             * @instance
             */
            Module.prototype.uuid = "";

            /**
             * Module name.
             * @member {string} name
             * @memberof gateway.core.Module
             * @instance
             */
            Module.prototype.name = "";

            /**
             * Module daq.
             * @member {gateway.core.IDaq|null|undefined} daq
             * @memberof gateway.core.Module
             * @instance
             */
            Module.prototype.daq = null;

            /**
             * Module ivSettings.
             * @member {gateway.core.IIvCurveSettings|null|undefined} ivSettings
             * @memberof gateway.core.Module
             * @instance
             */
            Module.prototype.ivSettings = null;

            /**
             * Creates a new Module instance using the specified properties.
             * @function create
             * @memberof gateway.core.Module
             * @static
             * @param {gateway.core.IModule=} [properties] Properties to set
             * @returns {gateway.core.Module} Module instance
             */
            Module.create = function create(properties) {
                return new Module(properties);
            };

            /**
             * Encodes the specified Module message. Does not implicitly {@link gateway.core.Module.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.Module
             * @static
             * @param {gateway.core.IModule} message Module message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Module.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.uuid);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.daq != null && Object.hasOwnProperty.call(message, "daq"))
                    $root.gateway.core.Daq.encode(message.daq, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.ivSettings != null && Object.hasOwnProperty.call(message, "ivSettings"))
                    $root.gateway.core.IvCurveSettings.encode(message.ivSettings, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Module message, length delimited. Does not implicitly {@link gateway.core.Module.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.Module
             * @static
             * @param {gateway.core.IModule} message Module message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Module.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Module message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.Module
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.Module} Module
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Module.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.Module();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.uuid = reader.string();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.daq = $root.gateway.core.Daq.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.ivSettings = $root.gateway.core.IvCurveSettings.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Module message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.Module
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.Module} Module
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Module.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Module message.
             * @function verify
             * @memberof gateway.core.Module
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Module.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    if (!$util.isString(message.uuid))
                        return "uuid: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.daq != null && message.hasOwnProperty("daq")) {
                    var error = $root.gateway.core.Daq.verify(message.daq);
                    if (error)
                        return "daq." + error;
                }
                if (message.ivSettings != null && message.hasOwnProperty("ivSettings")) {
                    var error = $root.gateway.core.IvCurveSettings.verify(message.ivSettings);
                    if (error)
                        return "ivSettings." + error;
                }
                return null;
            };

            /**
             * Creates a Module message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.Module
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.Module} Module
             */
            Module.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.Module)
                    return object;
                var message = new $root.gateway.core.Module();
                if (object.uuid != null)
                    message.uuid = String(object.uuid);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.daq != null) {
                    if (typeof object.daq !== "object")
                        throw TypeError(".gateway.core.Module.daq: object expected");
                    message.daq = $root.gateway.core.Daq.fromObject(object.daq);
                }
                if (object.ivSettings != null) {
                    if (typeof object.ivSettings !== "object")
                        throw TypeError(".gateway.core.Module.ivSettings: object expected");
                    message.ivSettings = $root.gateway.core.IvCurveSettings.fromObject(object.ivSettings);
                }
                return message;
            };

            /**
             * Creates a plain object from a Module message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.Module
             * @static
             * @param {gateway.core.Module} message Module
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Module.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.uuid = "";
                    object.name = "";
                    object.daq = null;
                    object.ivSettings = null;
                }
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    object.uuid = message.uuid;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.daq != null && message.hasOwnProperty("daq"))
                    object.daq = $root.gateway.core.Daq.toObject(message.daq, options);
                if (message.ivSettings != null && message.hasOwnProperty("ivSettings"))
                    object.ivSettings = $root.gateway.core.IvCurveSettings.toObject(message.ivSettings, options);
                return object;
            };

            /**
             * Converts this Module to JSON.
             * @function toJSON
             * @memberof gateway.core.Module
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Module.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Module;
        })();

        core.IvCurveSettings = (function() {

            /**
             * Properties of an IvCurveSettings.
             * @memberof gateway.core
             * @interface IIvCurveSettings
             * @property {gateway.core.IvCurveSettings.ScanMethod|null} [scanMethod] IvCurveSettings scanMethod
             * @property {number|null} [scanMode] IvCurveSettings scanMode
             */

            /**
             * Constructs a new IvCurveSettings.
             * @memberof gateway.core
             * @classdesc Represents an IvCurveSettings.
             * @implements IIvCurveSettings
             * @constructor
             * @param {gateway.core.IIvCurveSettings=} [properties] Properties to set
             */
            function IvCurveSettings(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * IvCurveSettings scanMethod.
             * @member {gateway.core.IvCurveSettings.ScanMethod} scanMethod
             * @memberof gateway.core.IvCurveSettings
             * @instance
             */
            IvCurveSettings.prototype.scanMethod = 0;

            /**
             * IvCurveSettings scanMode.
             * @member {number|null|undefined} scanMode
             * @memberof gateway.core.IvCurveSettings
             * @instance
             */
            IvCurveSettings.prototype.scanMode = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * IvCurveSettings optional.
             * @member {"scanMode"|undefined} optional
             * @memberof gateway.core.IvCurveSettings
             * @instance
             */
            Object.defineProperty(IvCurveSettings.prototype, "optional", {
                get: $util.oneOfGetter($oneOfFields = ["scanMode"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new IvCurveSettings instance using the specified properties.
             * @function create
             * @memberof gateway.core.IvCurveSettings
             * @static
             * @param {gateway.core.IIvCurveSettings=} [properties] Properties to set
             * @returns {gateway.core.IvCurveSettings} IvCurveSettings instance
             */
            IvCurveSettings.create = function create(properties) {
                return new IvCurveSettings(properties);
            };

            /**
             * Encodes the specified IvCurveSettings message. Does not implicitly {@link gateway.core.IvCurveSettings.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.IvCurveSettings
             * @static
             * @param {gateway.core.IIvCurveSettings} message IvCurveSettings message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IvCurveSettings.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.scanMethod != null && Object.hasOwnProperty.call(message, "scanMethod"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.scanMethod);
                if (message.scanMode != null && Object.hasOwnProperty.call(message, "scanMode"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.scanMode);
                return writer;
            };

            /**
             * Encodes the specified IvCurveSettings message, length delimited. Does not implicitly {@link gateway.core.IvCurveSettings.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.IvCurveSettings
             * @static
             * @param {gateway.core.IIvCurveSettings} message IvCurveSettings message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IvCurveSettings.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an IvCurveSettings message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.IvCurveSettings
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.IvCurveSettings} IvCurveSettings
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IvCurveSettings.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.IvCurveSettings();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.scanMethod = reader.int32();
                        break;
                    case 2:
                        message.scanMode = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an IvCurveSettings message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.IvCurveSettings
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.IvCurveSettings} IvCurveSettings
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IvCurveSettings.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an IvCurveSettings message.
             * @function verify
             * @memberof gateway.core.IvCurveSettings
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            IvCurveSettings.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.scanMethod != null && message.hasOwnProperty("scanMethod"))
                    switch (message.scanMethod) {
                    default:
                        return "scanMethod: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.scanMode != null && message.hasOwnProperty("scanMode")) {
                    properties.optional = 1;
                    if (!$util.isInteger(message.scanMode))
                        return "scanMode: integer expected";
                }
                return null;
            };

            /**
             * Creates an IvCurveSettings message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.IvCurveSettings
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.IvCurveSettings} IvCurveSettings
             */
            IvCurveSettings.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.IvCurveSettings)
                    return object;
                var message = new $root.gateway.core.IvCurveSettings();
                switch (object.scanMethod) {
                case "AUTO":
                case 0:
                    message.scanMethod = 0;
                    break;
                case "FIXED":
                case 1:
                    message.scanMethod = 1;
                    break;
                }
                if (object.scanMode != null)
                    message.scanMode = object.scanMode >>> 0;
                return message;
            };

            /**
             * Creates a plain object from an IvCurveSettings message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.IvCurveSettings
             * @static
             * @param {gateway.core.IvCurveSettings} message IvCurveSettings
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            IvCurveSettings.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.scanMethod = options.enums === String ? "AUTO" : 0;
                if (message.scanMethod != null && message.hasOwnProperty("scanMethod"))
                    object.scanMethod = options.enums === String ? $root.gateway.core.IvCurveSettings.ScanMethod[message.scanMethod] : message.scanMethod;
                if (message.scanMode != null && message.hasOwnProperty("scanMode")) {
                    object.scanMode = message.scanMode;
                    if (options.oneofs)
                        object.optional = "scanMode";
                }
                return object;
            };

            /**
             * Converts this IvCurveSettings to JSON.
             * @function toJSON
             * @memberof gateway.core.IvCurveSettings
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            IvCurveSettings.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * ScanMethod enum.
             * @name gateway.core.IvCurveSettings.ScanMethod
             * @enum {number}
             * @property {number} AUTO=0 AUTO value
             * @property {number} FIXED=1 FIXED value
             */
            IvCurveSettings.ScanMethod = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "AUTO"] = 0;
                values[valuesById[1] = "FIXED"] = 1;
                return values;
            })();

            return IvCurveSettings;
        })();

        core.ListModulesResponse = (function() {

            /**
             * Properties of a ListModulesResponse.
             * @memberof gateway.core
             * @interface IListModulesResponse
             * @property {Array.<gateway.core.IModule>|null} [modules] ListModulesResponse modules
             */

            /**
             * Constructs a new ListModulesResponse.
             * @memberof gateway.core
             * @classdesc Represents a ListModulesResponse.
             * @implements IListModulesResponse
             * @constructor
             * @param {gateway.core.IListModulesResponse=} [properties] Properties to set
             */
            function ListModulesResponse(properties) {
                this.modules = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListModulesResponse modules.
             * @member {Array.<gateway.core.IModule>} modules
             * @memberof gateway.core.ListModulesResponse
             * @instance
             */
            ListModulesResponse.prototype.modules = $util.emptyArray;

            /**
             * Creates a new ListModulesResponse instance using the specified properties.
             * @function create
             * @memberof gateway.core.ListModulesResponse
             * @static
             * @param {gateway.core.IListModulesResponse=} [properties] Properties to set
             * @returns {gateway.core.ListModulesResponse} ListModulesResponse instance
             */
            ListModulesResponse.create = function create(properties) {
                return new ListModulesResponse(properties);
            };

            /**
             * Encodes the specified ListModulesResponse message. Does not implicitly {@link gateway.core.ListModulesResponse.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ListModulesResponse
             * @static
             * @param {gateway.core.IListModulesResponse} message ListModulesResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListModulesResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.modules != null && message.modules.length)
                    for (var i = 0; i < message.modules.length; ++i)
                        $root.gateway.core.Module.encode(message.modules[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ListModulesResponse message, length delimited. Does not implicitly {@link gateway.core.ListModulesResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ListModulesResponse
             * @static
             * @param {gateway.core.IListModulesResponse} message ListModulesResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListModulesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListModulesResponse message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ListModulesResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ListModulesResponse} ListModulesResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListModulesResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ListModulesResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.modules && message.modules.length))
                            message.modules = [];
                        message.modules.push($root.gateway.core.Module.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListModulesResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ListModulesResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ListModulesResponse} ListModulesResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListModulesResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListModulesResponse message.
             * @function verify
             * @memberof gateway.core.ListModulesResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListModulesResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.modules != null && message.hasOwnProperty("modules")) {
                    if (!Array.isArray(message.modules))
                        return "modules: array expected";
                    for (var i = 0; i < message.modules.length; ++i) {
                        var error = $root.gateway.core.Module.verify(message.modules[i]);
                        if (error)
                            return "modules." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ListModulesResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ListModulesResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ListModulesResponse} ListModulesResponse
             */
            ListModulesResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ListModulesResponse)
                    return object;
                var message = new $root.gateway.core.ListModulesResponse();
                if (object.modules) {
                    if (!Array.isArray(object.modules))
                        throw TypeError(".gateway.core.ListModulesResponse.modules: array expected");
                    message.modules = [];
                    for (var i = 0; i < object.modules.length; ++i) {
                        if (typeof object.modules[i] !== "object")
                            throw TypeError(".gateway.core.ListModulesResponse.modules: object expected");
                        message.modules[i] = $root.gateway.core.Module.fromObject(object.modules[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ListModulesResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ListModulesResponse
             * @static
             * @param {gateway.core.ListModulesResponse} message ListModulesResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListModulesResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.modules = [];
                if (message.modules && message.modules.length) {
                    object.modules = [];
                    for (var j = 0; j < message.modules.length; ++j)
                        object.modules[j] = $root.gateway.core.Module.toObject(message.modules[j], options);
                }
                return object;
            };

            /**
             * Converts this ListModulesResponse to JSON.
             * @function toJSON
             * @memberof gateway.core.ListModulesResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListModulesResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ListModulesResponse;
        })();

        core.UnlinkModuleRequest = (function() {

            /**
             * Properties of an UnlinkModuleRequest.
             * @memberof gateway.core
             * @interface IUnlinkModuleRequest
             * @property {string|null} [moduleUuid] UnlinkModuleRequest moduleUuid
             */

            /**
             * Constructs a new UnlinkModuleRequest.
             * @memberof gateway.core
             * @classdesc Represents an UnlinkModuleRequest.
             * @implements IUnlinkModuleRequest
             * @constructor
             * @param {gateway.core.IUnlinkModuleRequest=} [properties] Properties to set
             */
            function UnlinkModuleRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UnlinkModuleRequest moduleUuid.
             * @member {string} moduleUuid
             * @memberof gateway.core.UnlinkModuleRequest
             * @instance
             */
            UnlinkModuleRequest.prototype.moduleUuid = "";

            /**
             * Creates a new UnlinkModuleRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.UnlinkModuleRequest
             * @static
             * @param {gateway.core.IUnlinkModuleRequest=} [properties] Properties to set
             * @returns {gateway.core.UnlinkModuleRequest} UnlinkModuleRequest instance
             */
            UnlinkModuleRequest.create = function create(properties) {
                return new UnlinkModuleRequest(properties);
            };

            /**
             * Encodes the specified UnlinkModuleRequest message. Does not implicitly {@link gateway.core.UnlinkModuleRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.UnlinkModuleRequest
             * @static
             * @param {gateway.core.IUnlinkModuleRequest} message UnlinkModuleRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnlinkModuleRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.moduleUuid != null && Object.hasOwnProperty.call(message, "moduleUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.moduleUuid);
                return writer;
            };

            /**
             * Encodes the specified UnlinkModuleRequest message, length delimited. Does not implicitly {@link gateway.core.UnlinkModuleRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.UnlinkModuleRequest
             * @static
             * @param {gateway.core.IUnlinkModuleRequest} message UnlinkModuleRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnlinkModuleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UnlinkModuleRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.UnlinkModuleRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.UnlinkModuleRequest} UnlinkModuleRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnlinkModuleRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.UnlinkModuleRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.moduleUuid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UnlinkModuleRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.UnlinkModuleRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.UnlinkModuleRequest} UnlinkModuleRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnlinkModuleRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UnlinkModuleRequest message.
             * @function verify
             * @memberof gateway.core.UnlinkModuleRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UnlinkModuleRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    if (!$util.isString(message.moduleUuid))
                        return "moduleUuid: string expected";
                return null;
            };

            /**
             * Creates an UnlinkModuleRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.UnlinkModuleRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.UnlinkModuleRequest} UnlinkModuleRequest
             */
            UnlinkModuleRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.UnlinkModuleRequest)
                    return object;
                var message = new $root.gateway.core.UnlinkModuleRequest();
                if (object.moduleUuid != null)
                    message.moduleUuid = String(object.moduleUuid);
                return message;
            };

            /**
             * Creates a plain object from an UnlinkModuleRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.UnlinkModuleRequest
             * @static
             * @param {gateway.core.UnlinkModuleRequest} message UnlinkModuleRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UnlinkModuleRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.moduleUuid = "";
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    object.moduleUuid = message.moduleUuid;
                return object;
            };

            /**
             * Converts this UnlinkModuleRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.UnlinkModuleRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UnlinkModuleRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UnlinkModuleRequest;
        })();

        core.UpdateModuleRequest = (function() {

            /**
             * Properties of an UpdateModuleRequest.
             * @memberof gateway.core
             * @interface IUpdateModuleRequest
             * @property {string|null} [moduleUuid] UpdateModuleRequest moduleUuid
             * @property {gateway.core.IModule|null} [module] UpdateModuleRequest module
             * @property {boolean|null} [force] UpdateModuleRequest force
             * @property {boolean|null} [incremental] UpdateModuleRequest incremental
             */

            /**
             * Constructs a new UpdateModuleRequest.
             * @memberof gateway.core
             * @classdesc Represents an UpdateModuleRequest.
             * @implements IUpdateModuleRequest
             * @constructor
             * @param {gateway.core.IUpdateModuleRequest=} [properties] Properties to set
             */
            function UpdateModuleRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdateModuleRequest moduleUuid.
             * @member {string} moduleUuid
             * @memberof gateway.core.UpdateModuleRequest
             * @instance
             */
            UpdateModuleRequest.prototype.moduleUuid = "";

            /**
             * UpdateModuleRequest module.
             * @member {gateway.core.IModule|null|undefined} module
             * @memberof gateway.core.UpdateModuleRequest
             * @instance
             */
            UpdateModuleRequest.prototype.module = null;

            /**
             * UpdateModuleRequest force.
             * @member {boolean} force
             * @memberof gateway.core.UpdateModuleRequest
             * @instance
             */
            UpdateModuleRequest.prototype.force = false;

            /**
             * UpdateModuleRequest incremental.
             * @member {boolean} incremental
             * @memberof gateway.core.UpdateModuleRequest
             * @instance
             */
            UpdateModuleRequest.prototype.incremental = false;

            /**
             * Creates a new UpdateModuleRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.UpdateModuleRequest
             * @static
             * @param {gateway.core.IUpdateModuleRequest=} [properties] Properties to set
             * @returns {gateway.core.UpdateModuleRequest} UpdateModuleRequest instance
             */
            UpdateModuleRequest.create = function create(properties) {
                return new UpdateModuleRequest(properties);
            };

            /**
             * Encodes the specified UpdateModuleRequest message. Does not implicitly {@link gateway.core.UpdateModuleRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.UpdateModuleRequest
             * @static
             * @param {gateway.core.IUpdateModuleRequest} message UpdateModuleRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateModuleRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.moduleUuid != null && Object.hasOwnProperty.call(message, "moduleUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.moduleUuid);
                if (message.module != null && Object.hasOwnProperty.call(message, "module"))
                    $root.gateway.core.Module.encode(message.module, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.force != null && Object.hasOwnProperty.call(message, "force"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.force);
                if (message.incremental != null && Object.hasOwnProperty.call(message, "incremental"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.incremental);
                return writer;
            };

            /**
             * Encodes the specified UpdateModuleRequest message, length delimited. Does not implicitly {@link gateway.core.UpdateModuleRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.UpdateModuleRequest
             * @static
             * @param {gateway.core.IUpdateModuleRequest} message UpdateModuleRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateModuleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateModuleRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.UpdateModuleRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.UpdateModuleRequest} UpdateModuleRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateModuleRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.UpdateModuleRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.moduleUuid = reader.string();
                        break;
                    case 2:
                        message.module = $root.gateway.core.Module.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.force = reader.bool();
                        break;
                    case 4:
                        message.incremental = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateModuleRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.UpdateModuleRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.UpdateModuleRequest} UpdateModuleRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateModuleRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateModuleRequest message.
             * @function verify
             * @memberof gateway.core.UpdateModuleRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateModuleRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    if (!$util.isString(message.moduleUuid))
                        return "moduleUuid: string expected";
                if (message.module != null && message.hasOwnProperty("module")) {
                    var error = $root.gateway.core.Module.verify(message.module);
                    if (error)
                        return "module." + error;
                }
                if (message.force != null && message.hasOwnProperty("force"))
                    if (typeof message.force !== "boolean")
                        return "force: boolean expected";
                if (message.incremental != null && message.hasOwnProperty("incremental"))
                    if (typeof message.incremental !== "boolean")
                        return "incremental: boolean expected";
                return null;
            };

            /**
             * Creates an UpdateModuleRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.UpdateModuleRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.UpdateModuleRequest} UpdateModuleRequest
             */
            UpdateModuleRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.UpdateModuleRequest)
                    return object;
                var message = new $root.gateway.core.UpdateModuleRequest();
                if (object.moduleUuid != null)
                    message.moduleUuid = String(object.moduleUuid);
                if (object.module != null) {
                    if (typeof object.module !== "object")
                        throw TypeError(".gateway.core.UpdateModuleRequest.module: object expected");
                    message.module = $root.gateway.core.Module.fromObject(object.module);
                }
                if (object.force != null)
                    message.force = Boolean(object.force);
                if (object.incremental != null)
                    message.incremental = Boolean(object.incremental);
                return message;
            };

            /**
             * Creates a plain object from an UpdateModuleRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.UpdateModuleRequest
             * @static
             * @param {gateway.core.UpdateModuleRequest} message UpdateModuleRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateModuleRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.moduleUuid = "";
                    object.module = null;
                    object.force = false;
                    object.incremental = false;
                }
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    object.moduleUuid = message.moduleUuid;
                if (message.module != null && message.hasOwnProperty("module"))
                    object.module = $root.gateway.core.Module.toObject(message.module, options);
                if (message.force != null && message.hasOwnProperty("force"))
                    object.force = message.force;
                if (message.incremental != null && message.hasOwnProperty("incremental"))
                    object.incremental = message.incremental;
                return object;
            };

            /**
             * Converts this UpdateModuleRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.UpdateModuleRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateModuleRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateModuleRequest;
        })();

        core.LinkModuleRequest = (function() {

            /**
             * Properties of a LinkModuleRequest.
             * @memberof gateway.core
             * @interface ILinkModuleRequest
             * @property {gateway.core.IModule|null} [module] LinkModuleRequest module
             * @property {boolean|null} [force] LinkModuleRequest force
             */

            /**
             * Constructs a new LinkModuleRequest.
             * @memberof gateway.core
             * @classdesc Represents a LinkModuleRequest.
             * @implements ILinkModuleRequest
             * @constructor
             * @param {gateway.core.ILinkModuleRequest=} [properties] Properties to set
             */
            function LinkModuleRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LinkModuleRequest module.
             * @member {gateway.core.IModule|null|undefined} module
             * @memberof gateway.core.LinkModuleRequest
             * @instance
             */
            LinkModuleRequest.prototype.module = null;

            /**
             * LinkModuleRequest force.
             * @member {boolean} force
             * @memberof gateway.core.LinkModuleRequest
             * @instance
             */
            LinkModuleRequest.prototype.force = false;

            /**
             * Creates a new LinkModuleRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.LinkModuleRequest
             * @static
             * @param {gateway.core.ILinkModuleRequest=} [properties] Properties to set
             * @returns {gateway.core.LinkModuleRequest} LinkModuleRequest instance
             */
            LinkModuleRequest.create = function create(properties) {
                return new LinkModuleRequest(properties);
            };

            /**
             * Encodes the specified LinkModuleRequest message. Does not implicitly {@link gateway.core.LinkModuleRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.LinkModuleRequest
             * @static
             * @param {gateway.core.ILinkModuleRequest} message LinkModuleRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LinkModuleRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.module != null && Object.hasOwnProperty.call(message, "module"))
                    $root.gateway.core.Module.encode(message.module, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.force != null && Object.hasOwnProperty.call(message, "force"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.force);
                return writer;
            };

            /**
             * Encodes the specified LinkModuleRequest message, length delimited. Does not implicitly {@link gateway.core.LinkModuleRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.LinkModuleRequest
             * @static
             * @param {gateway.core.ILinkModuleRequest} message LinkModuleRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LinkModuleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LinkModuleRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.LinkModuleRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.LinkModuleRequest} LinkModuleRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LinkModuleRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.LinkModuleRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.module = $root.gateway.core.Module.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.force = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LinkModuleRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.LinkModuleRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.LinkModuleRequest} LinkModuleRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LinkModuleRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LinkModuleRequest message.
             * @function verify
             * @memberof gateway.core.LinkModuleRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LinkModuleRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.module != null && message.hasOwnProperty("module")) {
                    var error = $root.gateway.core.Module.verify(message.module);
                    if (error)
                        return "module." + error;
                }
                if (message.force != null && message.hasOwnProperty("force"))
                    if (typeof message.force !== "boolean")
                        return "force: boolean expected";
                return null;
            };

            /**
             * Creates a LinkModuleRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.LinkModuleRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.LinkModuleRequest} LinkModuleRequest
             */
            LinkModuleRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.LinkModuleRequest)
                    return object;
                var message = new $root.gateway.core.LinkModuleRequest();
                if (object.module != null) {
                    if (typeof object.module !== "object")
                        throw TypeError(".gateway.core.LinkModuleRequest.module: object expected");
                    message.module = $root.gateway.core.Module.fromObject(object.module);
                }
                if (object.force != null)
                    message.force = Boolean(object.force);
                return message;
            };

            /**
             * Creates a plain object from a LinkModuleRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.LinkModuleRequest
             * @static
             * @param {gateway.core.LinkModuleRequest} message LinkModuleRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LinkModuleRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.module = null;
                    object.force = false;
                }
                if (message.module != null && message.hasOwnProperty("module"))
                    object.module = $root.gateway.core.Module.toObject(message.module, options);
                if (message.force != null && message.hasOwnProperty("force"))
                    object.force = message.force;
                return object;
            };

            /**
             * Converts this LinkModuleRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.LinkModuleRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LinkModuleRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LinkModuleRequest;
        })();

        core.GetIvCurveRequest = (function() {

            /**
             * Properties of a GetIvCurveRequest.
             * @memberof gateway.core
             * @interface IGetIvCurveRequest
             * @property {string|null} [moduleUuid] GetIvCurveRequest moduleUuid
             */

            /**
             * Constructs a new GetIvCurveRequest.
             * @memberof gateway.core
             * @classdesc Represents a GetIvCurveRequest.
             * @implements IGetIvCurveRequest
             * @constructor
             * @param {gateway.core.IGetIvCurveRequest=} [properties] Properties to set
             */
            function GetIvCurveRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetIvCurveRequest moduleUuid.
             * @member {string} moduleUuid
             * @memberof gateway.core.GetIvCurveRequest
             * @instance
             */
            GetIvCurveRequest.prototype.moduleUuid = "";

            /**
             * Creates a new GetIvCurveRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.GetIvCurveRequest
             * @static
             * @param {gateway.core.IGetIvCurveRequest=} [properties] Properties to set
             * @returns {gateway.core.GetIvCurveRequest} GetIvCurveRequest instance
             */
            GetIvCurveRequest.create = function create(properties) {
                return new GetIvCurveRequest(properties);
            };

            /**
             * Encodes the specified GetIvCurveRequest message. Does not implicitly {@link gateway.core.GetIvCurveRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.GetIvCurveRequest
             * @static
             * @param {gateway.core.IGetIvCurveRequest} message GetIvCurveRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetIvCurveRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.moduleUuid != null && Object.hasOwnProperty.call(message, "moduleUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.moduleUuid);
                return writer;
            };

            /**
             * Encodes the specified GetIvCurveRequest message, length delimited. Does not implicitly {@link gateway.core.GetIvCurveRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.GetIvCurveRequest
             * @static
             * @param {gateway.core.IGetIvCurveRequest} message GetIvCurveRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetIvCurveRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetIvCurveRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.GetIvCurveRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.GetIvCurveRequest} GetIvCurveRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetIvCurveRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.GetIvCurveRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.moduleUuid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetIvCurveRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.GetIvCurveRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.GetIvCurveRequest} GetIvCurveRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetIvCurveRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetIvCurveRequest message.
             * @function verify
             * @memberof gateway.core.GetIvCurveRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetIvCurveRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    if (!$util.isString(message.moduleUuid))
                        return "moduleUuid: string expected";
                return null;
            };

            /**
             * Creates a GetIvCurveRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.GetIvCurveRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.GetIvCurveRequest} GetIvCurveRequest
             */
            GetIvCurveRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.GetIvCurveRequest)
                    return object;
                var message = new $root.gateway.core.GetIvCurveRequest();
                if (object.moduleUuid != null)
                    message.moduleUuid = String(object.moduleUuid);
                return message;
            };

            /**
             * Creates a plain object from a GetIvCurveRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.GetIvCurveRequest
             * @static
             * @param {gateway.core.GetIvCurveRequest} message GetIvCurveRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetIvCurveRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.moduleUuid = "";
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    object.moduleUuid = message.moduleUuid;
                return object;
            };

            /**
             * Converts this GetIvCurveRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.GetIvCurveRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetIvCurveRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetIvCurveRequest;
        })();

        core.GetOperatingPowerRequest = (function() {

            /**
             * Properties of a GetOperatingPowerRequest.
             * @memberof gateway.core
             * @interface IGetOperatingPowerRequest
             * @property {string|null} [moduleUuid] GetOperatingPowerRequest moduleUuid
             */

            /**
             * Constructs a new GetOperatingPowerRequest.
             * @memberof gateway.core
             * @classdesc Represents a GetOperatingPowerRequest.
             * @implements IGetOperatingPowerRequest
             * @constructor
             * @param {gateway.core.IGetOperatingPowerRequest=} [properties] Properties to set
             */
            function GetOperatingPowerRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetOperatingPowerRequest moduleUuid.
             * @member {string} moduleUuid
             * @memberof gateway.core.GetOperatingPowerRequest
             * @instance
             */
            GetOperatingPowerRequest.prototype.moduleUuid = "";

            /**
             * Creates a new GetOperatingPowerRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.GetOperatingPowerRequest
             * @static
             * @param {gateway.core.IGetOperatingPowerRequest=} [properties] Properties to set
             * @returns {gateway.core.GetOperatingPowerRequest} GetOperatingPowerRequest instance
             */
            GetOperatingPowerRequest.create = function create(properties) {
                return new GetOperatingPowerRequest(properties);
            };

            /**
             * Encodes the specified GetOperatingPowerRequest message. Does not implicitly {@link gateway.core.GetOperatingPowerRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.GetOperatingPowerRequest
             * @static
             * @param {gateway.core.IGetOperatingPowerRequest} message GetOperatingPowerRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetOperatingPowerRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.moduleUuid != null && Object.hasOwnProperty.call(message, "moduleUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.moduleUuid);
                return writer;
            };

            /**
             * Encodes the specified GetOperatingPowerRequest message, length delimited. Does not implicitly {@link gateway.core.GetOperatingPowerRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.GetOperatingPowerRequest
             * @static
             * @param {gateway.core.IGetOperatingPowerRequest} message GetOperatingPowerRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetOperatingPowerRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetOperatingPowerRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.GetOperatingPowerRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.GetOperatingPowerRequest} GetOperatingPowerRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetOperatingPowerRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.GetOperatingPowerRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.moduleUuid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetOperatingPowerRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.GetOperatingPowerRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.GetOperatingPowerRequest} GetOperatingPowerRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetOperatingPowerRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetOperatingPowerRequest message.
             * @function verify
             * @memberof gateway.core.GetOperatingPowerRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetOperatingPowerRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    if (!$util.isString(message.moduleUuid))
                        return "moduleUuid: string expected";
                return null;
            };

            /**
             * Creates a GetOperatingPowerRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.GetOperatingPowerRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.GetOperatingPowerRequest} GetOperatingPowerRequest
             */
            GetOperatingPowerRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.GetOperatingPowerRequest)
                    return object;
                var message = new $root.gateway.core.GetOperatingPowerRequest();
                if (object.moduleUuid != null)
                    message.moduleUuid = String(object.moduleUuid);
                return message;
            };

            /**
             * Creates a plain object from a GetOperatingPowerRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.GetOperatingPowerRequest
             * @static
             * @param {gateway.core.GetOperatingPowerRequest} message GetOperatingPowerRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetOperatingPowerRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.moduleUuid = "";
                if (message.moduleUuid != null && message.hasOwnProperty("moduleUuid"))
                    object.moduleUuid = message.moduleUuid;
                return object;
            };

            /**
             * Converts this GetOperatingPowerRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.GetOperatingPowerRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetOperatingPowerRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetOperatingPowerRequest;
        })();

        core.Sensors = (function() {

            /**
             * Constructs a new Sensors service.
             * @memberof gateway.core
             * @classdesc Represents a Sensors
             * @extends $protobuf.rpc.Service
             * @constructor
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             */
            function Sensors(rpcImpl, requestDelimited, responseDelimited) {
                $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
            }

            (Sensors.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Sensors;

            /**
             * Creates new Sensors service using the specified rpc implementation.
             * @function create
             * @memberof gateway.core.Sensors
             * @static
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             * @returns {Sensors} RPC service. Useful where requests and/or responses are streamed.
             */
            Sensors.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                return new this(rpcImpl, requestDelimited, responseDelimited);
            };

            /**
             * Callback as used by {@link gateway.core.Sensors#list}.
             * @memberof gateway.core.Sensors
             * @typedef ListCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.ListSensorsResponse} [response] ListSensorsResponse
             */

            /**
             * Calls List.
             * @function list
             * @memberof gateway.core.Sensors
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @param {gateway.core.Sensors.ListCallback} callback Node-style callback called with the error, if any, and ListSensorsResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Sensors.prototype.list = function list(request, callback) {
                return this.rpcCall(list, $root.google.protobuf.Empty, $root.gateway.core.ListSensorsResponse, request, callback);
            }, "name", { value: "List" });

            /**
             * Calls List.
             * @function list
             * @memberof gateway.core.Sensors
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @returns {Promise<gateway.core.ListSensorsResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Sensors#link}.
             * @memberof gateway.core.Sensors
             * @typedef LinkCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls Link.
             * @function link
             * @memberof gateway.core.Sensors
             * @instance
             * @param {gateway.core.ILinkSensorRequest} request LinkSensorRequest message or plain object
             * @param {gateway.core.Sensors.LinkCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Sensors.prototype.link = function link(request, callback) {
                return this.rpcCall(link, $root.gateway.core.LinkSensorRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "Link" });

            /**
             * Calls Link.
             * @function link
             * @memberof gateway.core.Sensors
             * @instance
             * @param {gateway.core.ILinkSensorRequest} request LinkSensorRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Sensors#unlink}.
             * @memberof gateway.core.Sensors
             * @typedef UnlinkCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls Unlink.
             * @function unlink
             * @memberof gateway.core.Sensors
             * @instance
             * @param {gateway.core.IUnlinkSensorRequest} request UnlinkSensorRequest message or plain object
             * @param {gateway.core.Sensors.UnlinkCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Sensors.prototype.unlink = function unlink(request, callback) {
                return this.rpcCall(unlink, $root.gateway.core.UnlinkSensorRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "Unlink" });

            /**
             * Calls Unlink.
             * @function unlink
             * @memberof gateway.core.Sensors
             * @instance
             * @param {gateway.core.IUnlinkSensorRequest} request UnlinkSensorRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Sensors#getData}.
             * @memberof gateway.core.Sensors
             * @typedef GetDataCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.SensorDataMeasurement} [response] SensorDataMeasurement
             */

            /**
             * Calls GetData.
             * @function getData
             * @memberof gateway.core.Sensors
             * @instance
             * @param {gateway.core.IGetDataRequest} request GetDataRequest message or plain object
             * @param {gateway.core.Sensors.GetDataCallback} callback Node-style callback called with the error, if any, and SensorDataMeasurement
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Sensors.prototype.getData = function getData(request, callback) {
                return this.rpcCall(getData, $root.gateway.core.GetDataRequest, $root.gateway.core.SensorDataMeasurement, request, callback);
            }, "name", { value: "GetData" });

            /**
             * Calls GetData.
             * @function getData
             * @memberof gateway.core.Sensors
             * @instance
             * @param {gateway.core.IGetDataRequest} request GetDataRequest message or plain object
             * @returns {Promise<gateway.core.SensorDataMeasurement>} Promise
             * @variation 2
             */

            return Sensors;
        })();

        core.LinkSensorRequest = (function() {

            /**
             * Properties of a LinkSensorRequest.
             * @memberof gateway.core
             * @interface ILinkSensorRequest
             * @property {gateway.core.ISensor|null} [sensor] LinkSensorRequest sensor
             * @property {boolean|null} [force] LinkSensorRequest force
             */

            /**
             * Constructs a new LinkSensorRequest.
             * @memberof gateway.core
             * @classdesc Represents a LinkSensorRequest.
             * @implements ILinkSensorRequest
             * @constructor
             * @param {gateway.core.ILinkSensorRequest=} [properties] Properties to set
             */
            function LinkSensorRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LinkSensorRequest sensor.
             * @member {gateway.core.ISensor|null|undefined} sensor
             * @memberof gateway.core.LinkSensorRequest
             * @instance
             */
            LinkSensorRequest.prototype.sensor = null;

            /**
             * LinkSensorRequest force.
             * @member {boolean} force
             * @memberof gateway.core.LinkSensorRequest
             * @instance
             */
            LinkSensorRequest.prototype.force = false;

            /**
             * Creates a new LinkSensorRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.LinkSensorRequest
             * @static
             * @param {gateway.core.ILinkSensorRequest=} [properties] Properties to set
             * @returns {gateway.core.LinkSensorRequest} LinkSensorRequest instance
             */
            LinkSensorRequest.create = function create(properties) {
                return new LinkSensorRequest(properties);
            };

            /**
             * Encodes the specified LinkSensorRequest message. Does not implicitly {@link gateway.core.LinkSensorRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.LinkSensorRequest
             * @static
             * @param {gateway.core.ILinkSensorRequest} message LinkSensorRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LinkSensorRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sensor != null && Object.hasOwnProperty.call(message, "sensor"))
                    $root.gateway.core.Sensor.encode(message.sensor, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.force != null && Object.hasOwnProperty.call(message, "force"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.force);
                return writer;
            };

            /**
             * Encodes the specified LinkSensorRequest message, length delimited. Does not implicitly {@link gateway.core.LinkSensorRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.LinkSensorRequest
             * @static
             * @param {gateway.core.ILinkSensorRequest} message LinkSensorRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LinkSensorRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LinkSensorRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.LinkSensorRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.LinkSensorRequest} LinkSensorRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LinkSensorRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.LinkSensorRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.sensor = $root.gateway.core.Sensor.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.force = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LinkSensorRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.LinkSensorRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.LinkSensorRequest} LinkSensorRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LinkSensorRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LinkSensorRequest message.
             * @function verify
             * @memberof gateway.core.LinkSensorRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LinkSensorRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sensor != null && message.hasOwnProperty("sensor")) {
                    var error = $root.gateway.core.Sensor.verify(message.sensor);
                    if (error)
                        return "sensor." + error;
                }
                if (message.force != null && message.hasOwnProperty("force"))
                    if (typeof message.force !== "boolean")
                        return "force: boolean expected";
                return null;
            };

            /**
             * Creates a LinkSensorRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.LinkSensorRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.LinkSensorRequest} LinkSensorRequest
             */
            LinkSensorRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.LinkSensorRequest)
                    return object;
                var message = new $root.gateway.core.LinkSensorRequest();
                if (object.sensor != null) {
                    if (typeof object.sensor !== "object")
                        throw TypeError(".gateway.core.LinkSensorRequest.sensor: object expected");
                    message.sensor = $root.gateway.core.Sensor.fromObject(object.sensor);
                }
                if (object.force != null)
                    message.force = Boolean(object.force);
                return message;
            };

            /**
             * Creates a plain object from a LinkSensorRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.LinkSensorRequest
             * @static
             * @param {gateway.core.LinkSensorRequest} message LinkSensorRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LinkSensorRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.sensor = null;
                    object.force = false;
                }
                if (message.sensor != null && message.hasOwnProperty("sensor"))
                    object.sensor = $root.gateway.core.Sensor.toObject(message.sensor, options);
                if (message.force != null && message.hasOwnProperty("force"))
                    object.force = message.force;
                return object;
            };

            /**
             * Converts this LinkSensorRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.LinkSensorRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LinkSensorRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return LinkSensorRequest;
        })();

        core.UnlinkSensorRequest = (function() {

            /**
             * Properties of an UnlinkSensorRequest.
             * @memberof gateway.core
             * @interface IUnlinkSensorRequest
             * @property {string|null} [sensorUuid] UnlinkSensorRequest sensorUuid
             */

            /**
             * Constructs a new UnlinkSensorRequest.
             * @memberof gateway.core
             * @classdesc Represents an UnlinkSensorRequest.
             * @implements IUnlinkSensorRequest
             * @constructor
             * @param {gateway.core.IUnlinkSensorRequest=} [properties] Properties to set
             */
            function UnlinkSensorRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UnlinkSensorRequest sensorUuid.
             * @member {string} sensorUuid
             * @memberof gateway.core.UnlinkSensorRequest
             * @instance
             */
            UnlinkSensorRequest.prototype.sensorUuid = "";

            /**
             * Creates a new UnlinkSensorRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.UnlinkSensorRequest
             * @static
             * @param {gateway.core.IUnlinkSensorRequest=} [properties] Properties to set
             * @returns {gateway.core.UnlinkSensorRequest} UnlinkSensorRequest instance
             */
            UnlinkSensorRequest.create = function create(properties) {
                return new UnlinkSensorRequest(properties);
            };

            /**
             * Encodes the specified UnlinkSensorRequest message. Does not implicitly {@link gateway.core.UnlinkSensorRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.UnlinkSensorRequest
             * @static
             * @param {gateway.core.IUnlinkSensorRequest} message UnlinkSensorRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnlinkSensorRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sensorUuid != null && Object.hasOwnProperty.call(message, "sensorUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sensorUuid);
                return writer;
            };

            /**
             * Encodes the specified UnlinkSensorRequest message, length delimited. Does not implicitly {@link gateway.core.UnlinkSensorRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.UnlinkSensorRequest
             * @static
             * @param {gateway.core.IUnlinkSensorRequest} message UnlinkSensorRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnlinkSensorRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UnlinkSensorRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.UnlinkSensorRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.UnlinkSensorRequest} UnlinkSensorRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnlinkSensorRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.UnlinkSensorRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.sensorUuid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UnlinkSensorRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.UnlinkSensorRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.UnlinkSensorRequest} UnlinkSensorRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnlinkSensorRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UnlinkSensorRequest message.
             * @function verify
             * @memberof gateway.core.UnlinkSensorRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UnlinkSensorRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sensorUuid != null && message.hasOwnProperty("sensorUuid"))
                    if (!$util.isString(message.sensorUuid))
                        return "sensorUuid: string expected";
                return null;
            };

            /**
             * Creates an UnlinkSensorRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.UnlinkSensorRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.UnlinkSensorRequest} UnlinkSensorRequest
             */
            UnlinkSensorRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.UnlinkSensorRequest)
                    return object;
                var message = new $root.gateway.core.UnlinkSensorRequest();
                if (object.sensorUuid != null)
                    message.sensorUuid = String(object.sensorUuid);
                return message;
            };

            /**
             * Creates a plain object from an UnlinkSensorRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.UnlinkSensorRequest
             * @static
             * @param {gateway.core.UnlinkSensorRequest} message UnlinkSensorRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UnlinkSensorRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.sensorUuid = "";
                if (message.sensorUuid != null && message.hasOwnProperty("sensorUuid"))
                    object.sensorUuid = message.sensorUuid;
                return object;
            };

            /**
             * Converts this UnlinkSensorRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.UnlinkSensorRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UnlinkSensorRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UnlinkSensorRequest;
        })();

        core.UpdateSensorRequest = (function() {

            /**
             * Properties of an UpdateSensorRequest.
             * @memberof gateway.core
             * @interface IUpdateSensorRequest
             * @property {string|null} [sensorUuid] UpdateSensorRequest sensorUuid
             * @property {gateway.core.ISensor|null} [sensor] UpdateSensorRequest sensor
             * @property {boolean|null} [force] UpdateSensorRequest force
             * @property {boolean|null} [incremental] UpdateSensorRequest incremental
             */

            /**
             * Constructs a new UpdateSensorRequest.
             * @memberof gateway.core
             * @classdesc Represents an UpdateSensorRequest.
             * @implements IUpdateSensorRequest
             * @constructor
             * @param {gateway.core.IUpdateSensorRequest=} [properties] Properties to set
             */
            function UpdateSensorRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UpdateSensorRequest sensorUuid.
             * @member {string} sensorUuid
             * @memberof gateway.core.UpdateSensorRequest
             * @instance
             */
            UpdateSensorRequest.prototype.sensorUuid = "";

            /**
             * UpdateSensorRequest sensor.
             * @member {gateway.core.ISensor|null|undefined} sensor
             * @memberof gateway.core.UpdateSensorRequest
             * @instance
             */
            UpdateSensorRequest.prototype.sensor = null;

            /**
             * UpdateSensorRequest force.
             * @member {boolean} force
             * @memberof gateway.core.UpdateSensorRequest
             * @instance
             */
            UpdateSensorRequest.prototype.force = false;

            /**
             * UpdateSensorRequest incremental.
             * @member {boolean} incremental
             * @memberof gateway.core.UpdateSensorRequest
             * @instance
             */
            UpdateSensorRequest.prototype.incremental = false;

            /**
             * Creates a new UpdateSensorRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.UpdateSensorRequest
             * @static
             * @param {gateway.core.IUpdateSensorRequest=} [properties] Properties to set
             * @returns {gateway.core.UpdateSensorRequest} UpdateSensorRequest instance
             */
            UpdateSensorRequest.create = function create(properties) {
                return new UpdateSensorRequest(properties);
            };

            /**
             * Encodes the specified UpdateSensorRequest message. Does not implicitly {@link gateway.core.UpdateSensorRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.UpdateSensorRequest
             * @static
             * @param {gateway.core.IUpdateSensorRequest} message UpdateSensorRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSensorRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sensorUuid != null && Object.hasOwnProperty.call(message, "sensorUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sensorUuid);
                if (message.sensor != null && Object.hasOwnProperty.call(message, "sensor"))
                    $root.gateway.core.Sensor.encode(message.sensor, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.force != null && Object.hasOwnProperty.call(message, "force"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.force);
                if (message.incremental != null && Object.hasOwnProperty.call(message, "incremental"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.incremental);
                return writer;
            };

            /**
             * Encodes the specified UpdateSensorRequest message, length delimited. Does not implicitly {@link gateway.core.UpdateSensorRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.UpdateSensorRequest
             * @static
             * @param {gateway.core.IUpdateSensorRequest} message UpdateSensorRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UpdateSensorRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UpdateSensorRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.UpdateSensorRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.UpdateSensorRequest} UpdateSensorRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSensorRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.UpdateSensorRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.sensorUuid = reader.string();
                        break;
                    case 2:
                        message.sensor = $root.gateway.core.Sensor.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.force = reader.bool();
                        break;
                    case 4:
                        message.incremental = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UpdateSensorRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.UpdateSensorRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.UpdateSensorRequest} UpdateSensorRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UpdateSensorRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UpdateSensorRequest message.
             * @function verify
             * @memberof gateway.core.UpdateSensorRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UpdateSensorRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sensorUuid != null && message.hasOwnProperty("sensorUuid"))
                    if (!$util.isString(message.sensorUuid))
                        return "sensorUuid: string expected";
                if (message.sensor != null && message.hasOwnProperty("sensor")) {
                    var error = $root.gateway.core.Sensor.verify(message.sensor);
                    if (error)
                        return "sensor." + error;
                }
                if (message.force != null && message.hasOwnProperty("force"))
                    if (typeof message.force !== "boolean")
                        return "force: boolean expected";
                if (message.incremental != null && message.hasOwnProperty("incremental"))
                    if (typeof message.incremental !== "boolean")
                        return "incremental: boolean expected";
                return null;
            };

            /**
             * Creates an UpdateSensorRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.UpdateSensorRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.UpdateSensorRequest} UpdateSensorRequest
             */
            UpdateSensorRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.UpdateSensorRequest)
                    return object;
                var message = new $root.gateway.core.UpdateSensorRequest();
                if (object.sensorUuid != null)
                    message.sensorUuid = String(object.sensorUuid);
                if (object.sensor != null) {
                    if (typeof object.sensor !== "object")
                        throw TypeError(".gateway.core.UpdateSensorRequest.sensor: object expected");
                    message.sensor = $root.gateway.core.Sensor.fromObject(object.sensor);
                }
                if (object.force != null)
                    message.force = Boolean(object.force);
                if (object.incremental != null)
                    message.incremental = Boolean(object.incremental);
                return message;
            };

            /**
             * Creates a plain object from an UpdateSensorRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.UpdateSensorRequest
             * @static
             * @param {gateway.core.UpdateSensorRequest} message UpdateSensorRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UpdateSensorRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.sensorUuid = "";
                    object.sensor = null;
                    object.force = false;
                    object.incremental = false;
                }
                if (message.sensorUuid != null && message.hasOwnProperty("sensorUuid"))
                    object.sensorUuid = message.sensorUuid;
                if (message.sensor != null && message.hasOwnProperty("sensor"))
                    object.sensor = $root.gateway.core.Sensor.toObject(message.sensor, options);
                if (message.force != null && message.hasOwnProperty("force"))
                    object.force = message.force;
                if (message.incremental != null && message.hasOwnProperty("incremental"))
                    object.incremental = message.incremental;
                return object;
            };

            /**
             * Converts this UpdateSensorRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.UpdateSensorRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UpdateSensorRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UpdateSensorRequest;
        })();

        core.ListSensorsResponse = (function() {

            /**
             * Properties of a ListSensorsResponse.
             * @memberof gateway.core
             * @interface IListSensorsResponse
             * @property {Array.<gateway.core.ISensor>|null} [sensors] ListSensorsResponse sensors
             */

            /**
             * Constructs a new ListSensorsResponse.
             * @memberof gateway.core
             * @classdesc Represents a ListSensorsResponse.
             * @implements IListSensorsResponse
             * @constructor
             * @param {gateway.core.IListSensorsResponse=} [properties] Properties to set
             */
            function ListSensorsResponse(properties) {
                this.sensors = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListSensorsResponse sensors.
             * @member {Array.<gateway.core.ISensor>} sensors
             * @memberof gateway.core.ListSensorsResponse
             * @instance
             */
            ListSensorsResponse.prototype.sensors = $util.emptyArray;

            /**
             * Creates a new ListSensorsResponse instance using the specified properties.
             * @function create
             * @memberof gateway.core.ListSensorsResponse
             * @static
             * @param {gateway.core.IListSensorsResponse=} [properties] Properties to set
             * @returns {gateway.core.ListSensorsResponse} ListSensorsResponse instance
             */
            ListSensorsResponse.create = function create(properties) {
                return new ListSensorsResponse(properties);
            };

            /**
             * Encodes the specified ListSensorsResponse message. Does not implicitly {@link gateway.core.ListSensorsResponse.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ListSensorsResponse
             * @static
             * @param {gateway.core.IListSensorsResponse} message ListSensorsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListSensorsResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sensors != null && message.sensors.length)
                    for (var i = 0; i < message.sensors.length; ++i)
                        $root.gateway.core.Sensor.encode(message.sensors[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ListSensorsResponse message, length delimited. Does not implicitly {@link gateway.core.ListSensorsResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ListSensorsResponse
             * @static
             * @param {gateway.core.IListSensorsResponse} message ListSensorsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListSensorsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListSensorsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ListSensorsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ListSensorsResponse} ListSensorsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListSensorsResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ListSensorsResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.sensors && message.sensors.length))
                            message.sensors = [];
                        message.sensors.push($root.gateway.core.Sensor.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListSensorsResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ListSensorsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ListSensorsResponse} ListSensorsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListSensorsResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListSensorsResponse message.
             * @function verify
             * @memberof gateway.core.ListSensorsResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListSensorsResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sensors != null && message.hasOwnProperty("sensors")) {
                    if (!Array.isArray(message.sensors))
                        return "sensors: array expected";
                    for (var i = 0; i < message.sensors.length; ++i) {
                        var error = $root.gateway.core.Sensor.verify(message.sensors[i]);
                        if (error)
                            return "sensors." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ListSensorsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ListSensorsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ListSensorsResponse} ListSensorsResponse
             */
            ListSensorsResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ListSensorsResponse)
                    return object;
                var message = new $root.gateway.core.ListSensorsResponse();
                if (object.sensors) {
                    if (!Array.isArray(object.sensors))
                        throw TypeError(".gateway.core.ListSensorsResponse.sensors: array expected");
                    message.sensors = [];
                    for (var i = 0; i < object.sensors.length; ++i) {
                        if (typeof object.sensors[i] !== "object")
                            throw TypeError(".gateway.core.ListSensorsResponse.sensors: object expected");
                        message.sensors[i] = $root.gateway.core.Sensor.fromObject(object.sensors[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ListSensorsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ListSensorsResponse
             * @static
             * @param {gateway.core.ListSensorsResponse} message ListSensorsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListSensorsResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.sensors = [];
                if (message.sensors && message.sensors.length) {
                    object.sensors = [];
                    for (var j = 0; j < message.sensors.length; ++j)
                        object.sensors[j] = $root.gateway.core.Sensor.toObject(message.sensors[j], options);
                }
                return object;
            };

            /**
             * Converts this ListSensorsResponse to JSON.
             * @function toJSON
             * @memberof gateway.core.ListSensorsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListSensorsResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ListSensorsResponse;
        })();

        core.ListModbusTransportsResponse = (function() {

            /**
             * Properties of a ListModbusTransportsResponse.
             * @memberof gateway.core
             * @interface IListModbusTransportsResponse
             * @property {Array.<gateway.core.IModbusTransport>|null} [transports] ListModbusTransportsResponse transports
             */

            /**
             * Constructs a new ListModbusTransportsResponse.
             * @memberof gateway.core
             * @classdesc Represents a ListModbusTransportsResponse.
             * @implements IListModbusTransportsResponse
             * @constructor
             * @param {gateway.core.IListModbusTransportsResponse=} [properties] Properties to set
             */
            function ListModbusTransportsResponse(properties) {
                this.transports = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListModbusTransportsResponse transports.
             * @member {Array.<gateway.core.IModbusTransport>} transports
             * @memberof gateway.core.ListModbusTransportsResponse
             * @instance
             */
            ListModbusTransportsResponse.prototype.transports = $util.emptyArray;

            /**
             * Creates a new ListModbusTransportsResponse instance using the specified properties.
             * @function create
             * @memberof gateway.core.ListModbusTransportsResponse
             * @static
             * @param {gateway.core.IListModbusTransportsResponse=} [properties] Properties to set
             * @returns {gateway.core.ListModbusTransportsResponse} ListModbusTransportsResponse instance
             */
            ListModbusTransportsResponse.create = function create(properties) {
                return new ListModbusTransportsResponse(properties);
            };

            /**
             * Encodes the specified ListModbusTransportsResponse message. Does not implicitly {@link gateway.core.ListModbusTransportsResponse.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ListModbusTransportsResponse
             * @static
             * @param {gateway.core.IListModbusTransportsResponse} message ListModbusTransportsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListModbusTransportsResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transports != null && message.transports.length)
                    for (var i = 0; i < message.transports.length; ++i)
                        $root.gateway.core.ModbusTransport.encode(message.transports[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ListModbusTransportsResponse message, length delimited. Does not implicitly {@link gateway.core.ListModbusTransportsResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ListModbusTransportsResponse
             * @static
             * @param {gateway.core.IListModbusTransportsResponse} message ListModbusTransportsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListModbusTransportsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListModbusTransportsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ListModbusTransportsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ListModbusTransportsResponse} ListModbusTransportsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListModbusTransportsResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ListModbusTransportsResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.transports && message.transports.length))
                            message.transports = [];
                        message.transports.push($root.gateway.core.ModbusTransport.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListModbusTransportsResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ListModbusTransportsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ListModbusTransportsResponse} ListModbusTransportsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListModbusTransportsResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListModbusTransportsResponse message.
             * @function verify
             * @memberof gateway.core.ListModbusTransportsResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListModbusTransportsResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transports != null && message.hasOwnProperty("transports")) {
                    if (!Array.isArray(message.transports))
                        return "transports: array expected";
                    for (var i = 0; i < message.transports.length; ++i) {
                        var error = $root.gateway.core.ModbusTransport.verify(message.transports[i]);
                        if (error)
                            return "transports." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ListModbusTransportsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ListModbusTransportsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ListModbusTransportsResponse} ListModbusTransportsResponse
             */
            ListModbusTransportsResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ListModbusTransportsResponse)
                    return object;
                var message = new $root.gateway.core.ListModbusTransportsResponse();
                if (object.transports) {
                    if (!Array.isArray(object.transports))
                        throw TypeError(".gateway.core.ListModbusTransportsResponse.transports: array expected");
                    message.transports = [];
                    for (var i = 0; i < object.transports.length; ++i) {
                        if (typeof object.transports[i] !== "object")
                            throw TypeError(".gateway.core.ListModbusTransportsResponse.transports: object expected");
                        message.transports[i] = $root.gateway.core.ModbusTransport.fromObject(object.transports[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ListModbusTransportsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ListModbusTransportsResponse
             * @static
             * @param {gateway.core.ListModbusTransportsResponse} message ListModbusTransportsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListModbusTransportsResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.transports = [];
                if (message.transports && message.transports.length) {
                    object.transports = [];
                    for (var j = 0; j < message.transports.length; ++j)
                        object.transports[j] = $root.gateway.core.ModbusTransport.toObject(message.transports[j], options);
                }
                return object;
            };

            /**
             * Converts this ListModbusTransportsResponse to JSON.
             * @function toJSON
             * @memberof gateway.core.ListModbusTransportsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListModbusTransportsResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ListModbusTransportsResponse;
        })();

        core.GetDataRequest = (function() {

            /**
             * Properties of a GetDataRequest.
             * @memberof gateway.core
             * @interface IGetDataRequest
             * @property {string|null} [sensorUuid] GetDataRequest sensorUuid
             */

            /**
             * Constructs a new GetDataRequest.
             * @memberof gateway.core
             * @classdesc Represents a GetDataRequest.
             * @implements IGetDataRequest
             * @constructor
             * @param {gateway.core.IGetDataRequest=} [properties] Properties to set
             */
            function GetDataRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetDataRequest sensorUuid.
             * @member {string} sensorUuid
             * @memberof gateway.core.GetDataRequest
             * @instance
             */
            GetDataRequest.prototype.sensorUuid = "";

            /**
             * Creates a new GetDataRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.GetDataRequest
             * @static
             * @param {gateway.core.IGetDataRequest=} [properties] Properties to set
             * @returns {gateway.core.GetDataRequest} GetDataRequest instance
             */
            GetDataRequest.create = function create(properties) {
                return new GetDataRequest(properties);
            };

            /**
             * Encodes the specified GetDataRequest message. Does not implicitly {@link gateway.core.GetDataRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.GetDataRequest
             * @static
             * @param {gateway.core.IGetDataRequest} message GetDataRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDataRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sensorUuid != null && Object.hasOwnProperty.call(message, "sensorUuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sensorUuid);
                return writer;
            };

            /**
             * Encodes the specified GetDataRequest message, length delimited. Does not implicitly {@link gateway.core.GetDataRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.GetDataRequest
             * @static
             * @param {gateway.core.IGetDataRequest} message GetDataRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetDataRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.GetDataRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.GetDataRequest} GetDataRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDataRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.GetDataRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.sensorUuid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetDataRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.GetDataRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.GetDataRequest} GetDataRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDataRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetDataRequest message.
             * @function verify
             * @memberof gateway.core.GetDataRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetDataRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sensorUuid != null && message.hasOwnProperty("sensorUuid"))
                    if (!$util.isString(message.sensorUuid))
                        return "sensorUuid: string expected";
                return null;
            };

            /**
             * Creates a GetDataRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.GetDataRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.GetDataRequest} GetDataRequest
             */
            GetDataRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.GetDataRequest)
                    return object;
                var message = new $root.gateway.core.GetDataRequest();
                if (object.sensorUuid != null)
                    message.sensorUuid = String(object.sensorUuid);
                return message;
            };

            /**
             * Creates a plain object from a GetDataRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.GetDataRequest
             * @static
             * @param {gateway.core.GetDataRequest} message GetDataRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetDataRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.sensorUuid = "";
                if (message.sensorUuid != null && message.hasOwnProperty("sensorUuid"))
                    object.sensorUuid = message.sensorUuid;
                return object;
            };

            /**
             * Converts this GetDataRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.GetDataRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetDataRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GetDataRequest;
        })();

        core.Sensor = (function() {

            /**
             * Properties of a Sensor.
             * @memberof gateway.core
             * @interface ISensor
             * @property {string|null} [uuid] Sensor uuid
             * @property {string|null} [name] Sensor name
             * @property {gateway.core.ICollectionSpec|null} [collectionSpec] Sensor collectionSpec
             * @property {gateway.core.ITelemetrySpec|null} [telemetrySpec] Sensor telemetrySpec
             */

            /**
             * Constructs a new Sensor.
             * @memberof gateway.core
             * @classdesc Represents a Sensor.
             * @implements ISensor
             * @constructor
             * @param {gateway.core.ISensor=} [properties] Properties to set
             */
            function Sensor(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Sensor uuid.
             * @member {string} uuid
             * @memberof gateway.core.Sensor
             * @instance
             */
            Sensor.prototype.uuid = "";

            /**
             * Sensor name.
             * @member {string} name
             * @memberof gateway.core.Sensor
             * @instance
             */
            Sensor.prototype.name = "";

            /**
             * Sensor collectionSpec.
             * @member {gateway.core.ICollectionSpec|null|undefined} collectionSpec
             * @memberof gateway.core.Sensor
             * @instance
             */
            Sensor.prototype.collectionSpec = null;

            /**
             * Sensor telemetrySpec.
             * @member {gateway.core.ITelemetrySpec|null|undefined} telemetrySpec
             * @memberof gateway.core.Sensor
             * @instance
             */
            Sensor.prototype.telemetrySpec = null;

            /**
             * Creates a new Sensor instance using the specified properties.
             * @function create
             * @memberof gateway.core.Sensor
             * @static
             * @param {gateway.core.ISensor=} [properties] Properties to set
             * @returns {gateway.core.Sensor} Sensor instance
             */
            Sensor.create = function create(properties) {
                return new Sensor(properties);
            };

            /**
             * Encodes the specified Sensor message. Does not implicitly {@link gateway.core.Sensor.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.Sensor
             * @static
             * @param {gateway.core.ISensor} message Sensor message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Sensor.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.uuid);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.collectionSpec != null && Object.hasOwnProperty.call(message, "collectionSpec"))
                    $root.gateway.core.CollectionSpec.encode(message.collectionSpec, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.telemetrySpec != null && Object.hasOwnProperty.call(message, "telemetrySpec"))
                    $root.gateway.core.TelemetrySpec.encode(message.telemetrySpec, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Sensor message, length delimited. Does not implicitly {@link gateway.core.Sensor.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.Sensor
             * @static
             * @param {gateway.core.ISensor} message Sensor message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Sensor.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Sensor message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.Sensor
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.Sensor} Sensor
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Sensor.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.Sensor();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.uuid = reader.string();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.collectionSpec = $root.gateway.core.CollectionSpec.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.telemetrySpec = $root.gateway.core.TelemetrySpec.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Sensor message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.Sensor
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.Sensor} Sensor
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Sensor.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Sensor message.
             * @function verify
             * @memberof gateway.core.Sensor
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Sensor.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    if (!$util.isString(message.uuid))
                        return "uuid: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.collectionSpec != null && message.hasOwnProperty("collectionSpec")) {
                    var error = $root.gateway.core.CollectionSpec.verify(message.collectionSpec);
                    if (error)
                        return "collectionSpec." + error;
                }
                if (message.telemetrySpec != null && message.hasOwnProperty("telemetrySpec")) {
                    var error = $root.gateway.core.TelemetrySpec.verify(message.telemetrySpec);
                    if (error)
                        return "telemetrySpec." + error;
                }
                return null;
            };

            /**
             * Creates a Sensor message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.Sensor
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.Sensor} Sensor
             */
            Sensor.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.Sensor)
                    return object;
                var message = new $root.gateway.core.Sensor();
                if (object.uuid != null)
                    message.uuid = String(object.uuid);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.collectionSpec != null) {
                    if (typeof object.collectionSpec !== "object")
                        throw TypeError(".gateway.core.Sensor.collectionSpec: object expected");
                    message.collectionSpec = $root.gateway.core.CollectionSpec.fromObject(object.collectionSpec);
                }
                if (object.telemetrySpec != null) {
                    if (typeof object.telemetrySpec !== "object")
                        throw TypeError(".gateway.core.Sensor.telemetrySpec: object expected");
                    message.telemetrySpec = $root.gateway.core.TelemetrySpec.fromObject(object.telemetrySpec);
                }
                return message;
            };

            /**
             * Creates a plain object from a Sensor message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.Sensor
             * @static
             * @param {gateway.core.Sensor} message Sensor
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Sensor.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.uuid = "";
                    object.name = "";
                    object.collectionSpec = null;
                    object.telemetrySpec = null;
                }
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    object.uuid = message.uuid;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.collectionSpec != null && message.hasOwnProperty("collectionSpec"))
                    object.collectionSpec = $root.gateway.core.CollectionSpec.toObject(message.collectionSpec, options);
                if (message.telemetrySpec != null && message.hasOwnProperty("telemetrySpec"))
                    object.telemetrySpec = $root.gateway.core.TelemetrySpec.toObject(message.telemetrySpec, options);
                return object;
            };

            /**
             * Converts this Sensor to JSON.
             * @function toJSON
             * @memberof gateway.core.Sensor
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Sensor.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Sensor;
        })();

        core.CollectionSpec = (function() {

            /**
             * Properties of a CollectionSpec.
             * @memberof gateway.core
             * @interface ICollectionSpec
             * @property {number|null} [interval] CollectionSpec interval
             * @property {gateway.core.IModbusCollectionSpec|null} [modbus] CollectionSpec modbus
             */

            /**
             * Constructs a new CollectionSpec.
             * @memberof gateway.core
             * @classdesc Represents a CollectionSpec.
             * @implements ICollectionSpec
             * @constructor
             * @param {gateway.core.ICollectionSpec=} [properties] Properties to set
             */
            function CollectionSpec(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CollectionSpec interval.
             * @member {number|null|undefined} interval
             * @memberof gateway.core.CollectionSpec
             * @instance
             */
            CollectionSpec.prototype.interval = null;

            /**
             * CollectionSpec modbus.
             * @member {gateway.core.IModbusCollectionSpec|null|undefined} modbus
             * @memberof gateway.core.CollectionSpec
             * @instance
             */
            CollectionSpec.prototype.modbus = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * CollectionSpec optional.
             * @member {"interval"|undefined} optional
             * @memberof gateway.core.CollectionSpec
             * @instance
             */
            Object.defineProperty(CollectionSpec.prototype, "optional", {
                get: $util.oneOfGetter($oneOfFields = ["interval"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * CollectionSpec kind.
             * @member {"modbus"|undefined} kind
             * @memberof gateway.core.CollectionSpec
             * @instance
             */
            Object.defineProperty(CollectionSpec.prototype, "kind", {
                get: $util.oneOfGetter($oneOfFields = ["modbus"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new CollectionSpec instance using the specified properties.
             * @function create
             * @memberof gateway.core.CollectionSpec
             * @static
             * @param {gateway.core.ICollectionSpec=} [properties] Properties to set
             * @returns {gateway.core.CollectionSpec} CollectionSpec instance
             */
            CollectionSpec.create = function create(properties) {
                return new CollectionSpec(properties);
            };

            /**
             * Encodes the specified CollectionSpec message. Does not implicitly {@link gateway.core.CollectionSpec.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.CollectionSpec
             * @static
             * @param {gateway.core.ICollectionSpec} message CollectionSpec message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CollectionSpec.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.interval != null && Object.hasOwnProperty.call(message, "interval"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.interval);
                if (message.modbus != null && Object.hasOwnProperty.call(message, "modbus"))
                    $root.gateway.core.ModbusCollectionSpec.encode(message.modbus, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CollectionSpec message, length delimited. Does not implicitly {@link gateway.core.CollectionSpec.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.CollectionSpec
             * @static
             * @param {gateway.core.ICollectionSpec} message CollectionSpec message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CollectionSpec.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CollectionSpec message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.CollectionSpec
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.CollectionSpec} CollectionSpec
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CollectionSpec.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.CollectionSpec();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.interval = reader.uint32();
                        break;
                    case 2:
                        message.modbus = $root.gateway.core.ModbusCollectionSpec.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CollectionSpec message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.CollectionSpec
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.CollectionSpec} CollectionSpec
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CollectionSpec.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CollectionSpec message.
             * @function verify
             * @memberof gateway.core.CollectionSpec
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CollectionSpec.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.interval != null && message.hasOwnProperty("interval")) {
                    properties.optional = 1;
                    if (!$util.isInteger(message.interval))
                        return "interval: integer expected";
                }
                if (message.modbus != null && message.hasOwnProperty("modbus")) {
                    properties.kind = 1;
                    {
                        var error = $root.gateway.core.ModbusCollectionSpec.verify(message.modbus);
                        if (error)
                            return "modbus." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a CollectionSpec message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.CollectionSpec
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.CollectionSpec} CollectionSpec
             */
            CollectionSpec.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.CollectionSpec)
                    return object;
                var message = new $root.gateway.core.CollectionSpec();
                if (object.interval != null)
                    message.interval = object.interval >>> 0;
                if (object.modbus != null) {
                    if (typeof object.modbus !== "object")
                        throw TypeError(".gateway.core.CollectionSpec.modbus: object expected");
                    message.modbus = $root.gateway.core.ModbusCollectionSpec.fromObject(object.modbus);
                }
                return message;
            };

            /**
             * Creates a plain object from a CollectionSpec message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.CollectionSpec
             * @static
             * @param {gateway.core.CollectionSpec} message CollectionSpec
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CollectionSpec.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (message.interval != null && message.hasOwnProperty("interval")) {
                    object.interval = message.interval;
                    if (options.oneofs)
                        object.optional = "interval";
                }
                if (message.modbus != null && message.hasOwnProperty("modbus")) {
                    object.modbus = $root.gateway.core.ModbusCollectionSpec.toObject(message.modbus, options);
                    if (options.oneofs)
                        object.kind = "modbus";
                }
                return object;
            };

            /**
             * Converts this CollectionSpec to JSON.
             * @function toJSON
             * @memberof gateway.core.CollectionSpec
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CollectionSpec.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CollectionSpec;
        })();

        core.TelemetrySpec = (function() {

            /**
             * Properties of a TelemetrySpec.
             * @memberof gateway.core
             * @interface ITelemetrySpec
             * @property {string|null} [type] TelemetrySpec type
             * @property {Object.<string,gateway.core.IDataValueSpec>|null} [dataSpec] TelemetrySpec dataSpec
             * @property {Array.<string>|null} [dataMappers] TelemetrySpec dataMappers
             */

            /**
             * Constructs a new TelemetrySpec.
             * @memberof gateway.core
             * @classdesc Represents a TelemetrySpec.
             * @implements ITelemetrySpec
             * @constructor
             * @param {gateway.core.ITelemetrySpec=} [properties] Properties to set
             */
            function TelemetrySpec(properties) {
                this.dataSpec = {};
                this.dataMappers = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TelemetrySpec type.
             * @member {string} type
             * @memberof gateway.core.TelemetrySpec
             * @instance
             */
            TelemetrySpec.prototype.type = "";

            /**
             * TelemetrySpec dataSpec.
             * @member {Object.<string,gateway.core.IDataValueSpec>} dataSpec
             * @memberof gateway.core.TelemetrySpec
             * @instance
             */
            TelemetrySpec.prototype.dataSpec = $util.emptyObject;

            /**
             * TelemetrySpec dataMappers.
             * @member {Array.<string>} dataMappers
             * @memberof gateway.core.TelemetrySpec
             * @instance
             */
            TelemetrySpec.prototype.dataMappers = $util.emptyArray;

            /**
             * Creates a new TelemetrySpec instance using the specified properties.
             * @function create
             * @memberof gateway.core.TelemetrySpec
             * @static
             * @param {gateway.core.ITelemetrySpec=} [properties] Properties to set
             * @returns {gateway.core.TelemetrySpec} TelemetrySpec instance
             */
            TelemetrySpec.create = function create(properties) {
                return new TelemetrySpec(properties);
            };

            /**
             * Encodes the specified TelemetrySpec message. Does not implicitly {@link gateway.core.TelemetrySpec.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.TelemetrySpec
             * @static
             * @param {gateway.core.ITelemetrySpec} message TelemetrySpec message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TelemetrySpec.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.dataSpec != null && Object.hasOwnProperty.call(message, "dataSpec"))
                    for (var keys = Object.keys(message.dataSpec), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.gateway.core.DataValueSpec.encode(message.dataSpec[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                if (message.dataMappers != null && message.dataMappers.length)
                    for (var i = 0; i < message.dataMappers.length; ++i)
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.dataMappers[i]);
                return writer;
            };

            /**
             * Encodes the specified TelemetrySpec message, length delimited. Does not implicitly {@link gateway.core.TelemetrySpec.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.TelemetrySpec
             * @static
             * @param {gateway.core.ITelemetrySpec} message TelemetrySpec message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TelemetrySpec.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TelemetrySpec message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.TelemetrySpec
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.TelemetrySpec} TelemetrySpec
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TelemetrySpec.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.TelemetrySpec(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.string();
                        break;
                    case 2:
                        if (message.dataSpec === $util.emptyObject)
                            message.dataSpec = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.gateway.core.DataValueSpec.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.dataSpec[key] = value;
                        break;
                    case 3:
                        if (!(message.dataMappers && message.dataMappers.length))
                            message.dataMappers = [];
                        message.dataMappers.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TelemetrySpec message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.TelemetrySpec
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.TelemetrySpec} TelemetrySpec
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TelemetrySpec.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TelemetrySpec message.
             * @function verify
             * @memberof gateway.core.TelemetrySpec
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TelemetrySpec.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.dataSpec != null && message.hasOwnProperty("dataSpec")) {
                    if (!$util.isObject(message.dataSpec))
                        return "dataSpec: object expected";
                    var key = Object.keys(message.dataSpec);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.gateway.core.DataValueSpec.verify(message.dataSpec[key[i]]);
                        if (error)
                            return "dataSpec." + error;
                    }
                }
                if (message.dataMappers != null && message.hasOwnProperty("dataMappers")) {
                    if (!Array.isArray(message.dataMappers))
                        return "dataMappers: array expected";
                    for (var i = 0; i < message.dataMappers.length; ++i)
                        if (!$util.isString(message.dataMappers[i]))
                            return "dataMappers: string[] expected";
                }
                return null;
            };

            /**
             * Creates a TelemetrySpec message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.TelemetrySpec
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.TelemetrySpec} TelemetrySpec
             */
            TelemetrySpec.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.TelemetrySpec)
                    return object;
                var message = new $root.gateway.core.TelemetrySpec();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.dataSpec) {
                    if (typeof object.dataSpec !== "object")
                        throw TypeError(".gateway.core.TelemetrySpec.dataSpec: object expected");
                    message.dataSpec = {};
                    for (var keys = Object.keys(object.dataSpec), i = 0; i < keys.length; ++i) {
                        if (typeof object.dataSpec[keys[i]] !== "object")
                            throw TypeError(".gateway.core.TelemetrySpec.dataSpec: object expected");
                        message.dataSpec[keys[i]] = $root.gateway.core.DataValueSpec.fromObject(object.dataSpec[keys[i]]);
                    }
                }
                if (object.dataMappers) {
                    if (!Array.isArray(object.dataMappers))
                        throw TypeError(".gateway.core.TelemetrySpec.dataMappers: array expected");
                    message.dataMappers = [];
                    for (var i = 0; i < object.dataMappers.length; ++i)
                        message.dataMappers[i] = String(object.dataMappers[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a TelemetrySpec message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.TelemetrySpec
             * @static
             * @param {gateway.core.TelemetrySpec} message TelemetrySpec
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TelemetrySpec.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.dataMappers = [];
                if (options.objects || options.defaults)
                    object.dataSpec = {};
                if (options.defaults)
                    object.type = "";
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                var keys2;
                if (message.dataSpec && (keys2 = Object.keys(message.dataSpec)).length) {
                    object.dataSpec = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.dataSpec[keys2[j]] = $root.gateway.core.DataValueSpec.toObject(message.dataSpec[keys2[j]], options);
                }
                if (message.dataMappers && message.dataMappers.length) {
                    object.dataMappers = [];
                    for (var j = 0; j < message.dataMappers.length; ++j)
                        object.dataMappers[j] = message.dataMappers[j];
                }
                return object;
            };

            /**
             * Converts this TelemetrySpec to JSON.
             * @function toJSON
             * @memberof gateway.core.TelemetrySpec
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TelemetrySpec.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TelemetrySpec;
        })();

        core.DataValueSpec = (function() {

            /**
             * Properties of a DataValueSpec.
             * @memberof gateway.core
             * @interface IDataValueSpec
             * @property {string|null} [name] DataValueSpec name
             * @property {string|null} [unit] DataValueSpec unit
             * @property {google.protobuf.IStruct|null} [schema] DataValueSpec schema
             */

            /**
             * Constructs a new DataValueSpec.
             * @memberof gateway.core
             * @classdesc Represents a DataValueSpec.
             * @implements IDataValueSpec
             * @constructor
             * @param {gateway.core.IDataValueSpec=} [properties] Properties to set
             */
            function DataValueSpec(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DataValueSpec name.
             * @member {string} name
             * @memberof gateway.core.DataValueSpec
             * @instance
             */
            DataValueSpec.prototype.name = "";

            /**
             * DataValueSpec unit.
             * @member {string} unit
             * @memberof gateway.core.DataValueSpec
             * @instance
             */
            DataValueSpec.prototype.unit = "";

            /**
             * DataValueSpec schema.
             * @member {google.protobuf.IStruct|null|undefined} schema
             * @memberof gateway.core.DataValueSpec
             * @instance
             */
            DataValueSpec.prototype.schema = null;

            /**
             * Creates a new DataValueSpec instance using the specified properties.
             * @function create
             * @memberof gateway.core.DataValueSpec
             * @static
             * @param {gateway.core.IDataValueSpec=} [properties] Properties to set
             * @returns {gateway.core.DataValueSpec} DataValueSpec instance
             */
            DataValueSpec.create = function create(properties) {
                return new DataValueSpec(properties);
            };

            /**
             * Encodes the specified DataValueSpec message. Does not implicitly {@link gateway.core.DataValueSpec.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.DataValueSpec
             * @static
             * @param {gateway.core.IDataValueSpec} message DataValueSpec message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DataValueSpec.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.unit);
                if (message.schema != null && Object.hasOwnProperty.call(message, "schema"))
                    $root.google.protobuf.Struct.encode(message.schema, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified DataValueSpec message, length delimited. Does not implicitly {@link gateway.core.DataValueSpec.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.DataValueSpec
             * @static
             * @param {gateway.core.IDataValueSpec} message DataValueSpec message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DataValueSpec.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DataValueSpec message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.DataValueSpec
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.DataValueSpec} DataValueSpec
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DataValueSpec.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.DataValueSpec();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.unit = reader.string();
                        break;
                    case 3:
                        message.schema = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DataValueSpec message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.DataValueSpec
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.DataValueSpec} DataValueSpec
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DataValueSpec.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DataValueSpec message.
             * @function verify
             * @memberof gateway.core.DataValueSpec
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DataValueSpec.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.unit != null && message.hasOwnProperty("unit"))
                    if (!$util.isString(message.unit))
                        return "unit: string expected";
                if (message.schema != null && message.hasOwnProperty("schema")) {
                    var error = $root.google.protobuf.Struct.verify(message.schema);
                    if (error)
                        return "schema." + error;
                }
                return null;
            };

            /**
             * Creates a DataValueSpec message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.DataValueSpec
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.DataValueSpec} DataValueSpec
             */
            DataValueSpec.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.DataValueSpec)
                    return object;
                var message = new $root.gateway.core.DataValueSpec();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.unit != null)
                    message.unit = String(object.unit);
                if (object.schema != null) {
                    if (typeof object.schema !== "object")
                        throw TypeError(".gateway.core.DataValueSpec.schema: object expected");
                    message.schema = $root.google.protobuf.Struct.fromObject(object.schema);
                }
                return message;
            };

            /**
             * Creates a plain object from a DataValueSpec message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.DataValueSpec
             * @static
             * @param {gateway.core.DataValueSpec} message DataValueSpec
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DataValueSpec.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.unit = "";
                    object.schema = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.unit != null && message.hasOwnProperty("unit"))
                    object.unit = message.unit;
                if (message.schema != null && message.hasOwnProperty("schema"))
                    object.schema = $root.google.protobuf.Struct.toObject(message.schema, options);
                return object;
            };

            /**
             * Converts this DataValueSpec to JSON.
             * @function toJSON
             * @memberof gateway.core.DataValueSpec
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DataValueSpec.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DataValueSpec;
        })();

        core.ModbusTransport = (function() {

            /**
             * Properties of a ModbusTransport.
             * @memberof gateway.core
             * @interface IModbusTransport
             * @property {number|null} [id] ModbusTransport id
             * @property {string|null} [name] ModbusTransport name
             * @property {gateway.core.IModbusTransportConfig|null} [config] ModbusTransport config
             */

            /**
             * Constructs a new ModbusTransport.
             * @memberof gateway.core
             * @classdesc Represents a ModbusTransport.
             * @implements IModbusTransport
             * @constructor
             * @param {gateway.core.IModbusTransport=} [properties] Properties to set
             */
            function ModbusTransport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusTransport id.
             * @member {number} id
             * @memberof gateway.core.ModbusTransport
             * @instance
             */
            ModbusTransport.prototype.id = 0;

            /**
             * ModbusTransport name.
             * @member {string} name
             * @memberof gateway.core.ModbusTransport
             * @instance
             */
            ModbusTransport.prototype.name = "";

            /**
             * ModbusTransport config.
             * @member {gateway.core.IModbusTransportConfig|null|undefined} config
             * @memberof gateway.core.ModbusTransport
             * @instance
             */
            ModbusTransport.prototype.config = null;

            /**
             * Creates a new ModbusTransport instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusTransport
             * @static
             * @param {gateway.core.IModbusTransport=} [properties] Properties to set
             * @returns {gateway.core.ModbusTransport} ModbusTransport instance
             */
            ModbusTransport.create = function create(properties) {
                return new ModbusTransport(properties);
            };

            /**
             * Encodes the specified ModbusTransport message. Does not implicitly {@link gateway.core.ModbusTransport.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusTransport
             * @static
             * @param {gateway.core.IModbusTransport} message ModbusTransport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusTransport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                    $root.gateway.core.ModbusTransportConfig.encode(message.config, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ModbusTransport message, length delimited. Does not implicitly {@link gateway.core.ModbusTransport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusTransport
             * @static
             * @param {gateway.core.IModbusTransport} message ModbusTransport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusTransport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusTransport message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusTransport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusTransport} ModbusTransport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusTransport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusTransport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.uint32();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.config = $root.gateway.core.ModbusTransportConfig.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusTransport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusTransport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusTransport} ModbusTransport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusTransport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusTransport message.
             * @function verify
             * @memberof gateway.core.ModbusTransport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusTransport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id))
                        return "id: integer expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.config != null && message.hasOwnProperty("config")) {
                    var error = $root.gateway.core.ModbusTransportConfig.verify(message.config);
                    if (error)
                        return "config." + error;
                }
                return null;
            };

            /**
             * Creates a ModbusTransport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusTransport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusTransport} ModbusTransport
             */
            ModbusTransport.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusTransport)
                    return object;
                var message = new $root.gateway.core.ModbusTransport();
                if (object.id != null)
                    message.id = object.id >>> 0;
                if (object.name != null)
                    message.name = String(object.name);
                if (object.config != null) {
                    if (typeof object.config !== "object")
                        throw TypeError(".gateway.core.ModbusTransport.config: object expected");
                    message.config = $root.gateway.core.ModbusTransportConfig.fromObject(object.config);
                }
                return message;
            };

            /**
             * Creates a plain object from a ModbusTransport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusTransport
             * @static
             * @param {gateway.core.ModbusTransport} message ModbusTransport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusTransport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = 0;
                    object.name = "";
                    object.config = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.config != null && message.hasOwnProperty("config"))
                    object.config = $root.gateway.core.ModbusTransportConfig.toObject(message.config, options);
                return object;
            };

            /**
             * Converts this ModbusTransport to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusTransport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusTransport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ModbusTransport;
        })();

        core.ModbusTransportConfig = (function() {

            /**
             * Properties of a ModbusTransportConfig.
             * @memberof gateway.core
             * @interface IModbusTransportConfig
             * @property {gateway.core.IModbusTcpConfig|null} [tcp] ModbusTransportConfig tcp
             * @property {gateway.core.IModbusSerialConfig|null} [serial] ModbusTransportConfig serial
             */

            /**
             * Constructs a new ModbusTransportConfig.
             * @memberof gateway.core
             * @classdesc Represents a ModbusTransportConfig.
             * @implements IModbusTransportConfig
             * @constructor
             * @param {gateway.core.IModbusTransportConfig=} [properties] Properties to set
             */
            function ModbusTransportConfig(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusTransportConfig tcp.
             * @member {gateway.core.IModbusTcpConfig|null|undefined} tcp
             * @memberof gateway.core.ModbusTransportConfig
             * @instance
             */
            ModbusTransportConfig.prototype.tcp = null;

            /**
             * ModbusTransportConfig serial.
             * @member {gateway.core.IModbusSerialConfig|null|undefined} serial
             * @memberof gateway.core.ModbusTransportConfig
             * @instance
             */
            ModbusTransportConfig.prototype.serial = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * ModbusTransportConfig config.
             * @member {"tcp"|"serial"|undefined} config
             * @memberof gateway.core.ModbusTransportConfig
             * @instance
             */
            Object.defineProperty(ModbusTransportConfig.prototype, "config", {
                get: $util.oneOfGetter($oneOfFields = ["tcp", "serial"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new ModbusTransportConfig instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusTransportConfig
             * @static
             * @param {gateway.core.IModbusTransportConfig=} [properties] Properties to set
             * @returns {gateway.core.ModbusTransportConfig} ModbusTransportConfig instance
             */
            ModbusTransportConfig.create = function create(properties) {
                return new ModbusTransportConfig(properties);
            };

            /**
             * Encodes the specified ModbusTransportConfig message. Does not implicitly {@link gateway.core.ModbusTransportConfig.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusTransportConfig
             * @static
             * @param {gateway.core.IModbusTransportConfig} message ModbusTransportConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusTransportConfig.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.tcp != null && Object.hasOwnProperty.call(message, "tcp"))
                    $root.gateway.core.ModbusTcpConfig.encode(message.tcp, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.serial != null && Object.hasOwnProperty.call(message, "serial"))
                    $root.gateway.core.ModbusSerialConfig.encode(message.serial, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ModbusTransportConfig message, length delimited. Does not implicitly {@link gateway.core.ModbusTransportConfig.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusTransportConfig
             * @static
             * @param {gateway.core.IModbusTransportConfig} message ModbusTransportConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusTransportConfig.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusTransportConfig message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusTransportConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusTransportConfig} ModbusTransportConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusTransportConfig.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusTransportConfig();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.tcp = $root.gateway.core.ModbusTcpConfig.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.serial = $root.gateway.core.ModbusSerialConfig.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusTransportConfig message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusTransportConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusTransportConfig} ModbusTransportConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusTransportConfig.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusTransportConfig message.
             * @function verify
             * @memberof gateway.core.ModbusTransportConfig
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusTransportConfig.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.tcp != null && message.hasOwnProperty("tcp")) {
                    properties.config = 1;
                    {
                        var error = $root.gateway.core.ModbusTcpConfig.verify(message.tcp);
                        if (error)
                            return "tcp." + error;
                    }
                }
                if (message.serial != null && message.hasOwnProperty("serial")) {
                    if (properties.config === 1)
                        return "config: multiple values";
                    properties.config = 1;
                    {
                        var error = $root.gateway.core.ModbusSerialConfig.verify(message.serial);
                        if (error)
                            return "serial." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ModbusTransportConfig message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusTransportConfig
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusTransportConfig} ModbusTransportConfig
             */
            ModbusTransportConfig.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusTransportConfig)
                    return object;
                var message = new $root.gateway.core.ModbusTransportConfig();
                if (object.tcp != null) {
                    if (typeof object.tcp !== "object")
                        throw TypeError(".gateway.core.ModbusTransportConfig.tcp: object expected");
                    message.tcp = $root.gateway.core.ModbusTcpConfig.fromObject(object.tcp);
                }
                if (object.serial != null) {
                    if (typeof object.serial !== "object")
                        throw TypeError(".gateway.core.ModbusTransportConfig.serial: object expected");
                    message.serial = $root.gateway.core.ModbusSerialConfig.fromObject(object.serial);
                }
                return message;
            };

            /**
             * Creates a plain object from a ModbusTransportConfig message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusTransportConfig
             * @static
             * @param {gateway.core.ModbusTransportConfig} message ModbusTransportConfig
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusTransportConfig.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (message.tcp != null && message.hasOwnProperty("tcp")) {
                    object.tcp = $root.gateway.core.ModbusTcpConfig.toObject(message.tcp, options);
                    if (options.oneofs)
                        object.config = "tcp";
                }
                if (message.serial != null && message.hasOwnProperty("serial")) {
                    object.serial = $root.gateway.core.ModbusSerialConfig.toObject(message.serial, options);
                    if (options.oneofs)
                        object.config = "serial";
                }
                return object;
            };

            /**
             * Converts this ModbusTransportConfig to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusTransportConfig
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusTransportConfig.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ModbusTransportConfig;
        })();

        core.ModbusTcpConfig = (function() {

            /**
             * Properties of a ModbusTcpConfig.
             * @memberof gateway.core
             * @interface IModbusTcpConfig
             * @property {string|null} [host] ModbusTcpConfig host
             * @property {number|null} [port] ModbusTcpConfig port
             */

            /**
             * Constructs a new ModbusTcpConfig.
             * @memberof gateway.core
             * @classdesc Represents a ModbusTcpConfig.
             * @implements IModbusTcpConfig
             * @constructor
             * @param {gateway.core.IModbusTcpConfig=} [properties] Properties to set
             */
            function ModbusTcpConfig(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusTcpConfig host.
             * @member {string} host
             * @memberof gateway.core.ModbusTcpConfig
             * @instance
             */
            ModbusTcpConfig.prototype.host = "";

            /**
             * ModbusTcpConfig port.
             * @member {number} port
             * @memberof gateway.core.ModbusTcpConfig
             * @instance
             */
            ModbusTcpConfig.prototype.port = 0;

            /**
             * Creates a new ModbusTcpConfig instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusTcpConfig
             * @static
             * @param {gateway.core.IModbusTcpConfig=} [properties] Properties to set
             * @returns {gateway.core.ModbusTcpConfig} ModbusTcpConfig instance
             */
            ModbusTcpConfig.create = function create(properties) {
                return new ModbusTcpConfig(properties);
            };

            /**
             * Encodes the specified ModbusTcpConfig message. Does not implicitly {@link gateway.core.ModbusTcpConfig.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusTcpConfig
             * @static
             * @param {gateway.core.IModbusTcpConfig} message ModbusTcpConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusTcpConfig.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.host != null && Object.hasOwnProperty.call(message, "host"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.host);
                if (message.port != null && Object.hasOwnProperty.call(message, "port"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.port);
                return writer;
            };

            /**
             * Encodes the specified ModbusTcpConfig message, length delimited. Does not implicitly {@link gateway.core.ModbusTcpConfig.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusTcpConfig
             * @static
             * @param {gateway.core.IModbusTcpConfig} message ModbusTcpConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusTcpConfig.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusTcpConfig message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusTcpConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusTcpConfig} ModbusTcpConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusTcpConfig.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusTcpConfig();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.host = reader.string();
                        break;
                    case 2:
                        message.port = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusTcpConfig message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusTcpConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusTcpConfig} ModbusTcpConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusTcpConfig.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusTcpConfig message.
             * @function verify
             * @memberof gateway.core.ModbusTcpConfig
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusTcpConfig.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.host != null && message.hasOwnProperty("host"))
                    if (!$util.isString(message.host))
                        return "host: string expected";
                if (message.port != null && message.hasOwnProperty("port"))
                    if (!$util.isInteger(message.port))
                        return "port: integer expected";
                return null;
            };

            /**
             * Creates a ModbusTcpConfig message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusTcpConfig
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusTcpConfig} ModbusTcpConfig
             */
            ModbusTcpConfig.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusTcpConfig)
                    return object;
                var message = new $root.gateway.core.ModbusTcpConfig();
                if (object.host != null)
                    message.host = String(object.host);
                if (object.port != null)
                    message.port = object.port >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a ModbusTcpConfig message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusTcpConfig
             * @static
             * @param {gateway.core.ModbusTcpConfig} message ModbusTcpConfig
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusTcpConfig.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.host = "";
                    object.port = 0;
                }
                if (message.host != null && message.hasOwnProperty("host"))
                    object.host = message.host;
                if (message.port != null && message.hasOwnProperty("port"))
                    object.port = message.port;
                return object;
            };

            /**
             * Converts this ModbusTcpConfig to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusTcpConfig
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusTcpConfig.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ModbusTcpConfig;
        })();

        core.ModbusSerialConfig = (function() {

            /**
             * Properties of a ModbusSerialConfig.
             * @memberof gateway.core
             * @interface IModbusSerialConfig
             * @property {gateway.core.ModbusSerialConfig.FrameMethod|null} [method] ModbusSerialConfig method
             * @property {string|null} [port] ModbusSerialConfig port
             * @property {number|null} [baudrate] ModbusSerialConfig baudrate
             * @property {gateway.core.ModbusSerialConfig.ByteSize|null} [bytesize] ModbusSerialConfig bytesize
             * @property {gateway.core.ModbusSerialConfig.Parity|null} [parity] ModbusSerialConfig parity
             * @property {gateway.core.ModbusSerialConfig.StopBits|null} [stopbits] ModbusSerialConfig stopbits
             */

            /**
             * Constructs a new ModbusSerialConfig.
             * @memberof gateway.core
             * @classdesc Represents a ModbusSerialConfig.
             * @implements IModbusSerialConfig
             * @constructor
             * @param {gateway.core.IModbusSerialConfig=} [properties] Properties to set
             */
            function ModbusSerialConfig(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusSerialConfig method.
             * @member {gateway.core.ModbusSerialConfig.FrameMethod} method
             * @memberof gateway.core.ModbusSerialConfig
             * @instance
             */
            ModbusSerialConfig.prototype.method = 0;

            /**
             * ModbusSerialConfig port.
             * @member {string} port
             * @memberof gateway.core.ModbusSerialConfig
             * @instance
             */
            ModbusSerialConfig.prototype.port = "";

            /**
             * ModbusSerialConfig baudrate.
             * @member {number} baudrate
             * @memberof gateway.core.ModbusSerialConfig
             * @instance
             */
            ModbusSerialConfig.prototype.baudrate = 0;

            /**
             * ModbusSerialConfig bytesize.
             * @member {gateway.core.ModbusSerialConfig.ByteSize} bytesize
             * @memberof gateway.core.ModbusSerialConfig
             * @instance
             */
            ModbusSerialConfig.prototype.bytesize = 0;

            /**
             * ModbusSerialConfig parity.
             * @member {gateway.core.ModbusSerialConfig.Parity} parity
             * @memberof gateway.core.ModbusSerialConfig
             * @instance
             */
            ModbusSerialConfig.prototype.parity = 0;

            /**
             * ModbusSerialConfig stopbits.
             * @member {gateway.core.ModbusSerialConfig.StopBits} stopbits
             * @memberof gateway.core.ModbusSerialConfig
             * @instance
             */
            ModbusSerialConfig.prototype.stopbits = 0;

            /**
             * Creates a new ModbusSerialConfig instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusSerialConfig
             * @static
             * @param {gateway.core.IModbusSerialConfig=} [properties] Properties to set
             * @returns {gateway.core.ModbusSerialConfig} ModbusSerialConfig instance
             */
            ModbusSerialConfig.create = function create(properties) {
                return new ModbusSerialConfig(properties);
            };

            /**
             * Encodes the specified ModbusSerialConfig message. Does not implicitly {@link gateway.core.ModbusSerialConfig.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusSerialConfig
             * @static
             * @param {gateway.core.IModbusSerialConfig} message ModbusSerialConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusSerialConfig.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.method != null && Object.hasOwnProperty.call(message, "method"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.method);
                if (message.port != null && Object.hasOwnProperty.call(message, "port"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.port);
                if (message.baudrate != null && Object.hasOwnProperty.call(message, "baudrate"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.baudrate);
                if (message.bytesize != null && Object.hasOwnProperty.call(message, "bytesize"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.bytesize);
                if (message.parity != null && Object.hasOwnProperty.call(message, "parity"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.parity);
                if (message.stopbits != null && Object.hasOwnProperty.call(message, "stopbits"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.stopbits);
                return writer;
            };

            /**
             * Encodes the specified ModbusSerialConfig message, length delimited. Does not implicitly {@link gateway.core.ModbusSerialConfig.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusSerialConfig
             * @static
             * @param {gateway.core.IModbusSerialConfig} message ModbusSerialConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusSerialConfig.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusSerialConfig message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusSerialConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusSerialConfig} ModbusSerialConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusSerialConfig.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusSerialConfig();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.method = reader.int32();
                        break;
                    case 2:
                        message.port = reader.string();
                        break;
                    case 3:
                        message.baudrate = reader.uint32();
                        break;
                    case 4:
                        message.bytesize = reader.int32();
                        break;
                    case 5:
                        message.parity = reader.int32();
                        break;
                    case 6:
                        message.stopbits = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusSerialConfig message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusSerialConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusSerialConfig} ModbusSerialConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusSerialConfig.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusSerialConfig message.
             * @function verify
             * @memberof gateway.core.ModbusSerialConfig
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusSerialConfig.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.method != null && message.hasOwnProperty("method"))
                    switch (message.method) {
                    default:
                        return "method: enum value expected";
                    case 0:
                        break;
                    }
                if (message.port != null && message.hasOwnProperty("port"))
                    if (!$util.isString(message.port))
                        return "port: string expected";
                if (message.baudrate != null && message.hasOwnProperty("baudrate"))
                    if (!$util.isInteger(message.baudrate))
                        return "baudrate: integer expected";
                if (message.bytesize != null && message.hasOwnProperty("bytesize"))
                    switch (message.bytesize) {
                    default:
                        return "bytesize: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.parity != null && message.hasOwnProperty("parity"))
                    switch (message.parity) {
                    default:
                        return "parity: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.stopbits != null && message.hasOwnProperty("stopbits"))
                    switch (message.stopbits) {
                    default:
                        return "stopbits: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                return null;
            };

            /**
             * Creates a ModbusSerialConfig message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusSerialConfig
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusSerialConfig} ModbusSerialConfig
             */
            ModbusSerialConfig.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusSerialConfig)
                    return object;
                var message = new $root.gateway.core.ModbusSerialConfig();
                switch (object.method) {
                case "RTU":
                case 0:
                    message.method = 0;
                    break;
                }
                if (object.port != null)
                    message.port = String(object.port);
                if (object.baudrate != null)
                    message.baudrate = object.baudrate >>> 0;
                switch (object.bytesize) {
                case "EIGHTBITS":
                case 0:
                    message.bytesize = 0;
                    break;
                case "SEVENBITS":
                case 1:
                    message.bytesize = 1;
                    break;
                case "SIXBITS":
                case 2:
                    message.bytesize = 2;
                    break;
                case "FIVEBITS":
                case 3:
                    message.bytesize = 3;
                    break;
                }
                switch (object.parity) {
                case "NONE":
                case 0:
                    message.parity = 0;
                    break;
                case "EVEN":
                case 1:
                    message.parity = 1;
                    break;
                case "ODD":
                case 2:
                    message.parity = 2;
                    break;
                case "MARK":
                case 3:
                    message.parity = 3;
                    break;
                case "SPACE":
                case 4:
                    message.parity = 4;
                    break;
                }
                switch (object.stopbits) {
                case "ONE":
                case 0:
                    message.stopbits = 0;
                    break;
                case "ONE_POINT_FIVE":
                case 1:
                    message.stopbits = 1;
                    break;
                case "TWO":
                case 2:
                    message.stopbits = 2;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a ModbusSerialConfig message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusSerialConfig
             * @static
             * @param {gateway.core.ModbusSerialConfig} message ModbusSerialConfig
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusSerialConfig.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.method = options.enums === String ? "RTU" : 0;
                    object.port = "";
                    object.baudrate = 0;
                    object.bytesize = options.enums === String ? "EIGHTBITS" : 0;
                    object.parity = options.enums === String ? "NONE" : 0;
                    object.stopbits = options.enums === String ? "ONE" : 0;
                }
                if (message.method != null && message.hasOwnProperty("method"))
                    object.method = options.enums === String ? $root.gateway.core.ModbusSerialConfig.FrameMethod[message.method] : message.method;
                if (message.port != null && message.hasOwnProperty("port"))
                    object.port = message.port;
                if (message.baudrate != null && message.hasOwnProperty("baudrate"))
                    object.baudrate = message.baudrate;
                if (message.bytesize != null && message.hasOwnProperty("bytesize"))
                    object.bytesize = options.enums === String ? $root.gateway.core.ModbusSerialConfig.ByteSize[message.bytesize] : message.bytesize;
                if (message.parity != null && message.hasOwnProperty("parity"))
                    object.parity = options.enums === String ? $root.gateway.core.ModbusSerialConfig.Parity[message.parity] : message.parity;
                if (message.stopbits != null && message.hasOwnProperty("stopbits"))
                    object.stopbits = options.enums === String ? $root.gateway.core.ModbusSerialConfig.StopBits[message.stopbits] : message.stopbits;
                return object;
            };

            /**
             * Converts this ModbusSerialConfig to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusSerialConfig
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusSerialConfig.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * FrameMethod enum.
             * @name gateway.core.ModbusSerialConfig.FrameMethod
             * @enum {number}
             * @property {number} RTU=0 RTU value
             */
            ModbusSerialConfig.FrameMethod = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "RTU"] = 0;
                return values;
            })();

            /**
             * ByteSize enum.
             * @name gateway.core.ModbusSerialConfig.ByteSize
             * @enum {number}
             * @property {number} EIGHTBITS=0 EIGHTBITS value
             * @property {number} SEVENBITS=1 SEVENBITS value
             * @property {number} SIXBITS=2 SIXBITS value
             * @property {number} FIVEBITS=3 FIVEBITS value
             */
            ModbusSerialConfig.ByteSize = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "EIGHTBITS"] = 0;
                values[valuesById[1] = "SEVENBITS"] = 1;
                values[valuesById[2] = "SIXBITS"] = 2;
                values[valuesById[3] = "FIVEBITS"] = 3;
                return values;
            })();

            /**
             * Parity enum.
             * @name gateway.core.ModbusSerialConfig.Parity
             * @enum {number}
             * @property {number} NONE=0 NONE value
             * @property {number} EVEN=1 EVEN value
             * @property {number} ODD=2 ODD value
             * @property {number} MARK=3 MARK value
             * @property {number} SPACE=4 SPACE value
             */
            ModbusSerialConfig.Parity = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "NONE"] = 0;
                values[valuesById[1] = "EVEN"] = 1;
                values[valuesById[2] = "ODD"] = 2;
                values[valuesById[3] = "MARK"] = 3;
                values[valuesById[4] = "SPACE"] = 4;
                return values;
            })();

            /**
             * StopBits enum.
             * @name gateway.core.ModbusSerialConfig.StopBits
             * @enum {number}
             * @property {number} ONE=0 ONE value
             * @property {number} ONE_POINT_FIVE=1 ONE_POINT_FIVE value
             * @property {number} TWO=2 TWO value
             */
            ModbusSerialConfig.StopBits = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ONE"] = 0;
                values[valuesById[1] = "ONE_POINT_FIVE"] = 1;
                values[valuesById[2] = "TWO"] = 2;
                return values;
            })();

            return ModbusSerialConfig;
        })();

        core.ModbusCollectionSpec = (function() {

            /**
             * Properties of a ModbusCollectionSpec.
             * @memberof gateway.core
             * @interface IModbusCollectionSpec
             * @property {number|null} [transportId] ModbusCollectionSpec transportId
             * @property {number|null} [unit] ModbusCollectionSpec unit
             * @property {Array.<gateway.core.IModbusCollectionStep>|null} [steps] ModbusCollectionSpec steps
             */

            /**
             * Constructs a new ModbusCollectionSpec.
             * @memberof gateway.core
             * @classdesc Represents a ModbusCollectionSpec.
             * @implements IModbusCollectionSpec
             * @constructor
             * @param {gateway.core.IModbusCollectionSpec=} [properties] Properties to set
             */
            function ModbusCollectionSpec(properties) {
                this.steps = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusCollectionSpec transportId.
             * @member {number} transportId
             * @memberof gateway.core.ModbusCollectionSpec
             * @instance
             */
            ModbusCollectionSpec.prototype.transportId = 0;

            /**
             * ModbusCollectionSpec unit.
             * @member {number} unit
             * @memberof gateway.core.ModbusCollectionSpec
             * @instance
             */
            ModbusCollectionSpec.prototype.unit = 0;

            /**
             * ModbusCollectionSpec steps.
             * @member {Array.<gateway.core.IModbusCollectionStep>} steps
             * @memberof gateway.core.ModbusCollectionSpec
             * @instance
             */
            ModbusCollectionSpec.prototype.steps = $util.emptyArray;

            /**
             * Creates a new ModbusCollectionSpec instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusCollectionSpec
             * @static
             * @param {gateway.core.IModbusCollectionSpec=} [properties] Properties to set
             * @returns {gateway.core.ModbusCollectionSpec} ModbusCollectionSpec instance
             */
            ModbusCollectionSpec.create = function create(properties) {
                return new ModbusCollectionSpec(properties);
            };

            /**
             * Encodes the specified ModbusCollectionSpec message. Does not implicitly {@link gateway.core.ModbusCollectionSpec.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusCollectionSpec
             * @static
             * @param {gateway.core.IModbusCollectionSpec} message ModbusCollectionSpec message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusCollectionSpec.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transportId != null && Object.hasOwnProperty.call(message, "transportId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.transportId);
                if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.unit);
                if (message.steps != null && message.steps.length)
                    for (var i = 0; i < message.steps.length; ++i)
                        $root.gateway.core.ModbusCollectionStep.encode(message.steps[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ModbusCollectionSpec message, length delimited. Does not implicitly {@link gateway.core.ModbusCollectionSpec.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusCollectionSpec
             * @static
             * @param {gateway.core.IModbusCollectionSpec} message ModbusCollectionSpec message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusCollectionSpec.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusCollectionSpec message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusCollectionSpec
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusCollectionSpec} ModbusCollectionSpec
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusCollectionSpec.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusCollectionSpec();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transportId = reader.uint32();
                        break;
                    case 2:
                        message.unit = reader.uint32();
                        break;
                    case 3:
                        if (!(message.steps && message.steps.length))
                            message.steps = [];
                        message.steps.push($root.gateway.core.ModbusCollectionStep.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusCollectionSpec message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusCollectionSpec
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusCollectionSpec} ModbusCollectionSpec
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusCollectionSpec.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusCollectionSpec message.
             * @function verify
             * @memberof gateway.core.ModbusCollectionSpec
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusCollectionSpec.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transportId != null && message.hasOwnProperty("transportId"))
                    if (!$util.isInteger(message.transportId))
                        return "transportId: integer expected";
                if (message.unit != null && message.hasOwnProperty("unit"))
                    if (!$util.isInteger(message.unit))
                        return "unit: integer expected";
                if (message.steps != null && message.hasOwnProperty("steps")) {
                    if (!Array.isArray(message.steps))
                        return "steps: array expected";
                    for (var i = 0; i < message.steps.length; ++i) {
                        var error = $root.gateway.core.ModbusCollectionStep.verify(message.steps[i]);
                        if (error)
                            return "steps." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ModbusCollectionSpec message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusCollectionSpec
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusCollectionSpec} ModbusCollectionSpec
             */
            ModbusCollectionSpec.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusCollectionSpec)
                    return object;
                var message = new $root.gateway.core.ModbusCollectionSpec();
                if (object.transportId != null)
                    message.transportId = object.transportId >>> 0;
                if (object.unit != null)
                    message.unit = object.unit >>> 0;
                if (object.steps) {
                    if (!Array.isArray(object.steps))
                        throw TypeError(".gateway.core.ModbusCollectionSpec.steps: array expected");
                    message.steps = [];
                    for (var i = 0; i < object.steps.length; ++i) {
                        if (typeof object.steps[i] !== "object")
                            throw TypeError(".gateway.core.ModbusCollectionSpec.steps: object expected");
                        message.steps[i] = $root.gateway.core.ModbusCollectionStep.fromObject(object.steps[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ModbusCollectionSpec message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusCollectionSpec
             * @static
             * @param {gateway.core.ModbusCollectionSpec} message ModbusCollectionSpec
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusCollectionSpec.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.steps = [];
                if (options.defaults) {
                    object.transportId = 0;
                    object.unit = 0;
                }
                if (message.transportId != null && message.hasOwnProperty("transportId"))
                    object.transportId = message.transportId;
                if (message.unit != null && message.hasOwnProperty("unit"))
                    object.unit = message.unit;
                if (message.steps && message.steps.length) {
                    object.steps = [];
                    for (var j = 0; j < message.steps.length; ++j)
                        object.steps[j] = $root.gateway.core.ModbusCollectionStep.toObject(message.steps[j], options);
                }
                return object;
            };

            /**
             * Converts this ModbusCollectionSpec to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusCollectionSpec
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusCollectionSpec.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ModbusCollectionSpec;
        })();

        core.ModbusCollectionStep = (function() {

            /**
             * Properties of a ModbusCollectionStep.
             * @memberof gateway.core
             * @interface IModbusCollectionStep
             * @property {gateway.core.ModbusCollectionStep.ModbusFunction|null} ["function"] ModbusCollectionStep function
             * @property {number|null} [address] ModbusCollectionStep address
             * @property {number|null} [count] ModbusCollectionStep count
             * @property {number|null} [retry] ModbusCollectionStep retry
             * @property {gateway.core.IModbusDecoding|null} [decoding] ModbusCollectionStep decoding
             */

            /**
             * Constructs a new ModbusCollectionStep.
             * @memberof gateway.core
             * @classdesc Represents a ModbusCollectionStep.
             * @implements IModbusCollectionStep
             * @constructor
             * @param {gateway.core.IModbusCollectionStep=} [properties] Properties to set
             */
            function ModbusCollectionStep(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusCollectionStep function.
             * @member {gateway.core.ModbusCollectionStep.ModbusFunction} function
             * @memberof gateway.core.ModbusCollectionStep
             * @instance
             */
            ModbusCollectionStep.prototype["function"] = 0;

            /**
             * ModbusCollectionStep address.
             * @member {number} address
             * @memberof gateway.core.ModbusCollectionStep
             * @instance
             */
            ModbusCollectionStep.prototype.address = 0;

            /**
             * ModbusCollectionStep count.
             * @member {number} count
             * @memberof gateway.core.ModbusCollectionStep
             * @instance
             */
            ModbusCollectionStep.prototype.count = 0;

            /**
             * ModbusCollectionStep retry.
             * @member {number} retry
             * @memberof gateway.core.ModbusCollectionStep
             * @instance
             */
            ModbusCollectionStep.prototype.retry = 0;

            /**
             * ModbusCollectionStep decoding.
             * @member {gateway.core.IModbusDecoding|null|undefined} decoding
             * @memberof gateway.core.ModbusCollectionStep
             * @instance
             */
            ModbusCollectionStep.prototype.decoding = null;

            /**
             * Creates a new ModbusCollectionStep instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusCollectionStep
             * @static
             * @param {gateway.core.IModbusCollectionStep=} [properties] Properties to set
             * @returns {gateway.core.ModbusCollectionStep} ModbusCollectionStep instance
             */
            ModbusCollectionStep.create = function create(properties) {
                return new ModbusCollectionStep(properties);
            };

            /**
             * Encodes the specified ModbusCollectionStep message. Does not implicitly {@link gateway.core.ModbusCollectionStep.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusCollectionStep
             * @static
             * @param {gateway.core.IModbusCollectionStep} message ModbusCollectionStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusCollectionStep.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message["function"] != null && Object.hasOwnProperty.call(message, "function"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message["function"]);
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.address);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.count);
                if (message.retry != null && Object.hasOwnProperty.call(message, "retry"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.retry);
                if (message.decoding != null && Object.hasOwnProperty.call(message, "decoding"))
                    $root.gateway.core.ModbusDecoding.encode(message.decoding, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ModbusCollectionStep message, length delimited. Does not implicitly {@link gateway.core.ModbusCollectionStep.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusCollectionStep
             * @static
             * @param {gateway.core.IModbusCollectionStep} message ModbusCollectionStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusCollectionStep.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusCollectionStep message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusCollectionStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusCollectionStep} ModbusCollectionStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusCollectionStep.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusCollectionStep();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message["function"] = reader.int32();
                        break;
                    case 2:
                        message.address = reader.uint32();
                        break;
                    case 3:
                        message.count = reader.uint32();
                        break;
                    case 4:
                        message.retry = reader.uint32();
                        break;
                    case 5:
                        message.decoding = $root.gateway.core.ModbusDecoding.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusCollectionStep message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusCollectionStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusCollectionStep} ModbusCollectionStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusCollectionStep.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusCollectionStep message.
             * @function verify
             * @memberof gateway.core.ModbusCollectionStep
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusCollectionStep.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message["function"] != null && message.hasOwnProperty("function"))
                    switch (message["function"]) {
                    default:
                        return "function: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.address != null && message.hasOwnProperty("address"))
                    if (!$util.isInteger(message.address))
                        return "address: integer expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.retry != null && message.hasOwnProperty("retry"))
                    if (!$util.isInteger(message.retry))
                        return "retry: integer expected";
                if (message.decoding != null && message.hasOwnProperty("decoding")) {
                    var error = $root.gateway.core.ModbusDecoding.verify(message.decoding);
                    if (error)
                        return "decoding." + error;
                }
                return null;
            };

            /**
             * Creates a ModbusCollectionStep message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusCollectionStep
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusCollectionStep} ModbusCollectionStep
             */
            ModbusCollectionStep.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusCollectionStep)
                    return object;
                var message = new $root.gateway.core.ModbusCollectionStep();
                switch (object["function"]) {
                case "READ_COILS":
                case 0:
                    message["function"] = 0;
                    break;
                case "READ_DISCRETE_INPUTS":
                case 1:
                    message["function"] = 1;
                    break;
                case "READ_HOLDING_REGISTERS":
                case 2:
                    message["function"] = 2;
                    break;
                case "READ_INPUT_REGISTERS":
                case 3:
                    message["function"] = 3;
                    break;
                }
                if (object.address != null)
                    message.address = object.address >>> 0;
                if (object.count != null)
                    message.count = object.count >>> 0;
                if (object.retry != null)
                    message.retry = object.retry >>> 0;
                if (object.decoding != null) {
                    if (typeof object.decoding !== "object")
                        throw TypeError(".gateway.core.ModbusCollectionStep.decoding: object expected");
                    message.decoding = $root.gateway.core.ModbusDecoding.fromObject(object.decoding);
                }
                return message;
            };

            /**
             * Creates a plain object from a ModbusCollectionStep message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusCollectionStep
             * @static
             * @param {gateway.core.ModbusCollectionStep} message ModbusCollectionStep
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusCollectionStep.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object["function"] = options.enums === String ? "READ_COILS" : 0;
                    object.address = 0;
                    object.count = 0;
                    object.retry = 0;
                    object.decoding = null;
                }
                if (message["function"] != null && message.hasOwnProperty("function"))
                    object["function"] = options.enums === String ? $root.gateway.core.ModbusCollectionStep.ModbusFunction[message["function"]] : message["function"];
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = message.address;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.retry != null && message.hasOwnProperty("retry"))
                    object.retry = message.retry;
                if (message.decoding != null && message.hasOwnProperty("decoding"))
                    object.decoding = $root.gateway.core.ModbusDecoding.toObject(message.decoding, options);
                return object;
            };

            /**
             * Converts this ModbusCollectionStep to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusCollectionStep
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusCollectionStep.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * ModbusFunction enum.
             * @name gateway.core.ModbusCollectionStep.ModbusFunction
             * @enum {number}
             * @property {number} READ_COILS=0 READ_COILS value
             * @property {number} READ_DISCRETE_INPUTS=1 READ_DISCRETE_INPUTS value
             * @property {number} READ_HOLDING_REGISTERS=2 READ_HOLDING_REGISTERS value
             * @property {number} READ_INPUT_REGISTERS=3 READ_INPUT_REGISTERS value
             */
            ModbusCollectionStep.ModbusFunction = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "READ_COILS"] = 0;
                values[valuesById[1] = "READ_DISCRETE_INPUTS"] = 1;
                values[valuesById[2] = "READ_HOLDING_REGISTERS"] = 2;
                values[valuesById[3] = "READ_INPUT_REGISTERS"] = 3;
                return values;
            })();

            return ModbusCollectionStep;
        })();

        core.ModbusDecoding = (function() {

            /**
             * Properties of a ModbusDecoding.
             * @memberof gateway.core
             * @interface IModbusDecoding
             * @property {gateway.core.ModbusDecoding.Endian|null} [byteorder] ModbusDecoding byteorder
             * @property {gateway.core.ModbusDecoding.Endian|null} [wordorder] ModbusDecoding wordorder
             * @property {Array.<gateway.core.IModbusDecodingStep>|null} [steps] ModbusDecoding steps
             */

            /**
             * Constructs a new ModbusDecoding.
             * @memberof gateway.core
             * @classdesc Represents a ModbusDecoding.
             * @implements IModbusDecoding
             * @constructor
             * @param {gateway.core.IModbusDecoding=} [properties] Properties to set
             */
            function ModbusDecoding(properties) {
                this.steps = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusDecoding byteorder.
             * @member {gateway.core.ModbusDecoding.Endian} byteorder
             * @memberof gateway.core.ModbusDecoding
             * @instance
             */
            ModbusDecoding.prototype.byteorder = 0;

            /**
             * ModbusDecoding wordorder.
             * @member {gateway.core.ModbusDecoding.Endian} wordorder
             * @memberof gateway.core.ModbusDecoding
             * @instance
             */
            ModbusDecoding.prototype.wordorder = 0;

            /**
             * ModbusDecoding steps.
             * @member {Array.<gateway.core.IModbusDecodingStep>} steps
             * @memberof gateway.core.ModbusDecoding
             * @instance
             */
            ModbusDecoding.prototype.steps = $util.emptyArray;

            /**
             * Creates a new ModbusDecoding instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusDecoding
             * @static
             * @param {gateway.core.IModbusDecoding=} [properties] Properties to set
             * @returns {gateway.core.ModbusDecoding} ModbusDecoding instance
             */
            ModbusDecoding.create = function create(properties) {
                return new ModbusDecoding(properties);
            };

            /**
             * Encodes the specified ModbusDecoding message. Does not implicitly {@link gateway.core.ModbusDecoding.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusDecoding
             * @static
             * @param {gateway.core.IModbusDecoding} message ModbusDecoding message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusDecoding.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byteorder != null && Object.hasOwnProperty.call(message, "byteorder"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.byteorder);
                if (message.wordorder != null && Object.hasOwnProperty.call(message, "wordorder"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.wordorder);
                if (message.steps != null && message.steps.length)
                    for (var i = 0; i < message.steps.length; ++i)
                        $root.gateway.core.ModbusDecodingStep.encode(message.steps[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ModbusDecoding message, length delimited. Does not implicitly {@link gateway.core.ModbusDecoding.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusDecoding
             * @static
             * @param {gateway.core.IModbusDecoding} message ModbusDecoding message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusDecoding.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusDecoding message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusDecoding
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusDecoding} ModbusDecoding
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusDecoding.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusDecoding();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.byteorder = reader.int32();
                        break;
                    case 2:
                        message.wordorder = reader.int32();
                        break;
                    case 3:
                        if (!(message.steps && message.steps.length))
                            message.steps = [];
                        message.steps.push($root.gateway.core.ModbusDecodingStep.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusDecoding message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusDecoding
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusDecoding} ModbusDecoding
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusDecoding.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusDecoding message.
             * @function verify
             * @memberof gateway.core.ModbusDecoding
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusDecoding.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byteorder != null && message.hasOwnProperty("byteorder"))
                    switch (message.byteorder) {
                    default:
                        return "byteorder: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.wordorder != null && message.hasOwnProperty("wordorder"))
                    switch (message.wordorder) {
                    default:
                        return "wordorder: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.steps != null && message.hasOwnProperty("steps")) {
                    if (!Array.isArray(message.steps))
                        return "steps: array expected";
                    for (var i = 0; i < message.steps.length; ++i) {
                        var error = $root.gateway.core.ModbusDecodingStep.verify(message.steps[i]);
                        if (error)
                            return "steps." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ModbusDecoding message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusDecoding
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusDecoding} ModbusDecoding
             */
            ModbusDecoding.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusDecoding)
                    return object;
                var message = new $root.gateway.core.ModbusDecoding();
                switch (object.byteorder) {
                case "LITTLE":
                case 0:
                    message.byteorder = 0;
                    break;
                case "BIG":
                case 1:
                    message.byteorder = 1;
                    break;
                }
                switch (object.wordorder) {
                case "LITTLE":
                case 0:
                    message.wordorder = 0;
                    break;
                case "BIG":
                case 1:
                    message.wordorder = 1;
                    break;
                }
                if (object.steps) {
                    if (!Array.isArray(object.steps))
                        throw TypeError(".gateway.core.ModbusDecoding.steps: array expected");
                    message.steps = [];
                    for (var i = 0; i < object.steps.length; ++i) {
                        if (typeof object.steps[i] !== "object")
                            throw TypeError(".gateway.core.ModbusDecoding.steps: object expected");
                        message.steps[i] = $root.gateway.core.ModbusDecodingStep.fromObject(object.steps[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ModbusDecoding message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusDecoding
             * @static
             * @param {gateway.core.ModbusDecoding} message ModbusDecoding
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusDecoding.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.steps = [];
                if (options.defaults) {
                    object.byteorder = options.enums === String ? "LITTLE" : 0;
                    object.wordorder = options.enums === String ? "LITTLE" : 0;
                }
                if (message.byteorder != null && message.hasOwnProperty("byteorder"))
                    object.byteorder = options.enums === String ? $root.gateway.core.ModbusDecoding.Endian[message.byteorder] : message.byteorder;
                if (message.wordorder != null && message.hasOwnProperty("wordorder"))
                    object.wordorder = options.enums === String ? $root.gateway.core.ModbusDecoding.Endian[message.wordorder] : message.wordorder;
                if (message.steps && message.steps.length) {
                    object.steps = [];
                    for (var j = 0; j < message.steps.length; ++j)
                        object.steps[j] = $root.gateway.core.ModbusDecodingStep.toObject(message.steps[j], options);
                }
                return object;
            };

            /**
             * Converts this ModbusDecoding to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusDecoding
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusDecoding.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Endian enum.
             * @name gateway.core.ModbusDecoding.Endian
             * @enum {number}
             * @property {number} LITTLE=0 LITTLE value
             * @property {number} BIG=1 BIG value
             */
            ModbusDecoding.Endian = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "LITTLE"] = 0;
                values[valuesById[1] = "BIG"] = 1;
                return values;
            })();

            return ModbusDecoding;
        })();

        core.ModbusDecodingStep = (function() {

            /**
             * Properties of a ModbusDecodingStep.
             * @memberof gateway.core
             * @interface IModbusDecodingStep
             * @property {gateway.core.IModbusNumericDecodingStep|null} [number] ModbusDecodingStep number
             * @property {gateway.core.IModbusStringDecodingStep|null} [string] ModbusDecodingStep string
             * @property {gateway.core.IModbusSkipBytesDecodingStep|null} [skip] ModbusDecodingStep skip
             */

            /**
             * Constructs a new ModbusDecodingStep.
             * @memberof gateway.core
             * @classdesc Represents a ModbusDecodingStep.
             * @implements IModbusDecodingStep
             * @constructor
             * @param {gateway.core.IModbusDecodingStep=} [properties] Properties to set
             */
            function ModbusDecodingStep(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusDecodingStep number.
             * @member {gateway.core.IModbusNumericDecodingStep|null|undefined} number
             * @memberof gateway.core.ModbusDecodingStep
             * @instance
             */
            ModbusDecodingStep.prototype.number = null;

            /**
             * ModbusDecodingStep string.
             * @member {gateway.core.IModbusStringDecodingStep|null|undefined} string
             * @memberof gateway.core.ModbusDecodingStep
             * @instance
             */
            ModbusDecodingStep.prototype.string = null;

            /**
             * ModbusDecodingStep skip.
             * @member {gateway.core.IModbusSkipBytesDecodingStep|null|undefined} skip
             * @memberof gateway.core.ModbusDecodingStep
             * @instance
             */
            ModbusDecodingStep.prototype.skip = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * ModbusDecodingStep kind.
             * @member {"number"|"string"|"skip"|undefined} kind
             * @memberof gateway.core.ModbusDecodingStep
             * @instance
             */
            Object.defineProperty(ModbusDecodingStep.prototype, "kind", {
                get: $util.oneOfGetter($oneOfFields = ["number", "string", "skip"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new ModbusDecodingStep instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusDecodingStep
             * @static
             * @param {gateway.core.IModbusDecodingStep=} [properties] Properties to set
             * @returns {gateway.core.ModbusDecodingStep} ModbusDecodingStep instance
             */
            ModbusDecodingStep.create = function create(properties) {
                return new ModbusDecodingStep(properties);
            };

            /**
             * Encodes the specified ModbusDecodingStep message. Does not implicitly {@link gateway.core.ModbusDecodingStep.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusDecodingStep
             * @static
             * @param {gateway.core.IModbusDecodingStep} message ModbusDecodingStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusDecodingStep.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    $root.gateway.core.ModbusNumericDecodingStep.encode(message.number, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.string != null && Object.hasOwnProperty.call(message, "string"))
                    $root.gateway.core.ModbusStringDecodingStep.encode(message.string, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.skip != null && Object.hasOwnProperty.call(message, "skip"))
                    $root.gateway.core.ModbusSkipBytesDecodingStep.encode(message.skip, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ModbusDecodingStep message, length delimited. Does not implicitly {@link gateway.core.ModbusDecodingStep.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusDecodingStep
             * @static
             * @param {gateway.core.IModbusDecodingStep} message ModbusDecodingStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusDecodingStep.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusDecodingStep message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusDecodingStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusDecodingStep} ModbusDecodingStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusDecodingStep.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusDecodingStep();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.number = $root.gateway.core.ModbusNumericDecodingStep.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.string = $root.gateway.core.ModbusStringDecodingStep.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.skip = $root.gateway.core.ModbusSkipBytesDecodingStep.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusDecodingStep message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusDecodingStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusDecodingStep} ModbusDecodingStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusDecodingStep.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusDecodingStep message.
             * @function verify
             * @memberof gateway.core.ModbusDecodingStep
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusDecodingStep.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.number != null && message.hasOwnProperty("number")) {
                    properties.kind = 1;
                    {
                        var error = $root.gateway.core.ModbusNumericDecodingStep.verify(message.number);
                        if (error)
                            return "number." + error;
                    }
                }
                if (message.string != null && message.hasOwnProperty("string")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    {
                        var error = $root.gateway.core.ModbusStringDecodingStep.verify(message.string);
                        if (error)
                            return "string." + error;
                    }
                }
                if (message.skip != null && message.hasOwnProperty("skip")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    {
                        var error = $root.gateway.core.ModbusSkipBytesDecodingStep.verify(message.skip);
                        if (error)
                            return "skip." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ModbusDecodingStep message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusDecodingStep
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusDecodingStep} ModbusDecodingStep
             */
            ModbusDecodingStep.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusDecodingStep)
                    return object;
                var message = new $root.gateway.core.ModbusDecodingStep();
                if (object.number != null) {
                    if (typeof object.number !== "object")
                        throw TypeError(".gateway.core.ModbusDecodingStep.number: object expected");
                    message.number = $root.gateway.core.ModbusNumericDecodingStep.fromObject(object.number);
                }
                if (object.string != null) {
                    if (typeof object.string !== "object")
                        throw TypeError(".gateway.core.ModbusDecodingStep.string: object expected");
                    message.string = $root.gateway.core.ModbusStringDecodingStep.fromObject(object.string);
                }
                if (object.skip != null) {
                    if (typeof object.skip !== "object")
                        throw TypeError(".gateway.core.ModbusDecodingStep.skip: object expected");
                    message.skip = $root.gateway.core.ModbusSkipBytesDecodingStep.fromObject(object.skip);
                }
                return message;
            };

            /**
             * Creates a plain object from a ModbusDecodingStep message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusDecodingStep
             * @static
             * @param {gateway.core.ModbusDecodingStep} message ModbusDecodingStep
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusDecodingStep.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (message.number != null && message.hasOwnProperty("number")) {
                    object.number = $root.gateway.core.ModbusNumericDecodingStep.toObject(message.number, options);
                    if (options.oneofs)
                        object.kind = "number";
                }
                if (message.string != null && message.hasOwnProperty("string")) {
                    object.string = $root.gateway.core.ModbusStringDecodingStep.toObject(message.string, options);
                    if (options.oneofs)
                        object.kind = "string";
                }
                if (message.skip != null && message.hasOwnProperty("skip")) {
                    object.skip = $root.gateway.core.ModbusSkipBytesDecodingStep.toObject(message.skip, options);
                    if (options.oneofs)
                        object.kind = "skip";
                }
                return object;
            };

            /**
             * Converts this ModbusDecodingStep to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusDecodingStep
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusDecodingStep.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ModbusDecodingStep;
        })();

        core.ModbusNumericDecodingStep = (function() {

            /**
             * Properties of a ModbusNumericDecodingStep.
             * @memberof gateway.core
             * @interface IModbusNumericDecodingStep
             * @property {string|null} ["var"] ModbusNumericDecodingStep var
             * @property {gateway.core.ModbusNumericDecodingStep.Type|null} [type] ModbusNumericDecodingStep type
             */

            /**
             * Constructs a new ModbusNumericDecodingStep.
             * @memberof gateway.core
             * @classdesc Represents a ModbusNumericDecodingStep.
             * @implements IModbusNumericDecodingStep
             * @constructor
             * @param {gateway.core.IModbusNumericDecodingStep=} [properties] Properties to set
             */
            function ModbusNumericDecodingStep(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusNumericDecodingStep var.
             * @member {string} var
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @instance
             */
            ModbusNumericDecodingStep.prototype["var"] = "";

            /**
             * ModbusNumericDecodingStep type.
             * @member {gateway.core.ModbusNumericDecodingStep.Type} type
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @instance
             */
            ModbusNumericDecodingStep.prototype.type = 0;

            /**
             * Creates a new ModbusNumericDecodingStep instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @static
             * @param {gateway.core.IModbusNumericDecodingStep=} [properties] Properties to set
             * @returns {gateway.core.ModbusNumericDecodingStep} ModbusNumericDecodingStep instance
             */
            ModbusNumericDecodingStep.create = function create(properties) {
                return new ModbusNumericDecodingStep(properties);
            };

            /**
             * Encodes the specified ModbusNumericDecodingStep message. Does not implicitly {@link gateway.core.ModbusNumericDecodingStep.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @static
             * @param {gateway.core.IModbusNumericDecodingStep} message ModbusNumericDecodingStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusNumericDecodingStep.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message["var"] != null && Object.hasOwnProperty.call(message, "var"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message["var"]);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                return writer;
            };

            /**
             * Encodes the specified ModbusNumericDecodingStep message, length delimited. Does not implicitly {@link gateway.core.ModbusNumericDecodingStep.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @static
             * @param {gateway.core.IModbusNumericDecodingStep} message ModbusNumericDecodingStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusNumericDecodingStep.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusNumericDecodingStep message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusNumericDecodingStep} ModbusNumericDecodingStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusNumericDecodingStep.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusNumericDecodingStep();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message["var"] = reader.string();
                        break;
                    case 2:
                        message.type = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusNumericDecodingStep message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusNumericDecodingStep} ModbusNumericDecodingStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusNumericDecodingStep.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusNumericDecodingStep message.
             * @function verify
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusNumericDecodingStep.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message["var"] != null && message.hasOwnProperty("var"))
                    if (!$util.isString(message["var"]))
                        return "var: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                        break;
                    }
                return null;
            };

            /**
             * Creates a ModbusNumericDecodingStep message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusNumericDecodingStep} ModbusNumericDecodingStep
             */
            ModbusNumericDecodingStep.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusNumericDecodingStep)
                    return object;
                var message = new $root.gateway.core.ModbusNumericDecodingStep();
                if (object["var"] != null)
                    message["var"] = String(object["var"]);
                switch (object.type) {
                case "UINT8":
                case 0:
                    message.type = 0;
                    break;
                case "UINT16":
                case 1:
                    message.type = 1;
                    break;
                case "UINT32":
                case 2:
                    message.type = 2;
                    break;
                case "UINT64":
                case 3:
                    message.type = 3;
                    break;
                case "INT8":
                case 4:
                    message.type = 4;
                    break;
                case "INT16":
                case 5:
                    message.type = 5;
                    break;
                case "INT32":
                case 6:
                    message.type = 6;
                    break;
                case "INT64":
                case 7:
                    message.type = 7;
                    break;
                case "FLOAT32":
                case 8:
                    message.type = 8;
                    break;
                case "FLOAT64":
                case 9:
                    message.type = 9;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a ModbusNumericDecodingStep message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @static
             * @param {gateway.core.ModbusNumericDecodingStep} message ModbusNumericDecodingStep
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusNumericDecodingStep.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object["var"] = "";
                    object.type = options.enums === String ? "UINT8" : 0;
                }
                if (message["var"] != null && message.hasOwnProperty("var"))
                    object["var"] = message["var"];
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.gateway.core.ModbusNumericDecodingStep.Type[message.type] : message.type;
                return object;
            };

            /**
             * Converts this ModbusNumericDecodingStep to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusNumericDecodingStep
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusNumericDecodingStep.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Type enum.
             * @name gateway.core.ModbusNumericDecodingStep.Type
             * @enum {number}
             * @property {number} UINT8=0 UINT8 value
             * @property {number} UINT16=1 UINT16 value
             * @property {number} UINT32=2 UINT32 value
             * @property {number} UINT64=3 UINT64 value
             * @property {number} INT8=4 INT8 value
             * @property {number} INT16=5 INT16 value
             * @property {number} INT32=6 INT32 value
             * @property {number} INT64=7 INT64 value
             * @property {number} FLOAT32=8 FLOAT32 value
             * @property {number} FLOAT64=9 FLOAT64 value
             */
            ModbusNumericDecodingStep.Type = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UINT8"] = 0;
                values[valuesById[1] = "UINT16"] = 1;
                values[valuesById[2] = "UINT32"] = 2;
                values[valuesById[3] = "UINT64"] = 3;
                values[valuesById[4] = "INT8"] = 4;
                values[valuesById[5] = "INT16"] = 5;
                values[valuesById[6] = "INT32"] = 6;
                values[valuesById[7] = "INT64"] = 7;
                values[valuesById[8] = "FLOAT32"] = 8;
                values[valuesById[9] = "FLOAT64"] = 9;
                return values;
            })();

            return ModbusNumericDecodingStep;
        })();

        core.ModbusStringDecodingStep = (function() {

            /**
             * Properties of a ModbusStringDecodingStep.
             * @memberof gateway.core
             * @interface IModbusStringDecodingStep
             * @property {string|null} ["var"] ModbusStringDecodingStep var
             * @property {number|null} [size] ModbusStringDecodingStep size
             */

            /**
             * Constructs a new ModbusStringDecodingStep.
             * @memberof gateway.core
             * @classdesc Represents a ModbusStringDecodingStep.
             * @implements IModbusStringDecodingStep
             * @constructor
             * @param {gateway.core.IModbusStringDecodingStep=} [properties] Properties to set
             */
            function ModbusStringDecodingStep(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusStringDecodingStep var.
             * @member {string} var
             * @memberof gateway.core.ModbusStringDecodingStep
             * @instance
             */
            ModbusStringDecodingStep.prototype["var"] = "";

            /**
             * ModbusStringDecodingStep size.
             * @member {number} size
             * @memberof gateway.core.ModbusStringDecodingStep
             * @instance
             */
            ModbusStringDecodingStep.prototype.size = 0;

            /**
             * Creates a new ModbusStringDecodingStep instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusStringDecodingStep
             * @static
             * @param {gateway.core.IModbusStringDecodingStep=} [properties] Properties to set
             * @returns {gateway.core.ModbusStringDecodingStep} ModbusStringDecodingStep instance
             */
            ModbusStringDecodingStep.create = function create(properties) {
                return new ModbusStringDecodingStep(properties);
            };

            /**
             * Encodes the specified ModbusStringDecodingStep message. Does not implicitly {@link gateway.core.ModbusStringDecodingStep.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusStringDecodingStep
             * @static
             * @param {gateway.core.IModbusStringDecodingStep} message ModbusStringDecodingStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusStringDecodingStep.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message["var"] != null && Object.hasOwnProperty.call(message, "var"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message["var"]);
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.size);
                return writer;
            };

            /**
             * Encodes the specified ModbusStringDecodingStep message, length delimited. Does not implicitly {@link gateway.core.ModbusStringDecodingStep.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusStringDecodingStep
             * @static
             * @param {gateway.core.IModbusStringDecodingStep} message ModbusStringDecodingStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusStringDecodingStep.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusStringDecodingStep message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusStringDecodingStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusStringDecodingStep} ModbusStringDecodingStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusStringDecodingStep.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusStringDecodingStep();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message["var"] = reader.string();
                        break;
                    case 2:
                        message.size = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusStringDecodingStep message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusStringDecodingStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusStringDecodingStep} ModbusStringDecodingStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusStringDecodingStep.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusStringDecodingStep message.
             * @function verify
             * @memberof gateway.core.ModbusStringDecodingStep
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusStringDecodingStep.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message["var"] != null && message.hasOwnProperty("var"))
                    if (!$util.isString(message["var"]))
                        return "var: string expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size))
                        return "size: integer expected";
                return null;
            };

            /**
             * Creates a ModbusStringDecodingStep message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusStringDecodingStep
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusStringDecodingStep} ModbusStringDecodingStep
             */
            ModbusStringDecodingStep.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusStringDecodingStep)
                    return object;
                var message = new $root.gateway.core.ModbusStringDecodingStep();
                if (object["var"] != null)
                    message["var"] = String(object["var"]);
                if (object.size != null)
                    message.size = object.size >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a ModbusStringDecodingStep message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusStringDecodingStep
             * @static
             * @param {gateway.core.ModbusStringDecodingStep} message ModbusStringDecodingStep
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusStringDecodingStep.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object["var"] = "";
                    object.size = 0;
                }
                if (message["var"] != null && message.hasOwnProperty("var"))
                    object["var"] = message["var"];
                if (message.size != null && message.hasOwnProperty("size"))
                    object.size = message.size;
                return object;
            };

            /**
             * Converts this ModbusStringDecodingStep to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusStringDecodingStep
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusStringDecodingStep.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ModbusStringDecodingStep;
        })();

        core.ModbusSkipBytesDecodingStep = (function() {

            /**
             * Properties of a ModbusSkipBytesDecodingStep.
             * @memberof gateway.core
             * @interface IModbusSkipBytesDecodingStep
             * @property {number|null} [count] ModbusSkipBytesDecodingStep count
             */

            /**
             * Constructs a new ModbusSkipBytesDecodingStep.
             * @memberof gateway.core
             * @classdesc Represents a ModbusSkipBytesDecodingStep.
             * @implements IModbusSkipBytesDecodingStep
             * @constructor
             * @param {gateway.core.IModbusSkipBytesDecodingStep=} [properties] Properties to set
             */
            function ModbusSkipBytesDecodingStep(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModbusSkipBytesDecodingStep count.
             * @member {number} count
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @instance
             */
            ModbusSkipBytesDecodingStep.prototype.count = 0;

            /**
             * Creates a new ModbusSkipBytesDecodingStep instance using the specified properties.
             * @function create
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @static
             * @param {gateway.core.IModbusSkipBytesDecodingStep=} [properties] Properties to set
             * @returns {gateway.core.ModbusSkipBytesDecodingStep} ModbusSkipBytesDecodingStep instance
             */
            ModbusSkipBytesDecodingStep.create = function create(properties) {
                return new ModbusSkipBytesDecodingStep(properties);
            };

            /**
             * Encodes the specified ModbusSkipBytesDecodingStep message. Does not implicitly {@link gateway.core.ModbusSkipBytesDecodingStep.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @static
             * @param {gateway.core.IModbusSkipBytesDecodingStep} message ModbusSkipBytesDecodingStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusSkipBytesDecodingStep.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.count);
                return writer;
            };

            /**
             * Encodes the specified ModbusSkipBytesDecodingStep message, length delimited. Does not implicitly {@link gateway.core.ModbusSkipBytesDecodingStep.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @static
             * @param {gateway.core.IModbusSkipBytesDecodingStep} message ModbusSkipBytesDecodingStep message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModbusSkipBytesDecodingStep.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModbusSkipBytesDecodingStep message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ModbusSkipBytesDecodingStep} ModbusSkipBytesDecodingStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusSkipBytesDecodingStep.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ModbusSkipBytesDecodingStep();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.count = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModbusSkipBytesDecodingStep message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ModbusSkipBytesDecodingStep} ModbusSkipBytesDecodingStep
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModbusSkipBytesDecodingStep.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModbusSkipBytesDecodingStep message.
             * @function verify
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModbusSkipBytesDecodingStep.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                return null;
            };

            /**
             * Creates a ModbusSkipBytesDecodingStep message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ModbusSkipBytesDecodingStep} ModbusSkipBytesDecodingStep
             */
            ModbusSkipBytesDecodingStep.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ModbusSkipBytesDecodingStep)
                    return object;
                var message = new $root.gateway.core.ModbusSkipBytesDecodingStep();
                if (object.count != null)
                    message.count = object.count >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a ModbusSkipBytesDecodingStep message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @static
             * @param {gateway.core.ModbusSkipBytesDecodingStep} message ModbusSkipBytesDecodingStep
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModbusSkipBytesDecodingStep.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.count = 0;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                return object;
            };

            /**
             * Converts this ModbusSkipBytesDecodingStep to JSON.
             * @function toJSON
             * @memberof gateway.core.ModbusSkipBytesDecodingStep
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModbusSkipBytesDecodingStep.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ModbusSkipBytesDecodingStep;
        })();

        core.Telemetry = (function() {

            /**
             * Constructs a new Telemetry service.
             * @memberof gateway.core
             * @classdesc Represents a Telemetry
             * @extends $protobuf.rpc.Service
             * @constructor
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             */
            function Telemetry(rpcImpl, requestDelimited, responseDelimited) {
                $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
            }

            (Telemetry.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Telemetry;

            /**
             * Creates new Telemetry service using the specified rpc implementation.
             * @function create
             * @memberof gateway.core.Telemetry
             * @static
             * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
             * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
             * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
             * @returns {Telemetry} RPC service. Useful where requests and/or responses are streamed.
             */
            Telemetry.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                return new this(rpcImpl, requestDelimited, responseDelimited);
            };

            /**
             * Callback as used by {@link gateway.core.Telemetry#readAll}.
             * @memberof gateway.core.Telemetry
             * @typedef ReadAllCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.Measurement} [response] Measurement
             */

            /**
             * Calls ReadAll.
             * @function readAll
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.IReadAllRequest} request ReadAllRequest message or plain object
             * @param {gateway.core.Telemetry.ReadAllCallback} callback Node-style callback called with the error, if any, and Measurement
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Telemetry.prototype.readAll = function readAll(request, callback) {
                return this.rpcCall(readAll, $root.gateway.core.ReadAllRequest, $root.gateway.core.Measurement, request, callback);
            }, "name", { value: "ReadAll" });

            /**
             * Calls ReadAll.
             * @function readAll
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.IReadAllRequest} request ReadAllRequest message or plain object
             * @returns {Promise<gateway.core.Measurement>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Telemetry#readIvCurves}.
             * @memberof gateway.core.Telemetry
             * @typedef ReadIvCurvesCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.IvCurveMeasurement} [response] IvCurveMeasurement
             */

            /**
             * Calls ReadIvCurves.
             * @function readIvCurves
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.IReadIvCurvesRequest} request ReadIvCurvesRequest message or plain object
             * @param {gateway.core.Telemetry.ReadIvCurvesCallback} callback Node-style callback called with the error, if any, and IvCurveMeasurement
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Telemetry.prototype.readIvCurves = function readIvCurves(request, callback) {
                return this.rpcCall(readIvCurves, $root.gateway.core.ReadIvCurvesRequest, $root.gateway.core.IvCurveMeasurement, request, callback);
            }, "name", { value: "ReadIvCurves" });

            /**
             * Calls ReadIvCurves.
             * @function readIvCurves
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.IReadIvCurvesRequest} request ReadIvCurvesRequest message or plain object
             * @returns {Promise<gateway.core.IvCurveMeasurement>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Telemetry#readSensorData}.
             * @memberof gateway.core.Telemetry
             * @typedef ReadSensorDataCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.SensorDataMeasurement} [response] SensorDataMeasurement
             */

            /**
             * Calls ReadSensorData.
             * @function readSensorData
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.IReadIvCurvesRequest} request ReadIvCurvesRequest message or plain object
             * @param {gateway.core.Telemetry.ReadSensorDataCallback} callback Node-style callback called with the error, if any, and SensorDataMeasurement
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Telemetry.prototype.readSensorData = function readSensorData(request, callback) {
                return this.rpcCall(readSensorData, $root.gateway.core.ReadIvCurvesRequest, $root.gateway.core.SensorDataMeasurement, request, callback);
            }, "name", { value: "ReadSensorData" });

            /**
             * Calls ReadSensorData.
             * @function readSensorData
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.IReadIvCurvesRequest} request ReadIvCurvesRequest message or plain object
             * @returns {Promise<gateway.core.SensorDataMeasurement>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Telemetry#setIvCurveCollectionInterval}.
             * @memberof gateway.core.Telemetry
             * @typedef SetIvCurveCollectionIntervalCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls SetIvCurveCollectionInterval.
             * @function setIvCurveCollectionInterval
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.ICollectionIntervalRequest} request CollectionIntervalRequest message or plain object
             * @param {gateway.core.Telemetry.SetIvCurveCollectionIntervalCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Telemetry.prototype.setIvCurveCollectionInterval = function setIvCurveCollectionInterval(request, callback) {
                return this.rpcCall(setIvCurveCollectionInterval, $root.gateway.core.CollectionIntervalRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "SetIvCurveCollectionInterval" });

            /**
             * Calls SetIvCurveCollectionInterval.
             * @function setIvCurveCollectionInterval
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.ICollectionIntervalRequest} request CollectionIntervalRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Telemetry#getIvCurveCollectionInterval}.
             * @memberof gateway.core.Telemetry
             * @typedef GetIvCurveCollectionIntervalCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.CollectionIntervalResponse} [response] CollectionIntervalResponse
             */

            /**
             * Calls GetIvCurveCollectionInterval.
             * @function getIvCurveCollectionInterval
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @param {gateway.core.Telemetry.GetIvCurveCollectionIntervalCallback} callback Node-style callback called with the error, if any, and CollectionIntervalResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Telemetry.prototype.getIvCurveCollectionInterval = function getIvCurveCollectionInterval(request, callback) {
                return this.rpcCall(getIvCurveCollectionInterval, $root.google.protobuf.Empty, $root.gateway.core.CollectionIntervalResponse, request, callback);
            }, "name", { value: "GetIvCurveCollectionInterval" });

            /**
             * Calls GetIvCurveCollectionInterval.
             * @function getIvCurveCollectionInterval
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @returns {Promise<gateway.core.CollectionIntervalResponse>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Telemetry#setOperatingPowerCollectionInterval}.
             * @memberof gateway.core.Telemetry
             * @typedef SetOperatingPowerCollectionIntervalCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {google.protobuf.Empty} [response] Empty
             */

            /**
             * Calls SetOperatingPowerCollectionInterval.
             * @function setOperatingPowerCollectionInterval
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.ICollectionIntervalRequest} request CollectionIntervalRequest message or plain object
             * @param {gateway.core.Telemetry.SetOperatingPowerCollectionIntervalCallback} callback Node-style callback called with the error, if any, and Empty
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Telemetry.prototype.setOperatingPowerCollectionInterval = function setOperatingPowerCollectionInterval(request, callback) {
                return this.rpcCall(setOperatingPowerCollectionInterval, $root.gateway.core.CollectionIntervalRequest, $root.google.protobuf.Empty, request, callback);
            }, "name", { value: "SetOperatingPowerCollectionInterval" });

            /**
             * Calls SetOperatingPowerCollectionInterval.
             * @function setOperatingPowerCollectionInterval
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {gateway.core.ICollectionIntervalRequest} request CollectionIntervalRequest message or plain object
             * @returns {Promise<google.protobuf.Empty>} Promise
             * @variation 2
             */

            /**
             * Callback as used by {@link gateway.core.Telemetry#getOperatingPowerCollectionInterval}.
             * @memberof gateway.core.Telemetry
             * @typedef GetOperatingPowerCollectionIntervalCallback
             * @type {function}
             * @param {Error|null} error Error, if any
             * @param {gateway.core.CollectionIntervalResponse} [response] CollectionIntervalResponse
             */

            /**
             * Calls GetOperatingPowerCollectionInterval.
             * @function getOperatingPowerCollectionInterval
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @param {gateway.core.Telemetry.GetOperatingPowerCollectionIntervalCallback} callback Node-style callback called with the error, if any, and CollectionIntervalResponse
             * @returns {undefined}
             * @variation 1
             */
            Object.defineProperty(Telemetry.prototype.getOperatingPowerCollectionInterval = function getOperatingPowerCollectionInterval(request, callback) {
                return this.rpcCall(getOperatingPowerCollectionInterval, $root.google.protobuf.Empty, $root.gateway.core.CollectionIntervalResponse, request, callback);
            }, "name", { value: "GetOperatingPowerCollectionInterval" });

            /**
             * Calls GetOperatingPowerCollectionInterval.
             * @function getOperatingPowerCollectionInterval
             * @memberof gateway.core.Telemetry
             * @instance
             * @param {google.protobuf.IEmpty} request Empty message or plain object
             * @returns {Promise<gateway.core.CollectionIntervalResponse>} Promise
             * @variation 2
             */

            return Telemetry;
        })();

        core.ReadAllRequest = (function() {

            /**
             * Properties of a ReadAllRequest.
             * @memberof gateway.core
             * @interface IReadAllRequest
             * @property {google.protobuf.ITimestamp|null} [since] ReadAllRequest since
             * @property {google.protobuf.ITimestamp|null} [until] ReadAllRequest until
             */

            /**
             * Constructs a new ReadAllRequest.
             * @memberof gateway.core
             * @classdesc Represents a ReadAllRequest.
             * @implements IReadAllRequest
             * @constructor
             * @param {gateway.core.IReadAllRequest=} [properties] Properties to set
             */
            function ReadAllRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReadAllRequest since.
             * @member {google.protobuf.ITimestamp|null|undefined} since
             * @memberof gateway.core.ReadAllRequest
             * @instance
             */
            ReadAllRequest.prototype.since = null;

            /**
             * ReadAllRequest until.
             * @member {google.protobuf.ITimestamp|null|undefined} until
             * @memberof gateway.core.ReadAllRequest
             * @instance
             */
            ReadAllRequest.prototype.until = null;

            /**
             * Creates a new ReadAllRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.ReadAllRequest
             * @static
             * @param {gateway.core.IReadAllRequest=} [properties] Properties to set
             * @returns {gateway.core.ReadAllRequest} ReadAllRequest instance
             */
            ReadAllRequest.create = function create(properties) {
                return new ReadAllRequest(properties);
            };

            /**
             * Encodes the specified ReadAllRequest message. Does not implicitly {@link gateway.core.ReadAllRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ReadAllRequest
             * @static
             * @param {gateway.core.IReadAllRequest} message ReadAllRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReadAllRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.since != null && Object.hasOwnProperty.call(message, "since"))
                    $root.google.protobuf.Timestamp.encode(message.since, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.until != null && Object.hasOwnProperty.call(message, "until"))
                    $root.google.protobuf.Timestamp.encode(message.until, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ReadAllRequest message, length delimited. Does not implicitly {@link gateway.core.ReadAllRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ReadAllRequest
             * @static
             * @param {gateway.core.IReadAllRequest} message ReadAllRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReadAllRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReadAllRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ReadAllRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ReadAllRequest} ReadAllRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReadAllRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ReadAllRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.since = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.until = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReadAllRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ReadAllRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ReadAllRequest} ReadAllRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReadAllRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReadAllRequest message.
             * @function verify
             * @memberof gateway.core.ReadAllRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReadAllRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.since != null && message.hasOwnProperty("since")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.since);
                    if (error)
                        return "since." + error;
                }
                if (message.until != null && message.hasOwnProperty("until")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.until);
                    if (error)
                        return "until." + error;
                }
                return null;
            };

            /**
             * Creates a ReadAllRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ReadAllRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ReadAllRequest} ReadAllRequest
             */
            ReadAllRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ReadAllRequest)
                    return object;
                var message = new $root.gateway.core.ReadAllRequest();
                if (object.since != null) {
                    if (typeof object.since !== "object")
                        throw TypeError(".gateway.core.ReadAllRequest.since: object expected");
                    message.since = $root.google.protobuf.Timestamp.fromObject(object.since);
                }
                if (object.until != null) {
                    if (typeof object.until !== "object")
                        throw TypeError(".gateway.core.ReadAllRequest.until: object expected");
                    message.until = $root.google.protobuf.Timestamp.fromObject(object.until);
                }
                return message;
            };

            /**
             * Creates a plain object from a ReadAllRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ReadAllRequest
             * @static
             * @param {gateway.core.ReadAllRequest} message ReadAllRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReadAllRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.since = null;
                    object.until = null;
                }
                if (message.since != null && message.hasOwnProperty("since"))
                    object.since = $root.google.protobuf.Timestamp.toObject(message.since, options);
                if (message.until != null && message.hasOwnProperty("until"))
                    object.until = $root.google.protobuf.Timestamp.toObject(message.until, options);
                return object;
            };

            /**
             * Converts this ReadAllRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.ReadAllRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReadAllRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReadAllRequest;
        })();

        core.ReadIvCurvesRequest = (function() {

            /**
             * Properties of a ReadIvCurvesRequest.
             * @memberof gateway.core
             * @interface IReadIvCurvesRequest
             * @property {google.protobuf.ITimestamp|null} [since] ReadIvCurvesRequest since
             * @property {google.protobuf.ITimestamp|null} [until] ReadIvCurvesRequest until
             */

            /**
             * Constructs a new ReadIvCurvesRequest.
             * @memberof gateway.core
             * @classdesc Represents a ReadIvCurvesRequest.
             * @implements IReadIvCurvesRequest
             * @constructor
             * @param {gateway.core.IReadIvCurvesRequest=} [properties] Properties to set
             */
            function ReadIvCurvesRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReadIvCurvesRequest since.
             * @member {google.protobuf.ITimestamp|null|undefined} since
             * @memberof gateway.core.ReadIvCurvesRequest
             * @instance
             */
            ReadIvCurvesRequest.prototype.since = null;

            /**
             * ReadIvCurvesRequest until.
             * @member {google.protobuf.ITimestamp|null|undefined} until
             * @memberof gateway.core.ReadIvCurvesRequest
             * @instance
             */
            ReadIvCurvesRequest.prototype.until = null;

            /**
             * Creates a new ReadIvCurvesRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.ReadIvCurvesRequest
             * @static
             * @param {gateway.core.IReadIvCurvesRequest=} [properties] Properties to set
             * @returns {gateway.core.ReadIvCurvesRequest} ReadIvCurvesRequest instance
             */
            ReadIvCurvesRequest.create = function create(properties) {
                return new ReadIvCurvesRequest(properties);
            };

            /**
             * Encodes the specified ReadIvCurvesRequest message. Does not implicitly {@link gateway.core.ReadIvCurvesRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ReadIvCurvesRequest
             * @static
             * @param {gateway.core.IReadIvCurvesRequest} message ReadIvCurvesRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReadIvCurvesRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.since != null && Object.hasOwnProperty.call(message, "since"))
                    $root.google.protobuf.Timestamp.encode(message.since, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.until != null && Object.hasOwnProperty.call(message, "until"))
                    $root.google.protobuf.Timestamp.encode(message.until, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ReadIvCurvesRequest message, length delimited. Does not implicitly {@link gateway.core.ReadIvCurvesRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ReadIvCurvesRequest
             * @static
             * @param {gateway.core.IReadIvCurvesRequest} message ReadIvCurvesRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReadIvCurvesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReadIvCurvesRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ReadIvCurvesRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ReadIvCurvesRequest} ReadIvCurvesRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReadIvCurvesRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ReadIvCurvesRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.since = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.until = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReadIvCurvesRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ReadIvCurvesRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ReadIvCurvesRequest} ReadIvCurvesRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReadIvCurvesRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReadIvCurvesRequest message.
             * @function verify
             * @memberof gateway.core.ReadIvCurvesRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReadIvCurvesRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.since != null && message.hasOwnProperty("since")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.since);
                    if (error)
                        return "since." + error;
                }
                if (message.until != null && message.hasOwnProperty("until")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.until);
                    if (error)
                        return "until." + error;
                }
                return null;
            };

            /**
             * Creates a ReadIvCurvesRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ReadIvCurvesRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ReadIvCurvesRequest} ReadIvCurvesRequest
             */
            ReadIvCurvesRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ReadIvCurvesRequest)
                    return object;
                var message = new $root.gateway.core.ReadIvCurvesRequest();
                if (object.since != null) {
                    if (typeof object.since !== "object")
                        throw TypeError(".gateway.core.ReadIvCurvesRequest.since: object expected");
                    message.since = $root.google.protobuf.Timestamp.fromObject(object.since);
                }
                if (object.until != null) {
                    if (typeof object.until !== "object")
                        throw TypeError(".gateway.core.ReadIvCurvesRequest.until: object expected");
                    message.until = $root.google.protobuf.Timestamp.fromObject(object.until);
                }
                return message;
            };

            /**
             * Creates a plain object from a ReadIvCurvesRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ReadIvCurvesRequest
             * @static
             * @param {gateway.core.ReadIvCurvesRequest} message ReadIvCurvesRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReadIvCurvesRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.since = null;
                    object.until = null;
                }
                if (message.since != null && message.hasOwnProperty("since"))
                    object.since = $root.google.protobuf.Timestamp.toObject(message.since, options);
                if (message.until != null && message.hasOwnProperty("until"))
                    object.until = $root.google.protobuf.Timestamp.toObject(message.until, options);
                return object;
            };

            /**
             * Converts this ReadIvCurvesRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.ReadIvCurvesRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReadIvCurvesRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReadIvCurvesRequest;
        })();

        core.ReadReadSensorDataRequest = (function() {

            /**
             * Properties of a ReadReadSensorDataRequest.
             * @memberof gateway.core
             * @interface IReadReadSensorDataRequest
             * @property {string|null} [sensorTelemetryType] ReadReadSensorDataRequest sensorTelemetryType
             * @property {google.protobuf.ITimestamp|null} [since] ReadReadSensorDataRequest since
             * @property {google.protobuf.ITimestamp|null} [until] ReadReadSensorDataRequest until
             */

            /**
             * Constructs a new ReadReadSensorDataRequest.
             * @memberof gateway.core
             * @classdesc Represents a ReadReadSensorDataRequest.
             * @implements IReadReadSensorDataRequest
             * @constructor
             * @param {gateway.core.IReadReadSensorDataRequest=} [properties] Properties to set
             */
            function ReadReadSensorDataRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReadReadSensorDataRequest sensorTelemetryType.
             * @member {string} sensorTelemetryType
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @instance
             */
            ReadReadSensorDataRequest.prototype.sensorTelemetryType = "";

            /**
             * ReadReadSensorDataRequest since.
             * @member {google.protobuf.ITimestamp|null|undefined} since
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @instance
             */
            ReadReadSensorDataRequest.prototype.since = null;

            /**
             * ReadReadSensorDataRequest until.
             * @member {google.protobuf.ITimestamp|null|undefined} until
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @instance
             */
            ReadReadSensorDataRequest.prototype.until = null;

            /**
             * Creates a new ReadReadSensorDataRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @static
             * @param {gateway.core.IReadReadSensorDataRequest=} [properties] Properties to set
             * @returns {gateway.core.ReadReadSensorDataRequest} ReadReadSensorDataRequest instance
             */
            ReadReadSensorDataRequest.create = function create(properties) {
                return new ReadReadSensorDataRequest(properties);
            };

            /**
             * Encodes the specified ReadReadSensorDataRequest message. Does not implicitly {@link gateway.core.ReadReadSensorDataRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @static
             * @param {gateway.core.IReadReadSensorDataRequest} message ReadReadSensorDataRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReadReadSensorDataRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.sensorTelemetryType != null && Object.hasOwnProperty.call(message, "sensorTelemetryType"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sensorTelemetryType);
                if (message.since != null && Object.hasOwnProperty.call(message, "since"))
                    $root.google.protobuf.Timestamp.encode(message.since, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.until != null && Object.hasOwnProperty.call(message, "until"))
                    $root.google.protobuf.Timestamp.encode(message.until, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ReadReadSensorDataRequest message, length delimited. Does not implicitly {@link gateway.core.ReadReadSensorDataRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @static
             * @param {gateway.core.IReadReadSensorDataRequest} message ReadReadSensorDataRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReadReadSensorDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReadReadSensorDataRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.ReadReadSensorDataRequest} ReadReadSensorDataRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReadReadSensorDataRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.ReadReadSensorDataRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.sensorTelemetryType = reader.string();
                        break;
                    case 2:
                        message.since = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.until = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReadReadSensorDataRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.ReadReadSensorDataRequest} ReadReadSensorDataRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReadReadSensorDataRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReadReadSensorDataRequest message.
             * @function verify
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReadReadSensorDataRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.sensorTelemetryType != null && message.hasOwnProperty("sensorTelemetryType"))
                    if (!$util.isString(message.sensorTelemetryType))
                        return "sensorTelemetryType: string expected";
                if (message.since != null && message.hasOwnProperty("since")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.since);
                    if (error)
                        return "since." + error;
                }
                if (message.until != null && message.hasOwnProperty("until")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.until);
                    if (error)
                        return "until." + error;
                }
                return null;
            };

            /**
             * Creates a ReadReadSensorDataRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.ReadReadSensorDataRequest} ReadReadSensorDataRequest
             */
            ReadReadSensorDataRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.ReadReadSensorDataRequest)
                    return object;
                var message = new $root.gateway.core.ReadReadSensorDataRequest();
                if (object.sensorTelemetryType != null)
                    message.sensorTelemetryType = String(object.sensorTelemetryType);
                if (object.since != null) {
                    if (typeof object.since !== "object")
                        throw TypeError(".gateway.core.ReadReadSensorDataRequest.since: object expected");
                    message.since = $root.google.protobuf.Timestamp.fromObject(object.since);
                }
                if (object.until != null) {
                    if (typeof object.until !== "object")
                        throw TypeError(".gateway.core.ReadReadSensorDataRequest.until: object expected");
                    message.until = $root.google.protobuf.Timestamp.fromObject(object.until);
                }
                return message;
            };

            /**
             * Creates a plain object from a ReadReadSensorDataRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @static
             * @param {gateway.core.ReadReadSensorDataRequest} message ReadReadSensorDataRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReadReadSensorDataRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.sensorTelemetryType = "";
                    object.since = null;
                    object.until = null;
                }
                if (message.sensorTelemetryType != null && message.hasOwnProperty("sensorTelemetryType"))
                    object.sensorTelemetryType = message.sensorTelemetryType;
                if (message.since != null && message.hasOwnProperty("since"))
                    object.since = $root.google.protobuf.Timestamp.toObject(message.since, options);
                if (message.until != null && message.hasOwnProperty("until"))
                    object.until = $root.google.protobuf.Timestamp.toObject(message.until, options);
                return object;
            };

            /**
             * Converts this ReadReadSensorDataRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.ReadReadSensorDataRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReadReadSensorDataRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReadReadSensorDataRequest;
        })();

        core.Measurement = (function() {

            /**
             * Properties of a Measurement.
             * @memberof gateway.core
             * @interface IMeasurement
             * @property {google.protobuf.ITimestamp|null} [timestamp] Measurement timestamp
             * @property {string|null} [telemetryType] Measurement telemetryType
             * @property {google.protobuf.IStruct|null} [data] Measurement data
             */

            /**
             * Constructs a new Measurement.
             * @memberof gateway.core
             * @classdesc Represents a Measurement.
             * @implements IMeasurement
             * @constructor
             * @param {gateway.core.IMeasurement=} [properties] Properties to set
             */
            function Measurement(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Measurement timestamp.
             * @member {google.protobuf.ITimestamp|null|undefined} timestamp
             * @memberof gateway.core.Measurement
             * @instance
             */
            Measurement.prototype.timestamp = null;

            /**
             * Measurement telemetryType.
             * @member {string} telemetryType
             * @memberof gateway.core.Measurement
             * @instance
             */
            Measurement.prototype.telemetryType = "";

            /**
             * Measurement data.
             * @member {google.protobuf.IStruct|null|undefined} data
             * @memberof gateway.core.Measurement
             * @instance
             */
            Measurement.prototype.data = null;

            /**
             * Creates a new Measurement instance using the specified properties.
             * @function create
             * @memberof gateway.core.Measurement
             * @static
             * @param {gateway.core.IMeasurement=} [properties] Properties to set
             * @returns {gateway.core.Measurement} Measurement instance
             */
            Measurement.create = function create(properties) {
                return new Measurement(properties);
            };

            /**
             * Encodes the specified Measurement message. Does not implicitly {@link gateway.core.Measurement.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.Measurement
             * @static
             * @param {gateway.core.IMeasurement} message Measurement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Measurement.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.telemetryType != null && Object.hasOwnProperty.call(message, "telemetryType"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.telemetryType);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    $root.google.protobuf.Struct.encode(message.data, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Measurement message, length delimited. Does not implicitly {@link gateway.core.Measurement.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.Measurement
             * @static
             * @param {gateway.core.IMeasurement} message Measurement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Measurement.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Measurement message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.Measurement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.Measurement} Measurement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Measurement.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.Measurement();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.telemetryType = reader.string();
                        break;
                    case 3:
                        message.data = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Measurement message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.Measurement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.Measurement} Measurement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Measurement.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Measurement message.
             * @function verify
             * @memberof gateway.core.Measurement
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Measurement.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp")) {
                    var error = $root.google.protobuf.Timestamp.verify(message.timestamp);
                    if (error)
                        return "timestamp." + error;
                }
                if (message.telemetryType != null && message.hasOwnProperty("telemetryType"))
                    if (!$util.isString(message.telemetryType))
                        return "telemetryType: string expected";
                if (message.data != null && message.hasOwnProperty("data")) {
                    var error = $root.google.protobuf.Struct.verify(message.data);
                    if (error)
                        return "data." + error;
                }
                return null;
            };

            /**
             * Creates a Measurement message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.Measurement
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.Measurement} Measurement
             */
            Measurement.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.Measurement)
                    return object;
                var message = new $root.gateway.core.Measurement();
                if (object.timestamp != null) {
                    if (typeof object.timestamp !== "object")
                        throw TypeError(".gateway.core.Measurement.timestamp: object expected");
                    message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp);
                }
                if (object.telemetryType != null)
                    message.telemetryType = String(object.telemetryType);
                if (object.data != null) {
                    if (typeof object.data !== "object")
                        throw TypeError(".gateway.core.Measurement.data: object expected");
                    message.data = $root.google.protobuf.Struct.fromObject(object.data);
                }
                return message;
            };

            /**
             * Creates a plain object from a Measurement message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.Measurement
             * @static
             * @param {gateway.core.Measurement} message Measurement
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Measurement.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.timestamp = null;
                    object.telemetryType = "";
                    object.data = null;
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options);
                if (message.telemetryType != null && message.hasOwnProperty("telemetryType"))
                    object.telemetryType = message.telemetryType;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = $root.google.protobuf.Struct.toObject(message.data, options);
                return object;
            };

            /**
             * Converts this Measurement to JSON.
             * @function toJSON
             * @memberof gateway.core.Measurement
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Measurement.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Measurement;
        })();

        core.CollectionIntervalRequest = (function() {

            /**
             * Properties of a CollectionIntervalRequest.
             * @memberof gateway.core
             * @interface ICollectionIntervalRequest
             * @property {google.protobuf.IDuration|null} [interval] CollectionIntervalRequest interval
             */

            /**
             * Constructs a new CollectionIntervalRequest.
             * @memberof gateway.core
             * @classdesc Represents a CollectionIntervalRequest.
             * @implements ICollectionIntervalRequest
             * @constructor
             * @param {gateway.core.ICollectionIntervalRequest=} [properties] Properties to set
             */
            function CollectionIntervalRequest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CollectionIntervalRequest interval.
             * @member {google.protobuf.IDuration|null|undefined} interval
             * @memberof gateway.core.CollectionIntervalRequest
             * @instance
             */
            CollectionIntervalRequest.prototype.interval = null;

            /**
             * Creates a new CollectionIntervalRequest instance using the specified properties.
             * @function create
             * @memberof gateway.core.CollectionIntervalRequest
             * @static
             * @param {gateway.core.ICollectionIntervalRequest=} [properties] Properties to set
             * @returns {gateway.core.CollectionIntervalRequest} CollectionIntervalRequest instance
             */
            CollectionIntervalRequest.create = function create(properties) {
                return new CollectionIntervalRequest(properties);
            };

            /**
             * Encodes the specified CollectionIntervalRequest message. Does not implicitly {@link gateway.core.CollectionIntervalRequest.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.CollectionIntervalRequest
             * @static
             * @param {gateway.core.ICollectionIntervalRequest} message CollectionIntervalRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CollectionIntervalRequest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.interval != null && Object.hasOwnProperty.call(message, "interval"))
                    $root.google.protobuf.Duration.encode(message.interval, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CollectionIntervalRequest message, length delimited. Does not implicitly {@link gateway.core.CollectionIntervalRequest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.CollectionIntervalRequest
             * @static
             * @param {gateway.core.ICollectionIntervalRequest} message CollectionIntervalRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CollectionIntervalRequest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CollectionIntervalRequest message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.CollectionIntervalRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.CollectionIntervalRequest} CollectionIntervalRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CollectionIntervalRequest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.CollectionIntervalRequest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.interval = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CollectionIntervalRequest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.CollectionIntervalRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.CollectionIntervalRequest} CollectionIntervalRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CollectionIntervalRequest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CollectionIntervalRequest message.
             * @function verify
             * @memberof gateway.core.CollectionIntervalRequest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CollectionIntervalRequest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.interval != null && message.hasOwnProperty("interval")) {
                    var error = $root.google.protobuf.Duration.verify(message.interval);
                    if (error)
                        return "interval." + error;
                }
                return null;
            };

            /**
             * Creates a CollectionIntervalRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.CollectionIntervalRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.CollectionIntervalRequest} CollectionIntervalRequest
             */
            CollectionIntervalRequest.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.CollectionIntervalRequest)
                    return object;
                var message = new $root.gateway.core.CollectionIntervalRequest();
                if (object.interval != null) {
                    if (typeof object.interval !== "object")
                        throw TypeError(".gateway.core.CollectionIntervalRequest.interval: object expected");
                    message.interval = $root.google.protobuf.Duration.fromObject(object.interval);
                }
                return message;
            };

            /**
             * Creates a plain object from a CollectionIntervalRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.CollectionIntervalRequest
             * @static
             * @param {gateway.core.CollectionIntervalRequest} message CollectionIntervalRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CollectionIntervalRequest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.interval = null;
                if (message.interval != null && message.hasOwnProperty("interval"))
                    object.interval = $root.google.protobuf.Duration.toObject(message.interval, options);
                return object;
            };

            /**
             * Converts this CollectionIntervalRequest to JSON.
             * @function toJSON
             * @memberof gateway.core.CollectionIntervalRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CollectionIntervalRequest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CollectionIntervalRequest;
        })();

        core.CollectionIntervalResponse = (function() {

            /**
             * Properties of a CollectionIntervalResponse.
             * @memberof gateway.core
             * @interface ICollectionIntervalResponse
             * @property {google.protobuf.IDuration|null} [interval] CollectionIntervalResponse interval
             */

            /**
             * Constructs a new CollectionIntervalResponse.
             * @memberof gateway.core
             * @classdesc Represents a CollectionIntervalResponse.
             * @implements ICollectionIntervalResponse
             * @constructor
             * @param {gateway.core.ICollectionIntervalResponse=} [properties] Properties to set
             */
            function CollectionIntervalResponse(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CollectionIntervalResponse interval.
             * @member {google.protobuf.IDuration|null|undefined} interval
             * @memberof gateway.core.CollectionIntervalResponse
             * @instance
             */
            CollectionIntervalResponse.prototype.interval = null;

            /**
             * Creates a new CollectionIntervalResponse instance using the specified properties.
             * @function create
             * @memberof gateway.core.CollectionIntervalResponse
             * @static
             * @param {gateway.core.ICollectionIntervalResponse=} [properties] Properties to set
             * @returns {gateway.core.CollectionIntervalResponse} CollectionIntervalResponse instance
             */
            CollectionIntervalResponse.create = function create(properties) {
                return new CollectionIntervalResponse(properties);
            };

            /**
             * Encodes the specified CollectionIntervalResponse message. Does not implicitly {@link gateway.core.CollectionIntervalResponse.verify|verify} messages.
             * @function encode
             * @memberof gateway.core.CollectionIntervalResponse
             * @static
             * @param {gateway.core.ICollectionIntervalResponse} message CollectionIntervalResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CollectionIntervalResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.interval != null && Object.hasOwnProperty.call(message, "interval"))
                    $root.google.protobuf.Duration.encode(message.interval, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified CollectionIntervalResponse message, length delimited. Does not implicitly {@link gateway.core.CollectionIntervalResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof gateway.core.CollectionIntervalResponse
             * @static
             * @param {gateway.core.ICollectionIntervalResponse} message CollectionIntervalResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CollectionIntervalResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CollectionIntervalResponse message from the specified reader or buffer.
             * @function decode
             * @memberof gateway.core.CollectionIntervalResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {gateway.core.CollectionIntervalResponse} CollectionIntervalResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CollectionIntervalResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.gateway.core.CollectionIntervalResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.interval = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CollectionIntervalResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof gateway.core.CollectionIntervalResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {gateway.core.CollectionIntervalResponse} CollectionIntervalResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CollectionIntervalResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CollectionIntervalResponse message.
             * @function verify
             * @memberof gateway.core.CollectionIntervalResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CollectionIntervalResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.interval != null && message.hasOwnProperty("interval")) {
                    var error = $root.google.protobuf.Duration.verify(message.interval);
                    if (error)
                        return "interval." + error;
                }
                return null;
            };

            /**
             * Creates a CollectionIntervalResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof gateway.core.CollectionIntervalResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {gateway.core.CollectionIntervalResponse} CollectionIntervalResponse
             */
            CollectionIntervalResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.gateway.core.CollectionIntervalResponse)
                    return object;
                var message = new $root.gateway.core.CollectionIntervalResponse();
                if (object.interval != null) {
                    if (typeof object.interval !== "object")
                        throw TypeError(".gateway.core.CollectionIntervalResponse.interval: object expected");
                    message.interval = $root.google.protobuf.Duration.fromObject(object.interval);
                }
                return message;
            };

            /**
             * Creates a plain object from a CollectionIntervalResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof gateway.core.CollectionIntervalResponse
             * @static
             * @param {gateway.core.CollectionIntervalResponse} message CollectionIntervalResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CollectionIntervalResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.interval = null;
                if (message.interval != null && message.hasOwnProperty("interval"))
                    object.interval = $root.google.protobuf.Duration.toObject(message.interval, options);
                return object;
            };

            /**
             * Converts this CollectionIntervalResponse to JSON.
             * @function toJSON
             * @memberof gateway.core.CollectionIntervalResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CollectionIntervalResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CollectionIntervalResponse;
        })();

        return core;
    })();

    return gateway;
})();

$root.google = (function() {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    var google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        var protobuf = {};

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             */
            function Timestamp(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.seconds = reader.int64();
                        break;
                    case 2:
                        message.nanos = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Timestamp message.
             * @function verify
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Timestamp.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                var message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Timestamp;
        })();

        protobuf.Struct = (function() {

            /**
             * Properties of a Struct.
             * @memberof google.protobuf
             * @interface IStruct
             * @property {Object.<string,google.protobuf.IValue>|null} [fields] Struct fields
             */

            /**
             * Constructs a new Struct.
             * @memberof google.protobuf
             * @classdesc Represents a Struct.
             * @implements IStruct
             * @constructor
             * @param {google.protobuf.IStruct=} [properties] Properties to set
             */
            function Struct(properties) {
                this.fields = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Struct fields.
             * @member {Object.<string,google.protobuf.IValue>} fields
             * @memberof google.protobuf.Struct
             * @instance
             */
            Struct.prototype.fields = $util.emptyObject;

            /**
             * Creates a new Struct instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.IStruct=} [properties] Properties to set
             * @returns {google.protobuf.Struct} Struct instance
             */
            Struct.create = function create(properties) {
                return new Struct(properties);
            };

            /**
             * Encodes the specified Struct message. Does not implicitly {@link google.protobuf.Struct.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.IStruct} message Struct message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Struct.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.fields != null && Object.hasOwnProperty.call(message, "fields"))
                    for (var keys = Object.keys(message.fields), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.google.protobuf.Value.encode(message.fields[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified Struct message, length delimited. Does not implicitly {@link google.protobuf.Struct.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.IStruct} message Struct message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Struct.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Struct message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Struct
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Struct} Struct
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Struct.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Struct(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.fields === $util.emptyObject)
                            message.fields = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.google.protobuf.Value.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.fields[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Struct message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Struct
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Struct} Struct
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Struct.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Struct message.
             * @function verify
             * @memberof google.protobuf.Struct
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Struct.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.fields != null && message.hasOwnProperty("fields")) {
                    if (!$util.isObject(message.fields))
                        return "fields: object expected";
                    var key = Object.keys(message.fields);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.google.protobuf.Value.verify(message.fields[key[i]]);
                        if (error)
                            return "fields." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Struct message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Struct
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Struct} Struct
             */
            Struct.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Struct)
                    return object;
                var message = new $root.google.protobuf.Struct();
                if (object.fields) {
                    if (typeof object.fields !== "object")
                        throw TypeError(".google.protobuf.Struct.fields: object expected");
                    message.fields = {};
                    for (var keys = Object.keys(object.fields), i = 0; i < keys.length; ++i) {
                        if (typeof object.fields[keys[i]] !== "object")
                            throw TypeError(".google.protobuf.Struct.fields: object expected");
                        message.fields[keys[i]] = $root.google.protobuf.Value.fromObject(object.fields[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Struct message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.Struct} message Struct
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Struct.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.fields = {};
                var keys2;
                if (message.fields && (keys2 = Object.keys(message.fields)).length) {
                    object.fields = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.fields[keys2[j]] = $root.google.protobuf.Value.toObject(message.fields[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this Struct to JSON.
             * @function toJSON
             * @memberof google.protobuf.Struct
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Struct.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Struct;
        })();

        protobuf.Value = (function() {

            /**
             * Properties of a Value.
             * @memberof google.protobuf
             * @interface IValue
             * @property {google.protobuf.NullValue|null} [nullValue] Value nullValue
             * @property {number|null} [numberValue] Value numberValue
             * @property {string|null} [stringValue] Value stringValue
             * @property {boolean|null} [boolValue] Value boolValue
             * @property {google.protobuf.IStruct|null} [structValue] Value structValue
             * @property {google.protobuf.IListValue|null} [listValue] Value listValue
             */

            /**
             * Constructs a new Value.
             * @memberof google.protobuf
             * @classdesc Represents a Value.
             * @implements IValue
             * @constructor
             * @param {google.protobuf.IValue=} [properties] Properties to set
             */
            function Value(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Value nullValue.
             * @member {google.protobuf.NullValue|null|undefined} nullValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.nullValue = null;

            /**
             * Value numberValue.
             * @member {number|null|undefined} numberValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.numberValue = null;

            /**
             * Value stringValue.
             * @member {string|null|undefined} stringValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.stringValue = null;

            /**
             * Value boolValue.
             * @member {boolean|null|undefined} boolValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.boolValue = null;

            /**
             * Value structValue.
             * @member {google.protobuf.IStruct|null|undefined} structValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.structValue = null;

            /**
             * Value listValue.
             * @member {google.protobuf.IListValue|null|undefined} listValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.listValue = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * Value kind.
             * @member {"nullValue"|"numberValue"|"stringValue"|"boolValue"|"structValue"|"listValue"|undefined} kind
             * @memberof google.protobuf.Value
             * @instance
             */
            Object.defineProperty(Value.prototype, "kind", {
                get: $util.oneOfGetter($oneOfFields = ["nullValue", "numberValue", "stringValue", "boolValue", "structValue", "listValue"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.IValue=} [properties] Properties to set
             * @returns {google.protobuf.Value} Value instance
             */
            Value.create = function create(properties) {
                return new Value(properties);
            };

            /**
             * Encodes the specified Value message. Does not implicitly {@link google.protobuf.Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.IValue} message Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.nullValue != null && Object.hasOwnProperty.call(message, "nullValue"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.nullValue);
                if (message.numberValue != null && Object.hasOwnProperty.call(message, "numberValue"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.numberValue);
                if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.stringValue);
                if (message.boolValue != null && Object.hasOwnProperty.call(message, "boolValue"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.boolValue);
                if (message.structValue != null && Object.hasOwnProperty.call(message, "structValue"))
                    $root.google.protobuf.Struct.encode(message.structValue, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.listValue != null && Object.hasOwnProperty.call(message, "listValue"))
                    $root.google.protobuf.ListValue.encode(message.listValue, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Value message, length delimited. Does not implicitly {@link google.protobuf.Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.IValue} message Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Value} Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Value();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.nullValue = reader.int32();
                        break;
                    case 2:
                        message.numberValue = reader.double();
                        break;
                    case 3:
                        message.stringValue = reader.string();
                        break;
                    case 4:
                        message.boolValue = reader.bool();
                        break;
                    case 5:
                        message.structValue = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.listValue = $root.google.protobuf.ListValue.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Value} Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Value message.
             * @function verify
             * @memberof google.protobuf.Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
                    properties.kind = 1;
                    switch (message.nullValue) {
                    default:
                        return "nullValue: enum value expected";
                    case 0:
                        break;
                    }
                }
                if (message.numberValue != null && message.hasOwnProperty("numberValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (typeof message.numberValue !== "number")
                        return "numberValue: number expected";
                }
                if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (!$util.isString(message.stringValue))
                        return "stringValue: string expected";
                }
                if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (typeof message.boolValue !== "boolean")
                        return "boolValue: boolean expected";
                }
                if (message.structValue != null && message.hasOwnProperty("structValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    {
                        var error = $root.google.protobuf.Struct.verify(message.structValue);
                        if (error)
                            return "structValue." + error;
                    }
                }
                if (message.listValue != null && message.hasOwnProperty("listValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    {
                        var error = $root.google.protobuf.ListValue.verify(message.listValue);
                        if (error)
                            return "listValue." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Value} Value
             */
            Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Value)
                    return object;
                var message = new $root.google.protobuf.Value();
                switch (object.nullValue) {
                case "NULL_VALUE":
                case 0:
                    message.nullValue = 0;
                    break;
                }
                if (object.numberValue != null)
                    message.numberValue = Number(object.numberValue);
                if (object.stringValue != null)
                    message.stringValue = String(object.stringValue);
                if (object.boolValue != null)
                    message.boolValue = Boolean(object.boolValue);
                if (object.structValue != null) {
                    if (typeof object.structValue !== "object")
                        throw TypeError(".google.protobuf.Value.structValue: object expected");
                    message.structValue = $root.google.protobuf.Struct.fromObject(object.structValue);
                }
                if (object.listValue != null) {
                    if (typeof object.listValue !== "object")
                        throw TypeError(".google.protobuf.Value.listValue: object expected");
                    message.listValue = $root.google.protobuf.ListValue.fromObject(object.listValue);
                }
                return message;
            };

            /**
             * Creates a plain object from a Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.Value} message Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
                    object.nullValue = options.enums === String ? $root.google.protobuf.NullValue[message.nullValue] : message.nullValue;
                    if (options.oneofs)
                        object.kind = "nullValue";
                }
                if (message.numberValue != null && message.hasOwnProperty("numberValue")) {
                    object.numberValue = options.json && !isFinite(message.numberValue) ? String(message.numberValue) : message.numberValue;
                    if (options.oneofs)
                        object.kind = "numberValue";
                }
                if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                    object.stringValue = message.stringValue;
                    if (options.oneofs)
                        object.kind = "stringValue";
                }
                if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
                    object.boolValue = message.boolValue;
                    if (options.oneofs)
                        object.kind = "boolValue";
                }
                if (message.structValue != null && message.hasOwnProperty("structValue")) {
                    object.structValue = $root.google.protobuf.Struct.toObject(message.structValue, options);
                    if (options.oneofs)
                        object.kind = "structValue";
                }
                if (message.listValue != null && message.hasOwnProperty("listValue")) {
                    object.listValue = $root.google.protobuf.ListValue.toObject(message.listValue, options);
                    if (options.oneofs)
                        object.kind = "listValue";
                }
                return object;
            };

            /**
             * Converts this Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Value;
        })();

        /**
         * NullValue enum.
         * @name google.protobuf.NullValue
         * @enum {number}
         * @property {number} NULL_VALUE=0 NULL_VALUE value
         */
        protobuf.NullValue = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "NULL_VALUE"] = 0;
            return values;
        })();

        protobuf.ListValue = (function() {

            /**
             * Properties of a ListValue.
             * @memberof google.protobuf
             * @interface IListValue
             * @property {Array.<google.protobuf.IValue>|null} [values] ListValue values
             */

            /**
             * Constructs a new ListValue.
             * @memberof google.protobuf
             * @classdesc Represents a ListValue.
             * @implements IListValue
             * @constructor
             * @param {google.protobuf.IListValue=} [properties] Properties to set
             */
            function ListValue(properties) {
                this.values = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListValue values.
             * @member {Array.<google.protobuf.IValue>} values
             * @memberof google.protobuf.ListValue
             * @instance
             */
            ListValue.prototype.values = $util.emptyArray;

            /**
             * Creates a new ListValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.IListValue=} [properties] Properties to set
             * @returns {google.protobuf.ListValue} ListValue instance
             */
            ListValue.create = function create(properties) {
                return new ListValue(properties);
            };

            /**
             * Encodes the specified ListValue message. Does not implicitly {@link google.protobuf.ListValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.IListValue} message ListValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.values != null && message.values.length)
                    for (var i = 0; i < message.values.length; ++i)
                        $root.google.protobuf.Value.encode(message.values[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ListValue message, length delimited. Does not implicitly {@link google.protobuf.ListValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.IListValue} message ListValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ListValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.ListValue} ListValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ListValue();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.values && message.values.length))
                            message.values = [];
                        message.values.push($root.google.protobuf.Value.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.ListValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.ListValue} ListValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListValue message.
             * @function verify
             * @memberof google.protobuf.ListValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.values != null && message.hasOwnProperty("values")) {
                    if (!Array.isArray(message.values))
                        return "values: array expected";
                    for (var i = 0; i < message.values.length; ++i) {
                        var error = $root.google.protobuf.Value.verify(message.values[i]);
                        if (error)
                            return "values." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ListValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.ListValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.ListValue} ListValue
             */
            ListValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ListValue)
                    return object;
                var message = new $root.google.protobuf.ListValue();
                if (object.values) {
                    if (!Array.isArray(object.values))
                        throw TypeError(".google.protobuf.ListValue.values: array expected");
                    message.values = [];
                    for (var i = 0; i < object.values.length; ++i) {
                        if (typeof object.values[i] !== "object")
                            throw TypeError(".google.protobuf.ListValue.values: object expected");
                        message.values[i] = $root.google.protobuf.Value.fromObject(object.values[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ListValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.ListValue} message ListValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.values = [];
                if (message.values && message.values.length) {
                    object.values = [];
                    for (var j = 0; j < message.values.length; ++j)
                        object.values[j] = $root.google.protobuf.Value.toObject(message.values[j], options);
                }
                return object;
            };

            /**
             * Converts this ListValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.ListValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ListValue;
        })();

        protobuf.Empty = (function() {

            /**
             * Properties of an Empty.
             * @memberof google.protobuf
             * @interface IEmpty
             */

            /**
             * Constructs a new Empty.
             * @memberof google.protobuf
             * @classdesc Represents an Empty.
             * @implements IEmpty
             * @constructor
             * @param {google.protobuf.IEmpty=} [properties] Properties to set
             */
            function Empty(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Empty instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty=} [properties] Properties to set
             * @returns {google.protobuf.Empty} Empty instance
             */
            Empty.create = function create(properties) {
                return new Empty(properties);
            };

            /**
             * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Empty.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Empty message, length delimited. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Empty.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Empty message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Empty
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Empty} Empty
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Empty.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Empty();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Empty message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Empty
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Empty} Empty
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Empty.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Empty message.
             * @function verify
             * @memberof google.protobuf.Empty
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Empty.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an Empty message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Empty
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Empty} Empty
             */
            Empty.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Empty)
                    return object;
                return new $root.google.protobuf.Empty();
            };

            /**
             * Creates a plain object from an Empty message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.Empty} message Empty
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Empty.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Empty to JSON.
             * @function toJSON
             * @memberof google.protobuf.Empty
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Empty.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Empty;
        })();

        protobuf.Duration = (function() {

            /**
             * Properties of a Duration.
             * @memberof google.protobuf
             * @interface IDuration
             * @property {number|Long|null} [seconds] Duration seconds
             * @property {number|null} [nanos] Duration nanos
             */

            /**
             * Constructs a new Duration.
             * @memberof google.protobuf
             * @classdesc Represents a Duration.
             * @implements IDuration
             * @constructor
             * @param {google.protobuf.IDuration=} [properties] Properties to set
             */
            function Duration(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Duration seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Duration
             * @instance
             */
            Duration.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Duration nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Duration
             * @instance
             */
            Duration.prototype.nanos = 0;

            /**
             * Creates a new Duration instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration=} [properties] Properties to set
             * @returns {google.protobuf.Duration} Duration instance
             */
            Duration.create = function create(properties) {
                return new Duration(properties);
            };

            /**
             * Encodes the specified Duration message. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration} message Duration message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Duration.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Duration message, length delimited. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration} message Duration message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Duration.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Duration message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Duration
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Duration} Duration
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Duration.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Duration();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.seconds = reader.int64();
                        break;
                    case 2:
                        message.nanos = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Duration message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Duration
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Duration} Duration
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Duration.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Duration message.
             * @function verify
             * @memberof google.protobuf.Duration
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Duration.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Duration message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Duration
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Duration} Duration
             */
            Duration.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Duration)
                    return object;
                var message = new $root.google.protobuf.Duration();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Duration message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.Duration} message Duration
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Duration.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Duration to JSON.
             * @function toJSON
             * @memberof google.protobuf.Duration
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Duration.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Duration;
        })();

        return protobuf;
    })();

    return google;
})();

module.exports = $root;
